export default {
  ACCOUNT_PAGE_ADD_PHOTO: "Add Photo",
  ACCOUNT_PAGE_BADGES_BACK_TO_PROFILE: "Back to profile",
  ACCOUNT_PAGE_ACHIEVED_ON: "(Achieved on {date})",
  ACCOUNT_PAGE_BADGES_DESCRIPTION:
    "Our badges are a fun way to inspire each other to keep making progress. Click a badge to see more details.",
  ACCOUNT_PAGE_EVENTS_DRAFTS: "Event Drafts",
  ACCOUNT_PAGE_EVENTS_HOST_BY_ME: "Hosted by me",
  ACCOUNT_PAGE_EVENTS_IM_HOSTING: "Events I’m Hosting",
  ACCOUNT_PAGE_EVENTS_I_HOSTED: "Events I've Hosted",
  ACCOUNT_PAGE_EVENTS_HOSTED: "Events Hosted",
  ACCOUNT_PAGE_HAPPY_WITH_MY_SPEAKING_PARTNERS: "Happy with my speaking partners",
  ACCOUNT_PAGE_MY_OCCUPATION: "My Occupation",
  ACCOUNT_PAGE_MY_PERSONAL_INTERESTS: "My personal interests",
  ACCOUNT_PAGE_MY_PERSONAL_INTERESTS_MAX: "My personal interests (max 8)",
  ACCOUNT_PAGE_SKILLS_I_WANT_TO_IMPROVE: "The skills I want to improve",
  ACCOUNT_PAGE_STORY_ERROR: "Please complete your story",
  ACCOUNT_PAGE_REQUIRED_FIELD_ERROR: "This field is required",
  ACCOUNT_PAGE_MIN_INTERESTS_ERROR: "Please choose at least one interest",
  ACCOUNT_PAGE_MAX_INTERESTS_ERROR: "Please choose max 8 interests",
  ACCOUNT_PAGE_MIN_SKILLS_ERROR: "Please choose at least one English skill",
  ACCOUNT_PAGE_MAX_SKILLS_ERROR: "Please choose max 5 English skills",
  ACCOUNT_PAGE_MIN_WORDS_ERROR: "Your story must have at least 30 words.",
  ACCOUNT_PAGE_ADD_PHOTO_ERROR: "Please add your photo",
  ACCOUNT_PAGE_INVALID_DATE_ERROR: "Please provide valid date",
  ACCOUNT_PAGE_SKILLS_I_WANT_TO_IMPROVE_MAX: "The skills I want to improve (max 5)",
  ACCOUNT_PAGE_MY_AVAILABILITY: "My Availability",
  ACCOUNT_PAGE_MY_PHOTOS: "My Photos ({photos})",
  ACCOUNT_PAGE_ARE_YOU_SURE: "Are you sure you want to delete this photo?",
  ACCOUNT_PAGE_MY_PROFILE: "My Profile",
  ACCOUNT_PAGE_MY_STORY: "My Story",
  ACCOUNT_PAGE_MY_STORY_SUBTITLE:
    "Tell us a little about yourself! Let ladies know why you're here, what you're passionate about or what makes you interesting!",
  ACCOUNT_PAGE_MY_ACHIEVEMENTS: "My Achievements",
  ACCOUNT_PAGE_VIEW_REPORT: "View Report",
  ACCOUNT_PAGE_UPDATE_SCORE: "Update Score",
  ACCOUNT_PAGE_TAKE_ASSESSMENT: "Test your skills to find out your Hey Lady! Speaking Level",
  ACCOUNT_PAGE_ENGLISH_SPEAKING_LEVEL: "English Speaking Level",
  ACCOUNT_PAGE_YOUR_SPEAKING_LEVEL: "Your Speaking Level",
  ACCOUNT_PAGE_YOUR_ENGLISH_LEVEL_DESCRIPTION:
    "At Hey Lady! we use our own way to determine your speaking level. To" +
    " learn more, visit <link>Help Center</link>",
  ACCOUNT_PAGE_REPORT_DATE: "Date: {date}",
  ACCOUNT_PAGE_UPDATE_ENGLISH_LEVEL: "Update",
  ACCOUNT_PAGE_TOTAL_SCORE: "Total Score",
  ACCOUNT_PAGE_ALL_REPORTS: "All Reports",
  ACCOUNT_PAGE_OPEN_TO_SPEAKING_PARTNERS: "Open to speaking partners",
  ACCOUNT_PAGE_PASSED_EVENT: "Past Event",
  ACCOUNT_PAGE_PERSONAL_ACCOUNT: "My Account",
  ACCOUNT_PAGE_PERSONAL_DETAILS: "Personal Details",
  ACCOUNT_PAGE_TIME_ZONE: "Time zone",
  ACCOUNT_PAGE_SHOW_MY_BIRTHDAY: "Show my birthday (day & month only)",
  ACCOUNT_PAGE_SHOW_MY_BIRTHDAY_YEAR: "Show my birthday and year of birth",
  ACCOUNT_PAGE_NOT_SPECIFIED: "Occupation not specified",
  ACCOUNT_VERIFIED_MEMBER: "Verified Member",
  ACCOUNT_PAGE_LOOKING_FOR_SPEAKING_PARTNERS:
    "Are you  looking for new speaking partners right now?",
  ACCOUNT_PAGE_SPEAKING_PARTNERS_DESCRIPTION:
    "If you answer ‘yes’ we will make sure your profile is seen by other members who are also looking for speaking partners.",
  ACCOUNT_PAGE_SEE_WHAT_IS_MISSING: "See what’s missing",
  ACCOUNT_PAGE_MISSING_DETAILS: "Missing Details",
  ACCOUNT_PAGE_COMPLETED_NAME: "First and last name",
  ACCOUNT_PAGE_COMPLETED_ENGLISH_LEVEL: "English Level",
  ACCOUNT_PAGE_COMPLETED_LOCATION: "Location",
  ACCOUNT_PAGE_COMPLETED_INTERESTS: "Personal Interests",
  ACCOUNT_PAGE_COMPLETED_ENGLISH_SKILLS: "English Interests",
  ACCOUNT_PAGE_COMPLETED_OCCUPATION: "Occupation",
  ACCOUNT_PAGE_COMPLETED_STORY: "Your story",
  ACCOUNT_PAGE_COMPLETED_BIRTHDATE: "Date of birth",
  ACCOUNT_PAGE_COMPLETED_AVATAR: "Profile photo",
  ACCOUNT_PAGE_MISSING_INTERESTS: "Personal Interests (select up to 8)",
  ACCOUNT_PAGE_MISSING_ENGLISH_SKILLS: "English Interests (select up to 5)",
  ACCOUNT_PAGE_MISSING_OCCUPATION: "Occupation (please add)",
  ACCOUNT_PAGE_MISSING_STORY: "Your story (min 30 words)",
  ACCOUNT_PAGE_MISSING_BIRTHDATE: "Date of birth (please add)",
  ACCOUNT_PAGE_MISSING_AVATAR: "Profile photo (please add)",
  ACCOUNT_PAGE_MONTHLY_STATISTICS_READY: "{name}, your monthly recap is ready and waiting for you!",
  ACCOUNT_PAGE_MONTHLY_CHECK_PROGRESS:
    "Let’s check your progress from last month. You can review it now or access the report from your profile.",
  ACCOUNT_PAGE_SEE_STATISTICS: "See My Report",
  ACCOUNT_PAGE_CHECK_PROFILE: "Check My Profile",
  ACCOUNT_PAGE_BACK_TO_PROFILE: "Back to Profile",
  ACCOUNT_PAGE_RECAP: "{name}, here is your {month} recap!",
  ACCOUNT_PAGE_FINISH: "Finish & Close",
  ACCOUNT_PAGE_ATTENDED_EVENTS: "Events you attended",
  ACCOUNT_PAGE_ATTENDED_EVENTS_DESCRIPTION:
    "Each event is an opportunity to improve your English and connect with people. Keep it up!",
  ACCOUNT_PAGE_ATTENDED_EVENTS_MORE_DETAILS: "More details:",
  ACCOUNT_PAGE_ATTENDED_EVENTS_ONE_TO_ONES: "1:1 Events ",
  ACCOUNT_PAGE_ATTENDED_EVENTS_GROUP_EVENTS: "Group Events",
  ACCOUNT_PAGE_ATTENDED_EVENTS_IN_PERSON_EVENTS: "In Person Events",
  ACCOUNT_PAGE_ATTENDED_EVENTS_WEBINARS: "Webinars",
  ACCOUNT_PAGE_ATTENDED_EVENTS_OTHER: "Other",
  ACCOUNT_PAGE_ATTENDED_EVENTS_TOTAL_EVENTS: "Total Events",
  ACCOUNT_PAGE_ATTENDED_EVENTS_PREVIOUS_MONTH_MORE:
    "You attended {number} more events than the previous month",
  ACCOUNT_PAGE_ATTENDED_EVENTS_PREVIOUS_MONTH_LESS:
    "You attended {number} less events than the previous month",
  ACCOUNT_PAGE_ATTENDED_EVENTS_PREVIOUS_MONTH_SAME:
    "You attended the same number of events as previous month",
  ACCOUNT_PAGE_SPONTANEOUS_CONVERSATIONS: "Spontaneous Conversations",
  ACCOUNT_PAGE_SPONTANEOUS_CONVERSATIONS_DESCRIPTION:
    "These are the extra conversations you had at Live Tables and via the Chat!",
  ACCOUNT_PAGE_SPONTANEOUS_CONVERSATIONS_MORE:
    "You had {number} more spontaneous conversations than the previous month",
  ACCOUNT_PAGE_SPONTANEOUS_CONVERSATIONS_LESS:
    "You had {number} less spontaneous conversations than the previous month",
  ACCOUNT_PAGE_SPONTANEOUS_CONVERSATIONS_SAME:
    "You had the same number of spontaneous conversations as previous month",
  ACCOUNT_PAGE_ATTENDANCE_RECORD: "Attendance Record",
  ACCOUNT_PAGE_NO_OF_EVENTS:
    "How reliable are you? When you say you will attend an event, do you keep your promise?",
  ACCOUNT_PAGE_YOU_ATTENDED:
    "You attended <bold>{number}</bold> of the <bold>{total}</bold> events you said you would attend.",
  ACCOUNT_PAGE_YOU_ATTENDED_ONLY:
    "You only attended <bold>{number}</bold> of the <bold>{total}</bold> events you said you would attend.",
  ACCOUNT_PAGE_YOU_ATTENDED_JUST:
    "You attended just <bold>{number}</bold> of the <bold>{total}</bold> events you said you would attend.",
  ACCOUNT_PAGE_EXCELLENT: "Excellent!",
  ACCOUNT_PAGE_GREAT: "Great!",
  ACCOUNT_PAGE_OK: "Uh oh!",
  ACCOUNT_PAGE_NOT_GREAT: "Not great!",
  ACCOUNT_PAGE_NOT_BAD: "Oh dear!",
  ACCOUNT_PAGE_EVENTS_SUMMARY: "Events Summary",
  ACCOUNT_PAGE_PARTICIPATION_TIME: "Total Participation Time",
  ACCOUNT_PAGE_ATTENDANCE_TIME: "Attendance Time",
  ACCOUNT_PAGE_HOSTING_TIME: "Hosting Time",
  ACCOUNT_LADIES_ATTENDED: "ladies attended your events",
  ACCOUNT_PAGE_NO_EVENTS: "You haven't attended or hosted any events yet.",
  ACCOUNT_PAGE_NO_ATTENDED_EVENTS:
    "You haven't attended any events yet. Check out the upcoming events!",
  ACCOUNT_PAGE_NO_HOSTED_EVENTS: "You haven't hosted any events yet.",
  ACCOUNT_PAGE_NO_ARTICLES:
    "You haven’t written any articles yet. Explore what ladies are writing about.",
  ACCOUNT_PAGE_GO_TO_MEMBERZINE: "Go to Memberzine",
  ACCOUNT_PAGE_RECENT_ARTICLES: "Your most recent articles",
  ACCOUNT_PAGE_PRACTICE:
    "Practice makes perfect! This is how much time you spent in video calls improving your English",
  ACCOUNT_PAGE_MORE_TIME: "That is {number} hours more than the previous month",
  ACCOUNT_PAGE_LESS_TIME: "That is {number} hours less than the previous month",
  ACCOUNT_PAGE_SAME_TIME: "You have spent the same number of hours as last month",
  ACCOUNT_PAGE_HOURS: "Hours",
  ACCOUNT_PAGE_MINUTES: "Minutes",
  ACCOUNT_PAGE_NETWORK: "Connecting to the world!",
  ACCOUNT_PAGE_MAP: "Ladies who attended the same events as you, joined from here!",
  ACCOUNT_PAGE_RECOGNISE_THIS: "Recognise these friendly faces?",
  ACCOUNT_PAGE_MOST_COMMON: "These ladies attended the same events as you most frequently!",
  ACCOUNT_PAGE_ARTICLES_WRITTEN: "Articles Written",
  ACCOUNT_PAGE_NO_OF_ARTICLES: "Here is the number of articles you wrote for the community.",
  ACCOUNT_PAGE_EVENTS_STREAK: "Events Streak",
  ACCOUNT_PAGE_EVENTS_YOU_JOINED: "How often did you participate?",
  ACCOUNT_PAGE_HOSTED_EVENTS: "Hosted Events",
  ACCOUNT_PAGE_EVENTS_ATTENDED: "Attended Events",
  ACCOUNT_PAGE_ALL_EVENTS: "All Events",
  ACCOUNT_PAGE_THANKS: "Thanks for hosting!",
  ACCOUNT_PAGE_SPARKS: "Sparks created",
  ACCOUNT_PAGE_SPARKS_CELEBRATING:
    "Celebrating the meaningful conversations you’ve had in our community",
  ACCOUNT_PAGE_FELT_A_SPARK: "Events you attended where <bold>YOU felt</bold> a spark!",
  ACCOUNT_PAGE_NO_OF_SPARKS_ON_ATTENDED:
    "Sparks created <bold>at ALL the events</bold> you attended",
  ACCOUNT_PAGE_COMMUNITY_SPARKS: "Sparks created by the <bold>whole community</bold> last month!",
  ACCOUNT_PAGE_THANK_YOU: "Thank you!",
  ACCOUNT_PAGE_SPARKS_CREATED_SINCE: "Sparks created since Hey Lady! began",
  ACCOUNT_PAGE_MISSION:
    "Thank you for joining our mission to spark one billion meaningful conversations between" +
    " women of different cultures.",
  ACCOUNT_PAGE_SUMMARY:
    "This is a summary of the events you hosted and the number of participants who attended",
  ACCOUNT_PAGE_MORE_EVENTS: "You hosted {number} events more compared to the previous month.",
  ACCOUNT_PAGE_LESS_EVENTS: "You hosted {number} events less compared to the previous month.",
  ACCOUNT_PAGE_SAME_EVENTS: "You hosted the same number of events as the previous month.",
  ACCOUNT_PAGE_LADIES: "Ladies Attended",
  ACCOUNT_PAGE_SPARKS_CREATED: "Sparks created by the events <bold>you hosted!</bold>",
  ACCOUNT_PAGE_SEE_RECAP: "See Monthly Recap",
  ACCOUNT_PAGE_MONTHLY_REVIEW: "Your monthly review is ready!",
  ACCOUNT_PAGE_MONTHLY_RECAP:
    "Let’s review the amazing things you did over the past month in the Hey Lady! Community!",
  ACCOUNT_PAGE_SEE_DETAILS: "See Details",
  ACCOUNT_PAGE_TRACK_PROGRESS: "Want to track your progress?",
  ACCOUNT_PAGE_START_ATTENDING:
    "Did you know the average Hey Lady! member attends 3 events every week? Start attending events and we’ll help you to measure your progress!",
  AUTH_ACCOUNT_ENCOUNTERED_ISSUE:
    "We encountered an issue while activating your account. If this problem persists, please <link>contact us</link>.",
  AUTH_ACCOUNT_NOT_ACTIVATED: "Your account could not be activated",
  AUTH_ACCOUNT_NOW_ACTIVE: "Your account is now active!",
  AUTH_ACCOUNT_WAS_ACTIVATED:
    "Your account was activated successfully. You can now log in with the email and password you provided when you signed up.",
  AUTH_ACCOUNT_ACTIVATED: "Your account was activated successfully.",
  AUTH_ALREADY_HAVE_AN_ACCOUNT: "Already have an account? <url>Log In</url>",
  AUTH_BACK_TO_LOGIN: "Back to Log In",
  AUTH_BROWSE_MEMBER_PROFILES: "Browse member profiles",
  AUTH_CREATE_ACCOUNT: "Create Account",
  AUTH_CREATE_NEW_ACCOUNT_PASSWORD: "Please, create a new password for your account",
  AUTH_CREATE_NEW_PASSWORD_HINT: "Must be at least 8 characters long",
  AUTH_CREATE_PASSWORD: "Create password",
  AUTH_CREATE_CONFIRM_PASSWORD: "Confirm password",
  AUTH_CREATE_PASSWORDS_MUST_MATCH: "Passwords must match",
  AUTH_CREATE_PASSWORD_CHANGED: "Your password has been changed. You can log in now.",
  AUTH_CREATE_PASSWORD_FAILED: "Failed to change your password",
  AUTH_CREATE_PASSWORD_SAVE_PASSWORD: "Save new password",
  AUTH_CREATE_PASSWORD_LOG_IN: "Log in now",
  AUTH_DONT_HAVE_AN_ACCOUNT: "Not a member yet? <url>Sign Up</url>",
  AUTH_EXPLORE_YOUR_ONLINE_EVENTS: "Explore our online events",
  AUTH_FORGOT_PASSWORD: "Forgot password?",
  AUTH_FORGOT_PASSWORD_EMAIL_PLACEHOLDER: "pocahontas@example.com",
  AUTH_FORGOT_PASSWORD_ENTER_EMAIL:
    "Enter your email and we’ll send you instructions on how to restore your password",
  AUTH_FORGOT_PASSWORD_INSTRUCTIONS_SENT: "Instructions have been sent to your email!",
  AUTH_FORGOT_PASSWORD_INSTRUCTIONS_SENT_TO_EMAIL:
    "Instructions sent to {email}. Please check your email now to reset your password.",
  AUTH_FORGOT_PASSWORD_SEND_INSTRUCTIONS: "Send instructions",
  AUTH_I_WOULD_LIKE_TO_BE_UPDATED: "I would like to be updated about the launch of {title}",
  AUTH_LOGIN_TO_YOUR_ACCOUNT: "Log in to your account using the following methods:",
  AUTH_LOG_IN: "Log In",
  AUTH_LOG_IN_FORGOT_PASSWORD: "<url>Forgot password?</url>",
  AUTH_LOG_IN_TO_HEY_LADY: "Log in to Hey Lady!",
  AUTH_LOG_IN_WITH_GOOGLE: "Log in with Google",
  AUTH_NOT_ALL_FEATURES_FROM_OUR_PAID_MEMBER:
    "Not all features of our platform are available just yet.",
  AUTH_NO_CREDIT_CARD: "No credit card required",
  AUTH_PERSONALISE_YOUR_PROFILE: "Personalise your profile",
  AUTH_PREVIEW_HEY_LADY: "Preview {title}",
  AUTH_SETUP_PROFILE: "Set up your profile",
  AUTH_SIGN_UP: "Sign up to take a look inside.",
  AUTH_TWO_FREE_CONVERSATION_LESSONS: "Two free conversation lessons",
  AUTH_WELCOME: "Welcome to Hey Lady!",
  AUTH_WHAT_DO_I_GET: "What's inside?",
  AUTH_FAIL_UNEXPECTED_ERROR:
    "Unexpected error while trying to communicate with google. Please try again! If the issue persist please contact support.",
  AUTH_FAIL_ALREADY_EXISTS:
    "You already have an account associated with your email. Please log in!",
  AUTH_FAIL_UNAUTHORIZED: "We couldn't find a Hey Lady! account that matched your selection",
  AUTH_FAIL_UNAUTHORIZED_DESCRIPTION: `
      You have 2 options: {br}
      1. Please select a different Google account {br}
      2. If you are not yet a member of Hey Lady! Click <url>this link</url> to learn more and join
  `,
  BADGE_TITLE_FIRST_CONVERSATION: "First Conversation",
  BADGE_DESCRIPTION_FIRST_CONVERSATION:
    "Joining your first conversation in Hey Lady! is definitely something to be celebrated!",
  BADGE_TITLE_10_EVENTS: "10 Events",
  BADGE_DESCRIPTION_10_EVENTS:
    "Attend 10 scheduled events and you'll be officially on your way to joining the 100 Club!",
  BADGE_TITLE_50_EVENTS: "50 Events",
  BADGE_DESCRIPTION_50_EVENTS:
    "Attend 50 scheduled events and celebrate the half-way mark on your way to joining the 100 Club!",
  BADGE_TITLE_100_EVENTS: "100 Club",
  BADGE_DESCRIPTION_100_EVENTS:
    "Attend 100 scheduled events to join the “100 Club”. You are on your way to becoming a Conversation Queen!",
  BADGE_TITLE_500_EVENTS: "500 Club",
  BADGE_DESCRIPTION_500_EVENTS:
    "Attend 500 scheduled events and you’ll earn your “500 Club” badge. The recipients of this badge are officially past halfway on the journey to becoming a Conversation Queen!",
  BADGE_TITLE_AUTHOR: "Author",
  BADGE_DESCRIPTION_AUTHOR:
    "Members who write and publish an article of 300 words or more to our Memberzine can earn" +
    " themselves the “Author” badge.",
  BADGE_TITLE_BIG_SISTER: "Big Sister",
  BADGE_DESCRIPTION_BIG_SISTER:
    "Our ‘Big Sisters’ play an incredibly important role in our community by volunteering" +
    " their time to welcome new members, host community events and support members to get settled, meet friends and host events. Big Sisters are selected via application and receive training to support their special role. Contact our team to find out more.",
  BADGE_TITLE_PERFECT_PROFILE: "Perfect Profile",
  BADGE_DESCRIPTION_PERFECT_PROFILE:
    "A complete profile page helps us recommend events and members to you! Keep" +
    " yours at “100% complete” to earn and keep your “Perfect Profile” badge.",
  BADGE_TITLE_CONVERSATION_QUEEN: "Conversation Queen",
  BADGE_DESCRIPTION_CONVERSATION_QUEEN:
    "Attend 1000 scheduled events or more and you will be rightfully crowned as a Hey Lady! “Conversation Queen”. This is a prestigious badge acknowledging your persistence and commitment to becoming a brilliant English conversationalist!",
  BADGE_TITLE_EVENT_HOST: "Host",
  BADGE_DESCRIPTION_EVENT_HOST:
    "Members who create and host an online event for our community earn the ‘Host’ badge. To earn this badge you need to successfully create and host an event!",
  BADGE_TITLE_FOUNDING_MEMBER: "Founding Member",
  BADGE_DESCRIPTION_FOUNDING_MEMBER:
    "Our Founding Members are the pioneers of Hey Lady! They include members from The Ladies’ Project together with new members who signed up to join Hey Lady! within our first 3 months.",
  BADGE_TITLE_HOSTED_10_EVENTS: "Hosted 10 Events",
  BADGE_DESCRIPTION_HOSTED_10_EVENTS:
    "Successfully create and host 10 events to earn this Silver Host badge! Recipients of this badge are on the way to becoming a Super Host!",
  BADGE_TITLE_HOSTED_50_EVENTS: "Hosted 50 Events",
  BADGE_DESCRIPTION_HOSTED_50_EVENTS:
    "Successfully create and host 50 events to earn this shiny Gold Host badge. The recipients of this badge are officially past half way on the journey to becoming a Super Host.",
  BADGE_TITLE_LEGENDARY_LADY: "Legendary Lady",
  BADGE_DESCRIPTION_LEGENDARY_LADY:
    "Hey Lady! is full of incredible women - which is why it is so spectacular to" +
    " become legendary here. A Legendary Lady is a member who demonstrates one (or some or all) of our core values through her actions in our community. " +
    "<link>Our Community Values</link> are: Respect, Generosity, Empowerment, Courage and Collaboration.",
  BADGE_TITLE_LIFETIME_MEMBER: "Lifetime Member",
  BADGE_DESCRIPTION_LIFETIME_MEMBER:
    "Lifetime Membership is awarded to every Hey Lady! member who has been with the community for 4 years or more.",
  BADGE_TITLE_LOCAL_HOST: "Local Host",
  BADGE_DESCRIPTION_LOCAL_HOST:
    "Members who host an in-person event earn the “Local Host” badge. To earn this badge you need to successfully create and host an in-person event in the town or city where you live!",
  BADGE_TITLE_ONE_YEAR_ANNIVERSARY: "One Year Member",
  BADGE_DESCRIPTION_ONE_YEAR_ANNIVERSARY:
    "To celebrate 12 months of active membership in the community, members are awarded the “Green Emerald” badge.",
  BADGE_TITLE_TWO_YEAR_ANNIVERSARY: "Two Year Member",
  BADGE_DESCRIPTION_TWO_YEAR_ANNIVERSARY:
    "To celebrate 2 years of active membership in the community, members are awarded the “Pink Ruby” badge.",
  BADGE_TITLE_THREE_YEAR_ANNIVERSARY: "Three Year Member",
  BADGE_DESCRIPTION_THREE_YEAR_ANNIVERSARY:
    "To celebrate 3 years of active membership in the community, members are awarded the “Blue Diamond” badge.",
  BADGE_TITLE_FOUR_YEAR_ANNIVERSARY: "Four Year Member",
  BADGE_DESCRIPTION_FOUR_YEAR_ANNIVERSARY:
    "To celebrate 4 years of active membership in the community, members are awarded the “Purple Amethyst” badge.",
  BADGE_TITLE_SUPER_HOST: "Super Host",
  BADGE_DESCRIPTION_SUPER_HOST:
    "Members who host 100+ events attain the status of “Super host!” This is an incredible moment to be celebrated!",
  BADGE_TITLE_ULTRA_HOST: "Ultra Host",
  BADGE_DESCRIPTION_ULTRA_HOST:
    "Members who host 500+ events attain the status of “Ultra Host!” This is an astounding accomplishment and the highest host status that can be achieved.",
  BADGE_TITLE_VERIFIED: "Verified",
  BADGE_DESCRIPTION_VERIFIED:
    "Members whose identity has been verified by our team receive the verification badge. Being verified is an important step to ensure our community is safe so that our members can feel comfortable connecting face-to-face via video.",
  BADGE_WAITING_FOR_VERIFICATION: "Waiting for verification",
  BADGE_TITLE_ONBOARDING_QUIZ: "HeyLady! Way",
  BADGE_DESCRIPTION_ONBOARDING_QUIZ:
    "This badge is awarded to any member who correctly answers all 10 questions in our <link>quiz</link> about the “Hey Lady! Way”: how we learn, improve and grow!",
  BADGE_TITLE_BROUGHT_A_FRIEND: "Brought a friend!",
  BADGE_DESCRIPTION_BROUGHT_A_FRIEND:
    "Share the magic of Hey Lady! and support our community by bringing your friends! For every friend who joins, you get a free month!",
  BADGE_TITLE_AMBASSADOR: "Ambassador",
  BADGE_DESCRIPTION_AMBASSADOR:
    "Become a Hey Lady!  Ambassador by successfully inviting five (5) new members to join and support the community as paying members.",
  BADGE_TITLE_PLATINUM_AMBASSADOR: "Platinum Ambassador",
  BADGE_DESCRIPTION_PLATINUM_AMBASSADOR:
    "Become a Platinum Ambassador when you successfully invite 25 new members to join and support the community as paying members.",
  BADGE_TITLE_DIAMOND_AMBASSADOR: "Diamond Ambassador",
  BADGE_DESCRIPTION_DIAMOND_AMBASSADOR:
    "Our Diamond Ambassadors are the exceptional women who have successfully invited 50 new members to join the community.",
  BADGE_TITLE_CERTIFIED_HOST: "Certified Host",
  BADGE_DESCRIPTION_CERTIFIED_HOST:
    "Awarded to members who complete the Hey Lady! Host training and are certified as capable event hosts.{br} Members with this badge are experienced and host events that are well organised and enjoyable. ",
  BADGE_SEE_MY_ACHIEVEMENTS: "See my achievements",
  BADGE_LOCAL_HOST_1_TITLE: "Local Host",
  BADGE_LOCAL_HOST_1_DESCRIPTION:
    "Members who host an in-person event earn the “Local Host” badge. To earn this badge you need to successfully create and host an in-person event in the town or city where you live!",
  BADGE_LOCAL_HOST_3_TITLE: "Bronze Local Host",
  BADGE_LOCAL_HOST_3_DESCRIPTION:
    "Members who host three in-person events earn the Bronze “Local Host” badge. To earn this badge you need to successfully create and host three in-person events in the town or city where you live!",
  BADGE_LOCAL_HOST_10_TITLE: "Blue Local Host",
  BADGE_LOCAL_HOST_10_DESCRIPTION:
    "Members who host ten in-person events earn the Blue “Local Host” badge. To earn this badge you need to successfully create and host ten in-person events in the town or city where you live!",
  BADGE_LOCAL_HOST_25_TITLE: "Green Local Host",
  BADGE_LOCAL_HOST_25_DESCRIPTION:
    "Members who host twenty-five in-person events earn the “Local Host” badge. To earn this" +
    " badge you need to successfully create and host twenty-five in-person events in the town or city where you live!",
  BADGE_NEW_AUTHOR_TITLE: "You’ve just earned your Author badge!",
  BADGE_NEW_AUTHOR:
    "Congratulations on writing your first article. Writing regularly helps you to use language you learn and reflect on your progress. Keep writing!",
  BADGE_NEW_BIG_SISTER_TITLE: "You’ve just earned your Big Sister badge!",
  BADGE_NEW_BIG_SISTER:
    "Congratulations! Thank you for your wonderful contribution and the sparkle you bring to Hey Lady!",
  BADGE_NEW_FIRST_CONVERSATION_TITLE: "You did it, {name}! Congrats on your First Conversation!",
  BADGE_NEW_FIRST_CONVERSATION:
    "You showed up, spoke English and met new people - that takes <em>courage</em>! The first step is always the hardest, but just imagine what’s possible from here.",
  BADGE_NEW_10_EVENTS_TITLE: "You’ve just earned a new badge!",
  BADGE_NEW_10_EVENTS: "Congratulations for attending 10 events!",
  BADGE_NEW_50_EVENTS_TITLE: "You’ve just earned a new badge!",
  BADGE_NEW_50_EVENTS: "Congratulations for attending 50 events!",
  BADGE_NEW_100_EVENTS_TITLE: "You’ve just earned a new badge!",
  BADGE_NEW_100_EVENTS: "Congratulations for attending 100 events!",
  BADGE_NEW_500_EVENTS_TITLE: "You’ve just earned a new badge!",
  BADGE_NEW_500_EVENTS:
    "Whoah! You’ve attended 500 events?! That’s 500 opportunities you created to learn, speak," +
    " listen, laugh & meet new friends.",
  BADGE_NEW_CONVERSATION_QUEEN_TITLE: "You have been crowned a ‘Conversation Queen’!",
  BADGE_NEW_CONVERSATION_QUEEN:
    "This is special, lady! You have *officially* made the English language your own.",
  BADGE_NEW_EVENT_HOST_TITLE: "Congratulations, {name}! You’ve just earned your Host badge!",
  BADGE_NEW_EVENT_HOST:
    "Woohoo! Congratulations for unlocking new English opportunities for yourself. What conversation will you host next?",
  BADGE_NEW_HOSTED_10_EVENTS_TITLE: "Congratulations, {name}! You’ve just earned a new badge!",
  BADGE_NEW_HOSTED_10_EVENTS:
    "Congratulations for hosting 10 events! It’s time to make English your own!",
  BADGE_NEW_HOSTED_50_EVENTS_TITLE: "Congratulations, {name}! You’ve just earned a new badge!",
  BADGE_NEW_HOSTED_50_EVENTS:
    "You’ve hosted 50 events, which means you’ve been learning, but also DOING lots of things in English. 🙌 Keep going!",
  BADGE_NEW_SUPER_HOST_TITLE: "You are a SUPER Host, {name}!",
  BADGE_NEW_SUPER_HOST:
    "Congratulations! You are part of a small but special group of women in Hey Lady! Who contribute to the culture, discussions and ideas",
  BADGE_NEW_ULTRA_HOST_TITLE: "You are an ULTRA Host, {name}!",
  BADGE_NEW_ULTRA_HOST:
    "Congratulations! You are part of a small but special group of women who are core contributors to our community culture.",
  BADGE_NEW_LEGENDARY_LADY_TITLE: "Hey, lady! You are legendary!",
  BADGE_NEW_LEGENDARY_LADY:
    "The women of Hey lady! have awarded you this special badge, for consistently demonstrating our core <link>Community Values</link>. Thank you for being YOU!",
  BADGE_NEW_VERIFIED_TITLE: "Your account is now verified!",
  BADGE_NEW_VERIFIED:
    "You can now see and attend even more events and access all features inside our platform." +
    " Thank you for helping us to make Hey Lady! a safe space for everyone.",
  BADGE_NEW_PERFECT_PROFILE_TITLE: "You’ve just earned the Perfect Profile badge!",
  BADGE_NEW_PERFECT_PROFILE: "Thank you for keeping your profile complete and up to date!",
  BADGE_NEW_ONE_YEAR_ANNIVERSARY_TITLE: "Happy 1-Year Anniversary, {name}!",
  BADGE_NEW_ONE_YEAR_ANNIVERSARY:
    "We are celebrating with you today, because you have just reached 12 months of active membership in Hey Lady! You’ve come so far & we are excited to see what comes next!",
  BADGE_NEW_TWO_YEAR_ANNIVERSARY_TITLE: "Happy 2-Year Anniversary, {name}!",
  BADGE_NEW_TWO_YEAR_ANNIVERSARY:
    "We are celebrating YOU today, because you have been showing up to speak, practise, learn and grow for two years. We can’t wait to see what you achieve in the year ahead!",
  BADGE_NEW_THREE_YEAR_ANNIVERSARY_TITLE: "Happy 3-Year Anniversary, {name}!",
  BADGE_NEW_THREE_YEAR_ANNIVERSARY:
    "We are celebrating with you today, because you have been living your best English life inside Hey Lady! for 3 years. Love you looong time!",
  BADGE_NEW_FOUR_YEAR_ANNIVERSARY_TITLE: "Happy 4-Year Anniversary, {name}!",
  BADGE_NEW_FOUR_YEAR_ANNIVERSARY:
    "Today is a special day - a day to celebrate YOU for reaching this incredible milestone. Four years of friendship, new experiences and community contribution. We appreciate you!",
  BADGE_NEW_ONBOARDING_QUIZ_TITLE: "You just earned the <em>Hey Lady! Way</em> badge! Well done!",
  BADGE_NEW_BROUGHT_A_FRIEND_TITLE: "You brought a friend!",
  BADGE_NEW_AMBASSADOR_TITLE: "Hello Ambassador!",
  BADGE_NEW_PLATINUM_AMBASSADOR_TITLE: "Platinum Ambassador",
  BADGE_NEW_DIAMOND_AMBASSADOR_TITLE: "Diamond Ambassador",
  BADGE_NEW_ONBOARDING_QUIZ:
    "We are thrilled that you took the time to learn what makes our community unique and how we can help you!",
  BADGE_NEW_BROUGHT_A_FRIEND:
    "In recognition of your support in helping to introduce a friend to Hey Lady! you’ve just earned yourself a new badge! {br} You’re just 4 friends away from becoming an Ambassador!",
  BADGE_NEW_AMBASSADOR:
    "Awarded in recognition of successfully introducing 5 friends to Hey Lady! {br} Congratulations! We are pleased to offer you a private 1:1 session with a Hey Lady! Coach. Our Head Coach will contact you personally in the coming days.",
  BADGE_NEW_PLATINUM_AMBASSADOR:
    "Awarded in recognition of successfully introducing 25 friends to Hey Lady! {br} We are truly grateful for the support you have shown to your friends and this community. {br} To celebrate your achievement we are pleased to offer you a complimentary place in any small-group coaching program. Our Head Coach will contact you personally in the coming days.",
  BADGE_NEW_DIAMOND_AMBASSADOR:
    "Awarded in recognition of successfully introducing 50 friends to Hey Lady! {br} Congratulations! This is the big one! {br} Prepare to be showered with love and adoration by the whole community! {br} To show our appreciation, you will receive complimentary return flights to a Hey Lady! meetup! {br} Our Founder Emma will be in touch personally in the coming days to thank you herself!",
  BADGE_NEW_CERTIFIED_HOST_TITLE: "You are a Certified Host!",
  BADGE_NEW_CERTIFIED_HOST:
    "Congratulations on completing your host training! We award you the Certified Host badge in recognition of your commitment to hosting effective and enjoyable online events and meetings.{mb} Share this on your <link>LinkedIn</link> profile to celebrate your certified skills!",
  BADGE_NEW_LOCAL_HOST_1_TITLE: "You just earned your “Local Host” badge, {name}!",
  BADGE_NEW_LOCAL_HOST_1:
    "We LOVE taking online friendships, offline! Thank you for creating this special moment for other members of our community.",
  BADGE_NEW_LOCAL_HOST_3_TITLE: "Congratulations! You’ve just earned a new badge!",
  BADGE_NEW_LOCAL_HOST_3:
    "In recognition of your generosity and initiative by hosting 3 in-person events. An amazing contribution!",
  BADGE_NEW_LOCAL_HOST_10_TITLE: "Congratulations! You’ve just earned a new badge!",
  BADGE_NEW_LOCAL_HOST_10:
    "We recognise your effort for hosting 10 in-person events. Thank you for helping our members to connect in-person!",
  BADGE_NEW_LOCAL_HOST_25_TITLE: "Congratulations! You’ve just earned a new badge!",
  BADGE_NEW_LOCAL_HOST_25:
    "In recognition of your incredible contribution of hosting 25 events for the community! We are so grateful for your contribution and dedication to friendship and connection!",
  SIGN_UP_PAGE_QUOTE:
    "If you're looking for a safe & friendly place to improve your English, Hey Lady! is the place to be! I’ve gained so much confidence & made lots of friends along the way. Highly recommended!",
  SIGN_UP_PAGE_BEFORE_WE_START: "Before we start",
  SIGN_UP_PAGE_PLEASE_CONFIRM_ELIGIBILITY: "Please confirm your eligibility to join {logo}",
  SIGN_UP_PAGE_LETS_GET_STARTED: "Let's get started!",
  SIGN_UP_IMPORTANT_INFORMATION: "Here's some important information you need to know",
  SIGN_UP_PAGE_ARE_YOU_A_WOMAN: "Are you a woman over 18 years old?",
  SIGN_UP_PAGE_ARE_YOU_A_WOMAN_YES: "Yes, I’m a woman over 18 years old",
  SIGN_UP_PAGE_ARE_YOU_A_WOMAN_NO: "No, I’m a woman under 18 years old",
  SIGN_UP_PAGE_ARE_NO_I_AM_A_MAN: "No, I’m a man",
  SIGN_UP_PAGE_CREATE_YOUR_ACCOUNT: "Let’s set up your login",
  SIGN_UP_PAGE_CREATE_YOUR_LOGIN: "Let’s create your login",
  SIGN_UP_PAGE_CREATE_YOUR_ACCOUNT_MOBILE: "Let’s create your account",
  SIGN_UP_PAGE_CHOOSE_HOW_TO_LOG_IN: "Choose how you will log in to {HL}",
  SIGN_UP_WITH_GOOGLE: "Sign up with Google",
  SIGN_UP_PAGE_WHAT_IS_YOUR_ENGLISH_LEVEL: "What is your current English level?",
  SIGN_UP_PAGE_ENGLISH_LEVEL_A1: "A1/A2 Beginner",
  SIGN_UP_PAGE_ENGLISH_LEVEL_B1: "B1 - Intermediate",
  SIGN_UP_PAGE_ENGLISH_LEVEL_B2: "B2 - Upper Intermediate",
  SIGN_UP_PAGE_ENGLISH_LEVEL_C1: "C1 - Advanced",
  SIGN_UP_PAGE_ENGLISH_LEVEL_C2: "C2 - Proficient",
  SIGN_UP_NOT_SURE: "Not Sure? <link>Follow the link</link> to test your level",
  SIGN_UP_PAGE_CONTINUE: "Continue",
  SIGN_UP_PAGE_LETS_GO: "Let’s go!",
  SIGN_UP_PAGE_PREVIOUS_STEP: "Previous Step",
  SIGN_UP_PAGE_BACK_TO_HOME: "Back to Home",
  SIGN_UP_PAGE_ENGLISH_CHARACTERS_ERROR: "Please use only English characters.",
  SIGN_UP_PAGE_YOU_RE_BACK: "You’re back!",
  SIGN_UP_PAGE_ALREADY_HAVE_AN_ACCOUNT:
    "We already have a Hey Lady! account with this email. Please log in to continue.",
  SIGN_UP_PAGE_WE_RE_SORRY: "We’re sorry!",
  SIGN_UP_PAGE_CLOSE_AND_EXIT: "Close and exit",
  SIGN_UP_PAGE_UNFORTUNATELY_WE_CANNOT_ACCEPT: "Unfortunately we cannot accept your application.",
  SIGN_UP_PAGE_TO_JOIN_OUR_COMMUNITY: "To join our community you must:",
  SIGN_UP_PAGE_BE_A_WOMAN_OVER_18_YEARS_OLD: "Be a woman over 18 years old",
  SIGN_UP_PAGE_HAVE_INTERMEDIATE_LEVEL: "Have Intermediate level English or above",
  GUEST_PASS_READY_TITLE: "Your Guest Pass is ready!",
  GUEST_PASS_READY_SUBTITLE: "Let’s get you speaking and connecting in English.",
  GUEST_PASS_SEVEN_DAYS: "7 days",
  GUEST_PASS_INSIDE_HEY_LADY: "inside Hey Lady!",
  GUEST_PASS_THREE_STARTER_EVENTS: "3 Starter Events",
  GUEST_PASS_INCLUDED: "included",
  GUEST_PASS_DURING_TITLE: "During your Guest Pass you can:",
  GUEST_PASS_BENEFIT_ATTEND_TITLE: "Attend 3 Starter Events",
  GUEST_PASS_BENEFIT_ATTEND_COPY: " Friendly live-practice sessions hosted by our team",
  GUEST_PASS_BENEFIT_TABLES_TITLE: "Join ‘Live Coffee Tables’",
  GUEST_PASS_BENEFIT_TABLES_COPY: " Casual video chats with other members online",
  GUEST_PASS_BENEFIT_CHAT_TITLE: "Connect via chat",
  GUEST_PASS_BENEFIT_CHAT_COPY: " to keep talking to the people you meet",
  GUEST_PASS_BENEFIT_EXPLORE_TITLE: "Explore the platform",
  GUEST_PASS_BENEFIT_EXPLORE_COPY: " to see everything we offer",
  GUEST_PASS_MEMBER_ANY_TIME: "Become a member any time",
  GUEST_PASS_MEMBER_BANNER_COPY:
    "Unlock unlimited events including Live Coach Events, Member Events, Study Groups & more",
  GUEST_PASS_TERMS_AGREEMENT: "I agree to Hey Lady’s",
  GUEST_PASS_TERMS_OF_SERVICE: "Terms of Service",
  GUEST_PASS_PRIVACY_POLICY: "Privacy Policy",
  GUEST_PASS_START: "Start my Guest Pass",
  GUEST_PASS_STARTING: "Starting your Guest Pass…",
  GUEST_PASS_CREATE_ERROR:
    "We couldn’t create your Guest Pass. Please try again later or contact Member Support at hello@heylady.io.",
  GUEST_PASS_PREVIOUS_STEP: "Previous Step",
  GUEST_HOME_WELCOME: "Great to see you {name}!\u00a0<emoji>💖</emoji>",
  GUEST_HOME_WELCOME_SUBTITLE:
    "{days, plural, one {Let’s make today a success.} other {Let’s make the next # days a success.}}",
  GUEST_HOME_WELCOME_BACK: "Welcome back {name}!\u00a0<emoji>👋🏼</emoji>",
  GUEST_HOME_WELCOME_BACK_SUBTITLE: "You’re another step closer to confidence!",
  GUEST_HOME_FIRST_DAYS: "Your first 7 days",
  GUEST_HOME_EVENTS_ATTENDED: "Events attended:",
  GUEST_HOME_TIME_IN_EVENTS: "Time in events:",
  GUEST_HOME_BADGES_EARNED: "Badges earned:",
  GUEST_HOME_SEE_ALL_ACHIEVEMENTS: "See all achievements\u00a0→",
  GUEST_HOME_METRICS_EVENTS: "{count, plural, one {<b>#</b> Event} other {<b>#</b> Events}}",
  GUEST_HOME_METRICS_BADGES: "{count, plural, one {<b>#</b> Badge} other {<b>#</b> Badges}}",
  GUEST_HOME_HOURS_MINUTES: "{hours, plural, one {#hr} other {#hrs}} {minutes}mins",
  GUEST_HOME_MINUTES: "{minutes, plural, one {#min} other {#mins}}",
  GUEST_HOME_FIRST_EVENT: "Your first Hey Lady! event",
  GUEST_HOME_NEXT_EVENT: "Your next Hey Lady! event",
  GUEST_HOME_SEE_YOU_THERE: "We can’t wait to see you there!",
  GUEST_HOME_FIRST_EVENT_JOIN_HINT:
    "Come here at the time of your first event.{br}You’ll see a button to “Join the call”.",
  GUEST_HOME_NO_STARTER_EVENTS_LEFT: "You have 0 starter events remaining",
  GUEST_HOME_YOU_ARE_GOING: "You’re going!",
  GUEST_HOME_LOCKED: "Members Only / After your Guest Pass",
  GUEST_HOME_STARTS_IN: "Starts in {time}",
  GUEST_HOME_TIME_DAYS: "{count, plural, one {# day} other {# days}}",
  GUEST_HOME_TIME_HOURS: "{count, plural, one {# hour} other {# hours}}",
  GUEST_HOME_TIME_MINUTES: "{count} min",
  GUEST_HOME_ADD_TO_CALENDAR: "Add to calendar",
  GUEST_HOME_ADDED_TO_CALENDAR: "Added to calendar",
  GUEST_HOME_JOIN_THE_CALL: "Join the call",
  GUEST_HOME_CHOOSE_DIFFERENT_TIME: "Choose a different time",
  GUEST_HOME_CHOOSE_ANOTHER_TITLE: "Cancel and choose another?",
  GUEST_HOME_CHOOSE_ANOTHER_TEXT:
    "To choose a different time, we will cancel your place at this event and inform the host. Then you can browse the event list to find a different event that suits you.",
  GUEST_HOME_CHOOSE_ANOTHER_INVITATIONS_TEXT:
    "To choose a different time, we will cancel your place at this event and inform the host. You have event invitations. We will take you to see them on the Events page.",
  GUEST_HOME_KEEP_BOOKING: "Keep this booking",
  GUEST_HOME_CANCEL_AND_CHOOSE: "Cancel and choose another",
  GUEST_HOME_CANCEL_AND_SEE_INVITATIONS: "Cancel and see invitations",
  GUEST_HOME_CANCEL_BOOKING: "Cancel this booking",
  GUEST_HOME_VIEW_EVENT_DETAILS: "View event details",
  GUEST_HOME_INVITATIONS_TITLE:
    "{count, plural, one {You have an event invitation} other {You have # event invitations}}",
  GUEST_HOME_INVITATIONS_SUBTITLE: "You can see all invitations on the Events page.",
  GUEST_HOME_YOU_ARE_INVITED: "You’re invited!",
  GUEST_HOME_SEE_INVITATIONS: "{count, plural, one {See invitation} other {See invitations}}",
  GUEST_HOME_CHOOSE_FIRST_EVENT: "Choose your first event",
  GUEST_HOME_CHOOSE_FIRST_EVENT_SUBTITLE:
    "Your journey to confidence starts with your first event.",
  GUEST_HOME_NEW_MEMBER_EVENTS: "Friendly events for New Members",
  GUEST_HOME_NEW_MEMBER_EVENTS_TEXT:
    "Watch this video to learn about the different types of events that are available to you.{br}Then, choose a time that works for you.",
  GUEST_HOME_SEE_NEW_MEMBER_EVENTS: "See New Member Events",
  GUEST_HOME_CHOOSE_NEXT_EVENT: "Choose your next event",
  GUEST_HOME_CHOOSE_NEXT_EVENT_SUBTITLE: "Every event is an opportunity to improve and grow.",
  GUEST_HOME_NEED_HELP_DECIDING: "Need help deciding?",
  GUEST_HOME_NEED_HELP_DECIDING_TEXT:
    "Watch this video to learn about the different types of events that are available to you.{br}Book your next event on our events page.",
  GUEST_HOME_EXPLORE_EVENTS: "Explore Events",
  GUEST_HOME_PLAY_EVENTS_VIDEO: "Play the video about our events",
  GUEST_HOME_STARTER_EVENTS_DONE: "You have attended {count} Starter Events",
  GUEST_HOME_STARTER_EVENTS_DONE_SUBTITLE: "That’s a great achievement for your first week!",
  GUEST_HOME_BECOME_MEMBER: "Become a Hey Lady! member",
  GUEST_HOME_BECOME_MEMBER_TEXT:
    "Unlock our full event list including live Coach Events, Study Groups and longer conversations hosted by other members.",
  GUEST_HOME_SEE_PLANS: "See plans",
  GUEST_HOME_BECOME_MEMBER_TO_ATTEND: "Become a member to attend",
  GUEST_HOME_SEE_LIVE_TABLES: "See Live Tables",
  GUEST_HOME_CHAT_WITH_US: "Chat with us",
  GUEST_HOME_NO_THANKS: "No thanks",
  GUEST_HOME_THANKS: "Thanks!",
  GUEST_HOME_CHECK_IN_1_QUESTION: "How are you feeling about your first event?",
  GUEST_HOME_CHECK_IN_1_A: "Great!",
  GUEST_HOME_CHECK_IN_1_A_HINT: "Looking forward to it",
  GUEST_HOME_CHECK_IN_1_B: "I’m OK",
  GUEST_HOME_CHECK_IN_1_B_HINT: "Let’s see how it goes!",
  GUEST_HOME_CHECK_IN_1_C: "A little nervous",
  GUEST_HOME_CHECK_IN_1_C_HINT: "I feel shy to speak",
  GUEST_HOME_CHECK_IN_1_D: "Very nervous",
  GUEST_HOME_CHECK_IN_1_D_HINT: "Not sure I can do it!",
  GUEST_HOME_CHECK_IN_1_FOLLOW_UP: "Can you share more?",
  GUEST_HOME_FOLLOW_UP_MY_LEVEL: "It’s my level",
  GUEST_HOME_FOLLOW_UP_MY_LEVEL_HINT: "I’m worried about it",
  GUEST_HOME_FOLLOW_UP_FIRST_TIME: "It’s my first time",
  GUEST_HOME_FOLLOW_UP_FIRST_TIME_HINT: "Not sure what to do",
  GUEST_HOME_FOLLOW_UP_INTROVERT: "I’m an introvert",
  GUEST_HOME_FOLLOW_UP_INTROVERT_HINT: "I feel shy to speak",
  GUEST_HOME_FOLLOW_UP_SOMETHING_ELSE: "Something else",
  GUEST_HOME_FOLLOW_UP_SOMETHING_ELSE_HINT: "Not sure I can do it!",
  GUEST_HOME_CHECK_IN_1_A_TITLE: "Lovely! We’ll see you there!",
  GUEST_HOME_CHECK_IN_1_A_SUBTITLE: "Your host knows you’re coming and that you’re new.",
  GUEST_HOME_CHECK_IN_1_A_TEXT:
    "Be sure to add the event to your calendar, and log in a few minutes before your event is about to start.",
  GUEST_HOME_CHECK_IN_1_B_TITLE: "Something to do while you wait?",
  GUEST_HOME_CHECK_IN_1_B_SUBTITLE: "Check out our Memberzine, our Community Magazine.",
  GUEST_HOME_CHECK_IN_1_B_TEXT: "You’ll find inspiring articles written by Hey Lady! members.",
  GUEST_HOME_CHECK_IN_1_B_BUTTON: "Go to Memberzine",
  GUEST_HOME_CHECK_IN_1_C_TITLE: "That’s okay. A little nervous is normal.",
  GUEST_HOME_CHECK_IN_1_C_SUBTITLE: "Members Pinar and Sara once felt the same way.",
  GUEST_HOME_CHECK_IN_1_C_TEXT:
    "They created a <bold>5-step Survival Guide for Shy Speakers</bold> to help others.{br}It might help you to feel more comfortable too!",
  GUEST_HOME_CHECK_IN_1_C_BUTTON: "I’ll take a look",
  GUEST_HOME_CHECK_IN_1_D_TITLE: "That’s OK. Everyone feels nervous at first.",
  GUEST_HOME_CHECK_IN_1_D_SUBTITLE: "Our team is here to support you.",
  GUEST_HOME_CHECK_IN_1_D_TEXT:
    "You don’t have to figure this out alone. We can arrange a private one-to-one call with a Community Manager to listen and help you.",
  GUEST_HOME_CHECK_IN_1_D_BUTTON: "Book a 1:1 call",
  GUEST_HOME_CHECK_IN_2_QUESTION: "So, how was your first event?",
  GUEST_HOME_CHECK_IN_2_A: "Fantastic!",
  GUEST_HOME_CHECK_IN_2_A_HINT: "Can’t wait for another",
  GUEST_HOME_CHECK_IN_2_B: "Good",
  GUEST_HOME_CHECK_IN_2_B_HINT: "I enjoyed it",
  GUEST_HOME_CHECK_IN_2_C: "I’m not sure",
  GUEST_HOME_CHECK_IN_2_C_HINT: "I’ll try another one",
  GUEST_HOME_CHECK_IN_2_D: "I didn’t enjoy it",
  GUEST_HOME_CHECK_IN_2_D_HINT: "Not what I expected",
  GUEST_HOME_CHECK_IN_2_FOLLOW_UP: "Sorry to hear it. What happened?",
  GUEST_HOME_FOLLOW_UP_DID_NOT_SPEAK_MUCH: "I didn’t get to speak much",
  GUEST_HOME_FOLLOW_UP_FELT_UNCOMFORTABLE: "I felt uncomfortable",
  GUEST_HOME_FOLLOW_UP_TECHNICAL_ISSUE: "I had a technical issue",
  GUEST_HOME_CHECK_IN_2_A_TITLE: "Glad to hear it!",
  GUEST_HOME_CHECK_IN_2_A_SUBTITLE: "See you at the next one.",
  GUEST_HOME_CHECK_IN_2_A_TEXT: "Feel free to reach out if you have any questions.",
  GUEST_HOME_CHECK_IN_2_A_BUTTON: "OK",
  GUEST_HOME_CHECK_IN_2_B_TITLE: "So glad you enjoyed it!",
  GUEST_HOME_CHECK_IN_2_B_SUBTITLE: "Need any help to choose your next events?",
  GUEST_HOME_CHECK_IN_2_C_TITLE: "That’s OK. Let’s choose another.",
  GUEST_HOME_CHECK_IN_2_C_SUBTITLE: "There are other types of events you can try.",
  GUEST_HOME_QUICK_GUIDE_TEXT:
    "Check out our <guide>Quick Guide to Choosing your First Events</guide>. It explains the different events available and how to join them.",
  GUEST_HOME_SEE_THE_GUIDE: "See the Guide",
  GUEST_HOME_CHECK_IN_2_D_TITLE: "Let’s fix this!",
  GUEST_HOME_CHECK_IN_2_D_SUBTITLE: "Would you like to connect with a Community Manager?",
  GUEST_HOME_CHECK_IN_2_D_TEXT:
    "We are here to help. Send a request and we will contact you via Chat.",
  GUEST_HOME_CHECK_IN_2_D_BUTTON: "Send request",
  GUEST_HOME_REQUEST_RECEIVED_TITLE: "Request received",
  GUEST_HOME_REQUEST_RECEIVED_TEXT:
    "We have informed our Community Manager. They will send you a message via the chat soon.",
  GUEST_HOME_GO_TO_CHAT: "Go to Chat",
  GUEST_HOME_BOOK_CALL_TITLE: "Book a call with our team",
  GUEST_HOME_CHECK_IN_3_QUESTION: "How are you feeling about Hey Lady! so far?",
  GUEST_HOME_CHECK_IN_3_A: "It’s great!",
  GUEST_HOME_CHECK_IN_3_A_HINT: "Really enjoying it",
  GUEST_HOME_CHECK_IN_3_B: "Going well",
  GUEST_HOME_CHECK_IN_3_B_HINT: "I’m happy to be here",
  GUEST_HOME_CHECK_IN_3_C: "Still not sure",
  GUEST_HOME_CHECK_IN_3_C_HINT: "I need more time",
  GUEST_HOME_CHECK_IN_3_D: "It’s not for me",
  GUEST_HOME_CHECK_IN_3_D_HINT: "Thanks for asking",
  GUEST_HOME_CHECK_IN_3_A_TITLE: "So glad to hear it!",
  GUEST_HOME_CHECK_IN_3_A_TEXT:
    "We’ll see you at your next event. Feel free to reach out if you have any questions.",
  GUEST_HOME_CHECK_IN_3_B_TITLE: "That’s great! We’re happy to have you!",
  GUEST_HOME_CHECK_IN_3_B_TEXT:
    "Seeing you at your next event. Feel free to reach out if you have any questions.",
  GUEST_HOME_CHECK_IN_3_C_TITLE: "No worries! Take your time.",
  GUEST_HOME_CHECK_IN_3_C_TEXT:
    "Don’t forget you can start or join unlimited Live Coffee Tables. Feel free to reach out if you have any questions.",
  GUEST_HOME_CHECK_IN_3_D_TITLE: "Thanks for letting us know.",
  GUEST_HOME_CHECK_IN_3_D_TEXT:
    "If you have any questions or want to talk about your experience, our team is here.",
  GUEST_HOME_FIND_AND_JOIN_TITLE: "How to find and join events",
  GUEST_HOME_FIND_AND_JOIN_TEXT:
    "Watch this quick guide on which events to choose, how to book your place and how to join when it starts.",
  GUEST_HOME_WATCH_VIDEO: "Watch Video",
  GUEST_HOME_FEEL_NERVOUS_TITLE: "Feel nervous about joining an event?",
  GUEST_HOME_FEEL_NERVOUS_TEXT:
    "Emma recorded a video to explain exactly what happens, so you know what to expect and can feel more comfortable joining.",
  GUEST_HOME_FEEL_NERVOUS_BUTTON: "Watch video",
  GUEST_HOME_LIVE_TABLES_TITLE: "Happening now: Live Coffee Tables",
  GUEST_HOME_LIVE_TABLES_TEXT:
    "Join other ladies who are online now for a casual conversation. No booking needed. <link>Learn more.</link>",
  GUEST_HOME_LIVE_TABLES_MANY_TEXT:
    "Choose a conversation or start your own. No booking needed. <link>Learn more.</link>",
  GUEST_HOME_SEE_ALL_TABLES: "See all tables\u00a0→",
  GUEST_HOME_TABLE_SEATS:
    "{count, plural, =0 {FULL} one {# seat available} other {# seats available}}",
  GUEST_HOME_TABLE_ENDS_IN: "Ends in {time}",
  GUEST_HOME_JOIN_TABLE: "Join table",
  GUEST_HOME_TABLE_FULL: "Table full",
  GUEST_HOME_START_TABLE_TITLE: "Have something you want to talk about?",
  GUEST_HOME_START_TABLE_TEXT: "Choose a conversation idea or add your own.",
  GUEST_HOME_START_TABLE: "Start a table",
  GUEST_HOME_SPEAK_NOW_TITLE: "Ready to speak now?",
  GUEST_HOME_SPEAK_NOW_TEXT:
    "You can start or join a <bold>Live Coffee Table</bold>. Casual conversations with other members who are online at the same time.",
  GUEST_HOME_LEARN_MORE: "Learn more",
  GUEST_HOME_CURRENT_TOPIC_TITLE: "Have you seen the Current Topic?",
  GUEST_HOME_CURRENT_TOPIC_TEXT:
    "We’re talking about <bold>{topic}</bold>. Our coaches have provided new vocabulary, grammar and pronunciation lessons to help you prepare.",
  GUEST_HOME_CHECK_IT_OUT: "Check it out",
  GUEST_HOME_SEE_PLANS_TITLE: "You can still join Live Tables",
  GUEST_HOME_SEE_PLANS_TEXT:
    "Your Guest Pass includes unlimited Live Tables. Drop in for a casual conversation and enjoy meeting different people.",
  GUEST_HOME_SEE_PLANS_TRIAL_TEXT:
    "Your trial includes unlimited Live Tables. Drop in for a casual conversation and enjoy meeting different people.",
  GUEST_HOME_STEPS_TITLE: "While you’re here…",
  GUEST_HOME_STEPS_SUBTITLE: "3 quick steps to get set up in Hey Lady!",
  GUEST_HOME_STEPS_SUBTITLE_GUEST_PASS: "3 quick steps to get the most from your Guest Pass.",
  GUEST_HOME_EMMA_TITLE: "A quick hello from Emma\u00a0👋",
  GUEST_HOME_EMMA_TEXT:
    "Watch this short 3-minute video to get a feel for what to expect in your first week at Hey Lady!",
  GUEST_HOME_EMMA_DURATION: "◷  3 min",
  GUEST_HOME_EMMA_PLAY: "Play Emma’s video",
  GUEST_HOME_VERIFY_TEXT:
    "Help us keep our community safe. Record a short video for our team to review.{br}Being verified also unlocks access to <bold>Live Coffee Tables</bold>.",
  GUEST_HOME_VERIFY_DURATION: "◷  2 min",
  GUEST_HOME_PROFILE_TEXT:
    "Add a photo and a little about yourself so others can recognise you and get to know you before you meet.",
  GUEST_HOME_PROFILE_DURATION: "◷  3 min",
  GUEST_HOME_EDIT_PROFILE: "Edit profile",
  GUEST_HOME_TILE_VIDEO: "Welcome video",
  GUEST_HOME_TILE_VIDEO_TEXT: "A quick hello from Emma 👋🏼",
  GUEST_HOME_TILE_VERIFY_TEXT: "Unlock Live Coffee Tables",
  GUEST_HOME_TILE_IN_REVIEW: "Your video is being reviewed",
  GUEST_HOME_TILE_PROFILE_TEXT: "Help others get to know you",
  GUEST_HOME_STEP_DONE: "{count} of 3 steps done",
  GUEST_HOME_STEP_WATCH_VIDEO: "Watch Emma’s video",
  GUEST_HOME_STEP_GET_VERIFIED: "Get verified",
  GUEST_HOME_STEP_INTRODUCE_YOURSELF: "Introduce yourself",
  GUEST_HOME_STEP_STATUS_DONE: "{step}: done",
  GUEST_HOME_STEP_STATUS_TO_DO: "{step}: to do",
  GUEST_HOME_STEP_STATUS_IN_REVIEW: "{step}: in review",
  GUEST_HOME_EXPLORE_TITLE: "Why become a member?",
  GUEST_HOME_EXPLORE_SUBTITLE:
    "Your Guest Pass is just the beginning. Membership unlocks your true potential.",
  GUEST_HOME_EXPLORE_TRIAL_SUBTITLE:
    "Your trial is just the beginning. Membership unlocks your true potential.",
  GUEST_HOME_EXPLORE_BENEFITS_EYEBROW: "MEMBERSHIP BENEFITS",
  GUEST_HOME_EXPLORE_BENEFITS_TITLE: "What’s included in a membership?",
  GUEST_HOME_EXPLORE_BENEFITS_TEXT:
    "Choose the practice, people and support that fit your life and goals.",
  GUEST_HOME_EXPLORE_BENEFITS_LINK: "Find out what’s included\u00a0→",
  GUEST_HOME_EXPLORE_ROXANA_EYEBROW: "ROXANA’S STORY",
  GUEST_HOME_EXPLORE_ROXANA_TITLE: "She stopped avoiding English.",
  GUEST_HOME_EXPLORE_ROXANA_TEXT:
    "How she built the confidence to take opportunities she once avoided.",
  GUEST_HOME_EXPLORE_ROXANA_LINK: "Read Roxana’s story\u00a0→",
  GUEST_HOME_EXPLORE_SABAH_EYEBROW: "SABAH’S STORY",
  GUEST_HOME_EXPLORE_SABAH_TITLE: "Now she can lead the conversation.",
  GUEST_HOME_EXPLORE_SABAH_TEXT:
    "How she took charge of her learning and found the courage to host.",
  GUEST_HOME_EXPLORE_SABAH_LINK: "Read Sabah’s story\u00a0→",
  GUEST_HOME_INCLUDED_WITH_MEMBERSHIP: "Included with membership",
  GUEST_HOME_BASIC_EXCLUDES_COACH_EVENTS: "Basic Membership excludes Coach events",
  GUEST_HOME_BASIC_EXCLUDES_COACH_CONTENT: "Basic Membership excludes Coach content",
  GUEST_HOME_BASIC_EXCLUDES_MONTHLY_CHALLENGES: "Basic Membership excludes Monthly Challenges",
  GUEST_HOME_OPTIONAL_ADDITIONAL_COST: "Optional · Additional cost",
  GUEST_HOME_ROXANA_STORY: "Roxana’s story",
  GUEST_HOME_SABAH_STORY: "Sabah’s story",
  GUEST_HOME_CLOSE_STORY: "Close story",
  GUEST_HOME_MEMBERSHIP_BENEFITS: "Membership benefits",
  GUEST_HOME_CLOSE_BENEFITS: "Close membership benefits",
  GUEST_HOME_SLIDE_COUNT: "{slide} of {count}",
  GUEST_HOME_GO_TO_SLIDE: "Go to slide {slide}",
  GUEST_HOME_PREVIOUS_SLIDE: "Previous",
  GUEST_HOME_NEXT_SLIDE: "Next",
  GUEST_HOME_BENEFIT_1_TITLE: "More ways to practise. {br}More ways to improve.",
  GUEST_HOME_BENEFIT_1_TEXT_1:
    "As a member you unlock hundreds of events every month.{br}Join <bold>Coach events, Study Groups, Member Events or host your own</bold> events.",
  GUEST_HOME_BENEFIT_1_TEXT_2:
    "Choose what interests you, at times that suit you and <bold>build a weekly routine</bold> around your life and personal goals.",
  GUEST_HOME_BENEFIT_2_TITLE:
    "Learn and practise in <accent>live</accent> classes with our coaches",
  GUEST_HOME_BENEFIT_2_TEXT_1:
    "We schedule live <bold>grammar and vocabulary classes</bold> to cover all time zones. Use what you learn in <bold>guided conversations</bold> for intermediate and advanced speakers. Get support & feedback to express your ideas more clearly and confidently.",
  GUEST_HOME_BENEFIT_3_TITLE: "Keep learning at your own pace",
  GUEST_HOME_BENEFIT_3_TEXT_1:
    "<bold>Fresh topics and lessons are added every month.</bold> Plus coach training, past topics and a Grammar Library. Prepare for conversations, revisit something you find difficult and build your skills at the time that suits you.",
  GUEST_HOME_BENEFIT_4_TITLE: "Find your people",
  GUEST_HOME_BENEFIT_4_TEXT_1:
    "Membership connects you to a global network of people who share your interests and goals. Meet through <bold>member-hosted events, interest groups, study groups and in-person meetups.</bold>",
  GUEST_HOME_BENEFIT_4_TEXT_2:
    "Having friends to talk to makes English enjoyable. Imagine having English-speaking friends all over the world!",
  GUEST_HOME_BENEFIT_5_TITLE: "Do more with your English",
  GUEST_HOME_BENEFIT_5_TEXT_1:
    "Join our regular <bold>Monthly Challenges</bold> to push your comfort zone. Start a book or movie club, or bring people together at your own event or a local meetup.",
  GUEST_HOME_BENEFIT_5_TEXT_2:
    "We provide <bold>training to help you host, start a club or practise having deeper conversations.</bold> Experience English in different formats to expand your skills.",
  GUEST_HOME_BENEFIT_6_TITLE: "Optional coaching programs",
  GUEST_HOME_BENEFIT_6_TEXT_1:
    "We offer specialised programs throughout the year that include a dedicated coach in a small group.{br}Develop effective communication skills for work and life:",
  GUEST_HOME_BENEFIT_6_TEXT_2:
    "· Speak English With Ease (6 weeks){br}· English for Work, Parts 1, 2 & 3 (8 weeks each)",
  GUEST_HOME_BENEFIT_6_TEXT_3: "Available to members at an additional cost.",
  GUEST_HOME_BENEFITS_CONTINUE: "Continue\u00a0→",
  GUEST_HOME_BENEFITS_CLOSING_TITLE: "Your goals. Your interests.{br}Your English journey.",
  GUEST_HOME_BENEFITS_CLOSING_LEAD: "A Hey Lady! membership gives you choices.",
  GUEST_HOME_BENEFITS_CLOSING_TEXT:
    "Bring English into your life and build a routine that fits your life and your goals.{br}Everything you need in one place.{br}All you need to do is show up.",
  GUEST_HOME_SEE_MEMBERSHIP_OPTIONS: "See membership options",
  GUEST_HOME_SEE_MEMBERSHIP_PLANS: "See membership plans",
  GUEST_HOME_DISCOVER_HOW: "Discover how she got here\u00a0→",
  GUEST_HOME_ROXANA_1_SCRIPT: "Meet Roxana 🇷🇴",
  GUEST_HOME_ROXANA_1_TITLE: "She stopped avoiding English.",
  GUEST_HOME_ROXANA_1_TEXT:
    "After four months at Hey Lady!, Roxana was taking opportunities to speak, connect and even write in English that she once would have avoided.",
  GUEST_HOME_ROXANA_2_TITLE: "Where she started...",
  GUEST_HOME_ROXANA_2_TEXT:
    "Roxana wanted to express herself in English, but worried about making mistakes.",
  GUEST_HOME_ROXANA_2_QUOTE:
    "“I didn’t know if I would ever reach a point in my life when I would be proud of my accuracy and my fluency.”",
  GUEST_HOME_ROXANA_3_TITLE: "She found things she wanted to learn.",
  GUEST_HOME_ROXANA_3_TEXT_1:
    "Roxana studied the ‘Current Topic’ provided by our coaches, completed the vocabulary workbooks and watched our training on the foundations of fluency.",
  GUEST_HOME_ROXANA_3_TEXT_2:
    "Our Coach Events gave her the opportunity to put what she learned into practice with structure and guidance.",
  GUEST_HOME_ROXANA_4_TITLE: "She gave herself more chances to speak.",
  GUEST_HOME_ROXANA_4_TEXT_1:
    "In four months, Roxana attended 32 events. Later she began hosting her own events to meet other ladies interested in psychology.",
  GUEST_HOME_ROXANA_4_TEXT_2:
    "She also joined reading and writing clubs and continued her conversations via chat with other members.",
  GUEST_HOME_ROXANA_5_TITLE: "“I knew that I could manage.”",
  GUEST_HOME_ROXANA_5_TEXT_1:
    "All that practice helped her feel ready to try, even while she made mistakes.",
  GUEST_HOME_ROXANA_5_TEXT_2:
    "It didn’t take long before Roxana began to embrace opportunities to speak or write in English in everyday life.",
  GUEST_HOME_ROXANA_6_TITLE: "“I found my people here.”",
  GUEST_HOME_ROXANA_6_TEXT_1:
    "Friendships, interesting topics and conversations gave Roxana reasons to keep coming back.",
  GUEST_HOME_ROXANA_6_TEXT_2:
    "She hadn’t followed her original plan perfectly. She still experienced doubts. But she felt motivated to keep showing up because of the people she had connected with in the community.",
  GUEST_HOME_ROXANA_7_TITLE: "There’s a method behind her progress",
  GUEST_HOME_ROXANA_7_LEAD: "It’s the Hey Lady! Fluency Framework.",
  GUEST_HOME_ROXANA_7_TEXT_1:
    "Every month, Roxana <bold>prepared</bold> with a topic, <bold>practised</bold> in conversation and <bold>progressed</bold> by reflecting and learning what she needed next. Then she <bold>repeated</bold>, joining more conversations on the same topic from different angles.",
  GUEST_HOME_ROXANA_7_TEXT_2:
    "Hey Lady! is built to help you follow this framework around your interests, goals and everyday life.",
  GUEST_HOME_ROXANA_8_TITLE: "What would you do with more confidence in English?",
  GUEST_HOME_ROXANA_8_TEXT_1:
    "Roxana stopped avoiding opportunities to use her English. {br}Think about the doors that could open in your life.",
  GUEST_HOME_ROXANA_8_TEXT_2:
    "With membership, you’ll have the people, practice and coach support to make it happen. 💫",
  GUEST_HOME_SABAH_1_SCRIPT: "Meet Sabah 🇫🇷",
  GUEST_HOME_SABAH_1_TITLE: "Now she can lead the conversation.",
  GUEST_HOME_SABAH_1_TEXT:
    "Sabah once struggled to express herself freely in English. After two years at Hey Lady!, she can bring a group together, lead discussions and help others learn alongside her.",
  GUEST_HOME_SABAH_2_TITLE: "Her starting point...",
  GUEST_HOME_SABAH_2_TEXT:
    "Sabah had studied independently and completed training that helped her reach B2. Yet she wanted more than a qualification. She wanted to be able to express herself fully.",
  GUEST_HOME_SABAH_2_QUOTE:
    "“I was able to speak English, but I didn’t feel as fluent as I wanted to be.”",
  GUEST_HOME_SABAH_3_TITLE: "She prepared around her interests and goals.",
  GUEST_HOME_SABAH_3_TEXT_1:
    "Sabah began with structure of Coach Events but was soon diving deeper into specific topics that interested her, together with her speaking partners.",
  GUEST_HOME_SABAH_3_TEXT_2:
    "She chose to attend the sessions that were relevant to her goals. Goals that ultimately led to her next step.",
  GUEST_HOME_SABAH_4_TITLE: "She challenged herself to lead.",
  GUEST_HOME_SABAH_4_TEXT_1:
    "A few months after joining, Sabah chose to host her own events in English. She was still working on her fluency, but stepped forward to lead conversations about her personal areas of interest: reading and self-development.",
  GUEST_HOME_SABAH_4_TEXT_2: "<bold>“I started small.”</bold>",
  GUEST_HOME_SABAH_4_TEXT_3:
    "Those small sessions gave her a reason to practise and start each day with purpose.",
  GUEST_HOME_SABAH_5_TITLE: "Her practice became shared experiences for others.",
  GUEST_HOME_SABAH_5_TEXT_1:
    "Sabah began hosting larger events on a regular schedule. One helps members to share and expand their vocabulary, explain meanings and use new words in sentences.",
  GUEST_HOME_SABAH_5_TEXT_2:
    "The other focuses on confidence, fear of judgement and other topics that help them grow together, not only in English but in life.",
  GUEST_HOME_SABAH_6_TITLE: "“English is no longer just something I study.”",
  GUEST_HOME_SABAH_6_TEXT_1:
    "English has become a part of Sabah’s daily life. She’s learned to give herself time and enjoy the journey and new friendships.",
  GUEST_HOME_SABAH_6_TEXT_2:
    "<bold>Her next goal?</bold> More pronunciation and accuracy practice, including events she plans to host herself (of course!).",
  GUEST_HOME_SABAH_7_TITLE: "Small steps create big change.",
  GUEST_HOME_SABAH_7_TEXT_1:
    "“Step by step, I began to <bold>let go of pressure</bold>, trust the journey, and celebrate the little wins along the way.”",
  GUEST_HOME_SABAH_7_TEXT_2:
    "“Hey Lady! teaches us that we have no excuses, we can show up anytime and speak, even if it’s just for <bold>five or ten minutes.</bold>”",
  GUEST_HOME_SABAH_7_TEXT_3: "<bold>“Everything is available for us to grow.”</bold>",
  GUEST_HOME_SABAH_8_TITLE: "Where will you take your English journey?",
  GUEST_HOME_SABAH_8_TEXT_1:
    "Sabah turned her interests and goals into conversations and a personal challenge to lead. Your journey might be different.",
  GUEST_HOME_SABAH_8_TEXT_2:
    "With membership, you’ll have the people, practice and the platform to be in control of where you want your English to go.",
  HOME_YOUR_NEXT_EVENT: "Your next event",
  HOME_PRACTICE_MAKES_PROGRESS: "Practice makes progress.",
  HOME_PRACTICE_MAKES_PROGRESS_TEXT:
    "Even a short conversation can help you keep building your fluency and confidence.",
  HOME_FIND_AN_EVENT: "Find an event",
  WAY_TITLE: "Learn the Hey Lady! Way",
  WAY_SUBTITLE: "Our values. Our community.{br}Our promise to each other.",
  WAY_VALUES_TITLE: "Our Community Values",
  WAY_VALUES_CARD_TITLE: "Our Community Values 💫",
  WAY_VALUES_TEXT:
    "Every member is an important part of what makes Hey Lady! special. Watch this video to discover the five values we share and how you can help others feel welcome, supported and ready to speak.",
  WAY_VALUES_DURATION: "◷  3 min",
  WAY_VALUES_PLAY: "Play the community values video",
  WAY_VALUES_TILE: "How we learn and grow together",
  WAY_VALUES_MOBILE_TITLE: "Our community values",
  WAY_VALUES_MOBILE_TEXT:
    "Discover the values that guide how we learn, connect and support each other.",
  WAY_WATCH_THE_VIDEO: "Watch the video",
  WAY_QUIZ_TITLE: "Take the quiz",
  WAY_QUIZ_TEXT:
    "10 questions about life in Hey Lady!{br}Every question has a hint to help you learn.",
  WAY_QUIZ_TILE: "10 questions, with hints to help",
  WAY_PACT_TITLE: "Our Conversation Pact",
  WAY_PACT_TEXT: "Four simple promises that help everyone feel welcome, heard and ready to speak.",
  WAY_PACT_TILE: "Four promises we make to each other",
  WAY_READ_THE_PACT: "Read the Pact",
  WAY_COMPLETE_TITLE: "You’re part of the Hey Lady! Way",
  WAY_COMPLETE_TEXT:
    "You’ve learned our values, passed the quiz and agreed to our Conversation Pact.",
  WAY_VALUES_DONE: "Our community values  ·  Completed",
  WAY_QUIZ_DONE: "Take the quiz  ·  Completed",
  WAY_PACT_DONE: "Our Conversation Pact  ·  Completed",
  WAY_READ_OUR_PACT: "Read our Conversation Pact",
  PACT_TITLE: "Our Conversation Pact",
  PACT_I_AGREE: "I agree",
  PACT_AGREED: "You agreed to this promise",
  PACT_PROMISE_OF: "Promise {number} of {total}",
  PACT_COMPLETE: "Complete",
  PACT_PREVIOUS: "Previous promise",
  PACT_BE_CURIOUS_TITLE: "Be curious",
  PACT_BE_CURIOUS_PROMISE: "I’ll listen as much as I talk.",
  PACT_BE_CURIOUS_TEXT_1: "I’ll ask others about their life and their views.",
  PACT_BE_CURIOUS_TEXT_2:
    "We don’t have to agree. I can share my opinions without trying to change someone else’s beliefs.",
  PACT_BE_RESPECTFUL_TITLE: "Be respectful",
  PACT_BE_RESPECTFUL_PROMISE: "I’ll respond with kindness.",
  PACT_BE_RESPECTFUL_TEXT_1:
    "We’re all using our non-native language. Misunderstandings can happen. I’ll ask what someone means before assuming the worst.",
  PACT_BE_RESPECTFUL_TEXT_2:
    "If I feel hurt or uncomfortable, I can say so or ask the Community Managers for help.",
  PACT_BE_WELCOMING_TITLE: "Be welcoming",
  PACT_BE_WELCOMING_PROMISE: "I’ll invite quieter ladies to share.",
  PACT_BE_WELCOMING_TEXT_1:
    "I’ll never leave anyone out because of her accent, her background or her beliefs.",
  PACT_BE_WELCOMING_TEXT_2: "I’ll let others finish, not talk over them.",
  PACT_BE_FULLY_PRESENT_TITLE: "Be fully present",
  PACT_BE_FULLY_PRESENT_PROMISE: "I’ll join with my camera on.",
  PACT_BE_FULLY_PRESENT_TEXT_1:
    "I’ll join ready to talk, not while driving, working or doing something else!",
  PACT_BE_FULLY_PRESENT_TEXT_2:
    "Whether I’m joining, or hosting, I will help make the conversation a good experience for everyone.",
  PACT_THANK_YOU: "Thank you!",
  PACT_THANK_YOU_TITLE: "You help make Hey Lady! possible.",
  PACT_THANK_YOU_TEXT_1:
    "Every time you join a conversation, you give someone else a person to talk to, someone who will listen and the encouragement to keep going.",
  PACT_THANK_YOU_TEXT_2: "Thank you for being that person.",
  GUEST_PASS_STATUS_DAYS: "{days, plural, one {# day} other {# days}}",
  GUEST_PASS_STATUS_ENDED: "Guest Pass ended",
  GUEST_PASS_STATUS_TOKENS: "{remaining}/{allowance} starter events left",
  GUEST_PASS_STATUS_TOKENS_COMPACT:
    "{remaining, plural, one {# event token left} other {# event tokens left}}",
  GUEST_PASS_STATUS_TITLE_ACTIVE: "You have a 7-day Guest Pass!",
  GUEST_PASS_STATUS_TITLE_ENDED: "Your Guest Pass has ended.",
  GUEST_PASS_STATUS_INCLUDED: "Includes 7 days inside Hey Lady! and {allowance} Starter Events.",
  GUEST_PASS_STATUS_UPGRADE_TITLE: "Become a member anytime",
  GUEST_PASS_STATUS_UPGRADE_COPY:
    "to unlock unlimited events, including Coach Conversations, Group Study events, Member-Hosted events and more.",
  GUEST_PASS_BECOME_MEMBER: "Become a member",
  GUEST_PASS_MAYBE_LATER: "Maybe later",
  GUEST_PASS_COMPLETION_TITLE: "You’ve made a great start!",
  GUEST_PASS_COMPLETION_EVENTS: "3 Starter Events attended",
  GUEST_PASS_COMPLETION_REMAINING:
    "Guest Pass {days, plural, one {# day left} other {# days left}}",
  GUEST_PASS_COMPLETION_COPY:
    "Keep talking via video at Live Coffee Tables, chat with the people you’ve met and explore the platform. If you’re ready, become a member and enjoy unlimited access to all Hey Lady! events.",
  GUEST_PASS_KEEP_EXPLORING: "Keep Exploring",
  GUEST_PASS_LOCK_COACH_TITLE: "Unlock Coach Events",
  GUEST_PASS_LOCK_COACH_COPY:
    "Get guidance and support from Hey Lady! coaches in live events. Become a member to unlock Coach Events and join as many as you like.",
  GUEST_PASS_LOCK_LONG_TITLE: "Unlock longer events",
  GUEST_PASS_LOCK_LONG_COPY:
    "Build fluency with more time to speak, listen and connect. Become a member to unlock Speak 45+ Events and join as many as you like.",
  GUEST_PASS_LOCK_STUDY_TITLE: "Unlock Study Events",
  GUEST_PASS_LOCK_STUDY_COPY:
    "Learn with other members in focused study events. Become a member to unlock Group Study Events and join as many as you like.",
  GUEST_PASS_LOCK_MEMBER_TITLE: "Unlock member-hosted Events",
  GUEST_PASS_LOCK_MEMBER_COPY:
    "Connect with members in community-hosted events. Become a member to join these Events and unlock the full calendar.",
  GUEST_PASS_LOCK_AFTER_TITLE: "After your Guest Pass",
  GUEST_PASS_LOCK_AFTER_COPY:
    "Your Guest Pass gives you access for 7 days. Become a member to join future events and keep practising with Hey Lady!",
  GUEST_PASS_LOCK_TOKENS_TITLE: "Ready for more events?",
  GUEST_PASS_LOCK_TOKENS_STATUS: "You’ve attended 3 Starter Events",
  GUEST_PASS_LOCK_TOKENS_COPY:
    "Become a member to enjoy unlimited access to all events and continue your journey to confidence!",
  GUEST_PASS_SEE_MEMBERSHIP_PLANS: "See membership plans",
  GUEST_PASS_MEMBERS_ONLY: "Members Only.",
  GUEST_PASS_CLICK_INCLUDED: "Click to see what’s included.",
  GUEST_PASS_EVENT_CARD_AFTER: "After your Guest Pass",
  GUEST_PASS_EVENT_CARD_MEMBERS_ONLY: "Members only",
  BECOME_MEMBER_TITLE: "Become a Hey Lady! Member today",
  BECOME_MEMBER_RESTART_TITLE: "Welcome back!",
  BECOME_MEMBER_RESTART_SUBTITLE:
    "We’d love to give you one more Guest Pass to experience Hey Lady!",
  BECOME_MEMBER_RESTART_CARD_TITLE: "Restart your Guest Pass",
  BECOME_MEMBER_RESTART_HOSTED_BY_TEAM: "hosted by our team",
  BECOME_MEMBER_RESTART_ONCE: "You can restart your Guest Pass once.",
  BECOME_MEMBER_RESTART_CHOOSE_WEEK: "Choose a week when you have time to participate.",
  BECOME_MEMBER_RESTART_CTA: "See session times",
  BECOME_MEMBER_RESTART_BOOK_SUBTITLE:
    "☺️ All sessions are friendly and relaxed. Our team will be there to welcome and guide you.",
  BECOME_MEMBER_RESTART_BOOK_EMPTY:
    "There are no suitable sessions at this time. Please choose another time zone.",
  BECOME_MEMBER_RESTART_CANCEL: "Cancel. I’ll restart another time.",
  BECOME_MEMBER_RESTART_STARTS_TODAY: "Your Guest Pass starts today",
  BECOME_MEMBER_RESTART_CHANGE_TIME: "Change time",
  BECOME_MEMBER_RESTART_FINAL_CTA: "Start my Guest Pass now",
  BECOME_MEMBER_DESCRIPTION:
    "Join the community that helps you speak, connect and grow. Every month, enjoy unlimited events, coach support and real conversations with women around the world — for less than the cost of a single private lesson.",
  BECOME_MEMBER_CONFIDENCE: "Build your confidence",
  BECOME_MEMBER_CONFIDENCE_COPY: "so it’s there when you need it",
  BECOME_MEMBER_FLUENCY: "Expand your fluency",
  BECOME_MEMBER_FLUENCY_COPY: "so you can express ideas freely",
  BECOME_MEMBER_COACHES: "Get help from coaches",
  BECOME_MEMBER_COACHES_COPY: "so you know where to focus",
  BECOME_MEMBER_VOICE: "Find your voice in English",
  BECOME_MEMBER_VOICE_COPY: "so you feel like yourself when you speak",
  BECOME_MEMBER_MONTHLY_PLAN: "Monthly Plan",
  BECOME_MEMBER_MONTHLY: "Monthly",
  BECOME_MEMBER_MONTHLY_NOTE: "Flexible month-to-month",
  BECOME_MEMBER_MONTHLY_BILLING: "You pay {currency}{price} every month",
  BECOME_MEMBER_QUARTERLY_PLAN: "Quarterly Plan",
  BECOME_MEMBER_QUARTERLY: "Quarterly",
  BECOME_MEMBER_QUARTERLY_NOTE: "Best for building real progress",
  BECOME_MEMBER_QUARTERLY_BILLING: "You pay {currency}{price} every 3 months",
  BECOME_MEMBER_QUARTERLY_SAVING: "Save $30 over 3 months",
  BECOME_MEMBER_MOST_POPULAR: "MOST POPULAR",
  BECOME_MEMBER_YEARLY_PLAN: "Yearly Plan",
  BECOME_MEMBER_YEARLY: "Yearly",
  BECOME_MEMBER_YEARLY_NOTE: "Best value for your fluency goals",
  BECOME_MEMBER_YEARLY_BILLING: "You pay {currency}{price} once a year",
  BECOME_MEMBER_YEARLY_SAVING: "Save $240 over 12 months",
  BECOME_MEMBER_BEST_VALUE: "BEST VALUE",
  BECOME_MEMBER_CHOOSE: "Choose {plan}",
  BECOME_MEMBER_NO_CONTRACT: "No contract. You cancel or switch plans any time.",
  BECOME_MEMBER_SAFE_CHECKOUT: "100% Safe Checkout. Secure SSL Encryption.",
  BECOME_MEMBER_SUCCESS_TITLE: "Welcome to the family",
  BECOME_MEMBER_SUCCESS_SPECIAL_DAY: "Today is a special day!",
  BECOME_MEMBER_SUCCESS_COPY:
    "You are officially a Hey Lady! member.\nYou can now attend unlimited conversations, coach classes, study groups & so much more.\nSee you in your next event!",
  BECOME_MEMBER_EXPLORE_EVENTS: "Explore events",
  BECOME_MEMBER_SUCCESS_IMAGE_ALT: "Women welcoming a new Hey Lady! member",
  BECOME_MEMBER_GO_TO_HEY_LADY: "Go to Home",
  BECOME_MEMBER_RECONCILIATION_ERROR_TITLE: "We couldn’t confirm your membership",
  BECOME_MEMBER_RECONCILIATION_ERROR_COPY:
    "We couldn’t check your membership status. Select ‘Check membership status’ to check again without making another payment. If this continues, contact Member Support before attempting another checkout.",
  BECOME_MEMBER_RETRY_CONFIRMATION: "Check membership status",
  SIGN_UP_CONFIRMATION_PAYMENT_SUCCESSFUL: "Payment Successful!",
  SIGN_UP_CONFIRMATION_MEET_YOU: "We can’t wait to meet you!",
  SIGN_UP_CONFIRMATION_THANK_YOU: "Thank you for supporting Hey Lady!",
  SIGN_UP_CONFIRMATION_COPY: "A copy of your receipt has been sent to {email}.",
  SIGN_UP_CONFIRMATION_UPDATE: "You can update your payment settings at any time.",
  SIGN_UP_CONFIRMATION_ENTER_HEY_LADY: "Enter Hey Lady!",
  SIGN_UP_CONFIRMATION_CHECK_EMAIL: "Please check your email",
  SIGN_UP_CONFIRMATION_SENT_YOU:
    "We just sent you a link to {email} to enter the Hey Lady! platform.",
  SIGN_UP_CONFIRMATION_RECEIPT: "We also sent you a copy of your receipt.",
  SIGN_UP_CONFIRMATION_RESEND:
    "Can’t see the email in your inbox or spam folder? <url>Resend the link</url>.",
  SIGN_UP_CHECK_EMAIL: "Check your email",
  SIGN_UP_CHECK_CLICK_ON_THE_LINK:
    "Click on the link we sent to {email} to finish your account setup.",
  SIGN_UP_STILL_NO_EMAIL: "Still no email? <url>Contact Member Support</url>",
  SIGN_UP_PAGE_FREE_TRIAL_HOW_IT_WORKS: "How your free trial works",
  SIGN_UP_PAGE_FREE_TRIAL_SIGNUP_TODAY: "Sign up today",
  SIGN_UP_PAGE_FREE_TRIAL_SIGNUP_TODAY_DESCRIPTION: "Enter your details to create your account",
  SIGN_UP_PAGE_FREE_TRIAL_START_FREE_TRIAL: "Start your free trial",
  SIGN_UP_PAGE_FREE_TRIAL_START_FREE_TRIAL_DESCRIPTION:
    "Explore our platform and enjoy live conversation and learning sessions.",
  SIGN_UP_PAGE_FREE_TRIAL_EMAIL_REMINDER: "Day 4: Email Reminder",
  SIGN_UP_PAGE_FREE_TRIAL_EMAIL_REMINDER_DESCRIPTION:
    "We’ll remind you that your trial is ending in case you need to cancel",
  SIGN_UP_PAGE_FREE_TRIAL_ENDS_TODAY: "Day 7: Trial Ends",
  SIGN_UP_PAGE_FREE_TRIAL_ENDS_DESCRIPTION:
    "Your payment method will be charged automatically. Cancel to avoid payment",
  SIGN_UP_PAGE_SOCIAL_TRIAL_SETUP_LOGIN: "Set up your login",
  GUEST_PASS_SIGNUP_BACK: "Back",
  GUEST_PASS_SIGNUP_ABOUT_TITLE: "Tell us about yourself",
  GUEST_PASS_SIGNUP_ABOUT_SUBTITLE: "Your answers help us match you with people and events.",
  GUEST_PASS_SIGNUP_ELIGIBILITY_SUBTITLE: "Let’s make sure you are eligible to participate.",
  GUEST_PASS_SIGNUP_ELIGIBILITY_QUESTION: "Are you a woman 18 years or over?",
  GUEST_PASS_SIGNUP_ELIGIBILITY_YES: "Yes",
  GUEST_PASS_SIGNUP_ELIGIBILITY_YES_COPY: "I am a woman 18 years or over",
  GUEST_PASS_SIGNUP_ELIGIBILITY_UNDER_18: "No",
  GUEST_PASS_SIGNUP_ELIGIBILITY_UNDER_18_COPY: "I am not 18 years old yet",
  GUEST_PASS_SIGNUP_ELIGIBILITY_NO: "No",
  GUEST_PASS_SIGNUP_ELIGIBILITY_NO_COPY: "I am not a woman",
  GUEST_PASS_SIGNUP_ENGLISH_QUESTION: "What is your current English level?",
  GUEST_PASS_SIGNUP_ENGLISH_C2_TITLE: "Proficient (C2)",
  GUEST_PASS_SIGNUP_ENGLISH_C2_COPY:
    "I can understand almost everything easily and express precise meaning, even in complex situations.",
  GUEST_PASS_SIGNUP_ENGLISH_C1_TITLE: "Advanced (C1)",
  GUEST_PASS_SIGNUP_ENGLISH_C1_COPY:
    "I can understand complex English and communicate in work, study and social environments.",
  GUEST_PASS_SIGNUP_ENGLISH_B2_TITLE: "Upper-intermediate (B2)",
  GUEST_PASS_SIGNUP_ENGLISH_B2_COPY:
    "I can understand English about many topics, share my opinion and give reasons for my ideas.",
  GUEST_PASS_SIGNUP_ENGLISH_B1_TITLE: "Intermediate (B1)",
  GUEST_PASS_SIGNUP_ENGLISH_B1_COPY:
    "I can understand everyday topics and join simple conversations when people speak clearly.",
  GUEST_PASS_SIGNUP_ENGLISH_BEGINNER_TITLE: "Beginner (A1/A2)",
  GUEST_PASS_SIGNUP_ENGLISH_BEGINNER_COPY:
    "I know some words and phrases, but I need a teacher or translator to help me join a conversation.",
  GUEST_PASS_SIGNUP_PRIORITY_QUESTION:
    "What is the main reason you want to improve your spoken English?",
  GUEST_PASS_SIGNUP_PRIORITY_WORK_TITLE: "For work or study",
  GUEST_PASS_SIGNUP_PRIORITY_WORK_COPY: "Career, interviews, presentations, study.",
  GUEST_PASS_SIGNUP_PRIORITY_SOCIAL_TITLE: "For social connection",
  GUEST_PASS_SIGNUP_PRIORITY_SOCIAL_COPY: "Friendships, relationships, expand my network.",
  GUEST_PASS_SIGNUP_PRIORITY_EVERYDAY_TITLE: "For everyday life",
  GUEST_PASS_SIGNUP_PRIORITY_EVERYDAY_COPY: "Appointments, shops, neighbours, services.",
  GUEST_PASS_SIGNUP_PRIORITY_TRAVEL_TITLE: "For travel and culture",
  GUEST_PASS_SIGNUP_PRIORITY_TRAVEL_COPY: "Independent travel, music, art, history, cultures.",
  GUEST_PASS_SIGNUP_PRIORITY_CONFIDENCE_TITLE: "For general speaking confidence",
  GUEST_PASS_SIGNUP_PRIORITY_CONFIDENCE_COPY: "I want to be confident wherever I speak.",
  GUEST_PASS_SIGNUP_CHALLENGE_QUESTION: "What makes it hard for you to practise speaking?",
  GUEST_PASS_SIGNUP_CHALLENGE_PEOPLE_TITLE: "I don’t have people to practise with",
  GUEST_PASS_SIGNUP_CHALLENGE_PEOPLE_COPY: "I need reliable English-speaking partners",
  GUEST_PASS_SIGNUP_CHALLENGE_SHY_TITLE: "I feel too shy or nervous to speak with anyone",
  GUEST_PASS_SIGNUP_CHALLENGE_SHY_COPY: "I worry about mistakes or being judged",
  GUEST_PASS_SIGNUP_CHALLENGE_TIME_TITLE: "I don’t have a lot of time",
  GUEST_PASS_SIGNUP_CHALLENGE_TIME_COPY: "I haven’t committed to a routine for English",
  GUEST_PASS_SIGNUP_CHALLENGE_TOPICS_TITLE: "I don’t know what to talk about",
  GUEST_PASS_SIGNUP_CHALLENGE_TOPICS_COPY: "I feel better with topics or questions to start",
  GUEST_PASS_SIGNUP_CHALLENGE_NONE_TITLE: "Nothing really",
  GUEST_PASS_SIGNUP_CHALLENGE_NONE_COPY: "I am excited to meet people and speak more",
  GUEST_PASS_SIGNUP_READINESS_QUESTION: "Do you have time to practise speaking English this week?",
  GUEST_PASS_SIGNUP_READINESS_OFTEN_TITLE: "Yes! At least 2–3 times this week",
  GUEST_PASS_SIGNUP_READINESS_OFTEN_COPY: "I’m excited to start speaking at Hey Lady!",
  GUEST_PASS_SIGNUP_READINESS_ONCE_TITLE: "Yes! At least once this week",
  GUEST_PASS_SIGNUP_READINESS_ONCE_COPY: "I am ready to start this week",
  GUEST_PASS_SIGNUP_READINESS_LATER_TITLE: "No, not this week",
  GUEST_PASS_SIGNUP_READINESS_LATER_COPY: "I will apply for my Guest Pass when I have time",
  SIGNUP_READINESS_LATER_COPY: "I will join Hey Lady! when I have time",
  SOCIAL_SIGNUP_READINESS_LATER_COPY: "I won’t have time to practise this week",
  SIGNUP_NOT_READY_TITLE: "Join Hey Lady! later",
  SIGNUP_NOT_READY_COPY:
    "If you can’t make time to practise this week, come back another time to join Hey Lady!",
  SIGNUP_BOOKING_SKIP_LEAD: "Make the most of your time at Hey Lady!",
  GUEST_PASS_SIGNUP_NOT_READY_TITLE: "Start your Guest Pass later",
  GUEST_PASS_SIGNUP_NOT_READY_COPY:
    "There is a limit of one Guest Pass per person. If you can’t make time to practise this week, come back another time to start your Guest Pass.",
  GUEST_PASS_SIGNUP_NOT_READY_STAY: "I will make time this week",
  GUEST_PASS_SIGNUP_NOT_READY_EXIT: "I’ll come back later",
  GUEST_PASS_SIGNUP_ELIGIBLE_EYEBROW: "Great!",
  GUEST_PASS_SIGNUP_ELIGIBLE_TITLE: "You can join Hey Lady!",
  GUEST_PASS_SIGNUP_ELIGIBLE_COPY: "Next, tell us a little more to help us get to know you.",
  GUEST_PASS_SIGNUP_REFLECTION_TITLE: "Great! Let’s get you started!",
  GUEST_PASS_SIGNUP_REFLECTION_SUBTITLE: "Watch this video with Emma before you continue | 1 min",
  GUEST_PASS_SIGNUP_REFLECTION_NEXT: "Next step: Book your first session",
  GUEST_PASS_SIGNUP_REFLECTION_ACTION: "See session times",
  GUEST_PASS_SIGNUP_BOOKING_TITLE: "Book your first session",
  GUEST_PASS_SIGNUP_BOOKING_SUBTITLE:
    "Confirm your time zone, then choose a time.\n☺️ All sessions are friendly and relaxed.\nOur team will be there to welcome and guide you.",
  GUEST_PASS_SIGNUP_BOOKING_TIMEZONE: "Your time zone",
  GUEST_PASS_TIMEZONE_EASTERN: "Eastern Time – US & Canada",
  GUEST_PASS_TIMEZONE_CENTRAL: "Central Time – US & Canada",
  GUEST_PASS_TIMEZONE_MOUNTAIN: "Mountain Time – US & Canada",
  GUEST_PASS_TIMEZONE_PACIFIC: "Pacific Time – US & Canada",
  GUEST_PASS_TIMEZONE_BRASILIA: "Brasília Time",
  GUEST_PASS_TIMEZONE_UNITED_KINGDOM: "United Kingdom Time",
  GUEST_PASS_TIMEZONE_CENTRAL_EUROPE: "Central European Time",
  GUEST_PASS_TIMEZONE_EASTERN_EUROPE: "Eastern European Time",
  GUEST_PASS_TIMEZONE_SOUTH_AFRICA: "South Africa Time",
  GUEST_PASS_TIMEZONE_GULF: "Gulf Standard Time",
  GUEST_PASS_TIMEZONE_INDIA: "India Standard Time",
  GUEST_PASS_TIMEZONE_SINGAPORE: "Singapore Time",
  GUEST_PASS_TIMEZONE_JAPAN: "Japan Standard Time",
  GUEST_PASS_TIMEZONE_AUSTRALIAN_EASTERN: "Australian Eastern Time",
  GUEST_PASS_TIMEZONE_NEW_ZEALAND: "New Zealand Time",
  GUEST_PASS_TIMEZONE_UTC: "UTC",
  GUEST_PASS_SIGNUP_BOOKING_EMPTY:
    "There are no suitable sessions at this time. Please choose another time zone or book after you log in.",
  GUEST_PASS_SIGNUP_BOOKING_LOAD_ERROR:
    "We couldn’t load session times. Please try again or choose a time later.",
  GUEST_PASS_SIGNUP_BOOKING_UPDATE_ERROR: "We couldn’t save your session choice. Please try again.",
  GUEST_PASS_SIGNUP_BOOKING_ACTION: "Book this session",
  GUEST_PASS_SIGNUP_EVENT_NEW_MEMBER: "New Member Event",
  GUEST_PASS_SIGNUP_EVENT_LISTEN_ONLY: "Listening Event",
  GUEST_PASS_SIGNUP_EVENT_PRACTICE: "{durationMinutes} min practice",
  GUEST_PASS_SIGNUP_BOOKING_SKIP: "Choose a time later",
  GUEST_PASS_SIGNUP_BOOKING_SKIP_TITLE: "Book later?",
  GUEST_PASS_SIGNUP_BOOKING_SKIP_LEAD: "Your Guest Pass starts today.",
  GUEST_PASS_SIGNUP_BOOKING_SKIP_COPY:
    "We recommend you book your first session now to make the most of your time.",
  GUEST_PASS_SIGNUP_BOOKING_SKIP_SECOND_COPY:
    "All the sessions here are friendly, relaxed and perfect for new members. Our team will help you feel welcome.",
  GUEST_PASS_SIGNUP_BOOKING_SKIP_CONFIRM: "Choose a session now",
  GUEST_PASS_SIGNUP_BOOKING_SKIP_CANCEL: "I will book later",
  GUEST_PASS_SIGNUP_BOOKING_UNAVAILABLE:
    "That session is no longer available. Please choose another event.",
  GUEST_PASS_SIGNUP_ACCOUNT_TITLE: "Create your account",
  SIGNUP_VERIFICATION_SUBTITLE: "Check your email to complete account creation.",
  SIGNUP_VERIFICATION_PROMPT: "Please enter the code we just sent to",
  SIGNUP_VERIFICATION_DIGIT_LABEL: "Code digit {digit}",
  SIGNUP_VERIFICATION_RESENT: "Code resent! Check your email",
  SIGNUP_VERIFICATION_SEND: "Send code",
  SIGNUP_VERIFICATION_SEND_IN: "Send code in {seconds}s",
  SIGNUP_VERIFICATION_RESEND: "resend code.",
  SIGNUP_VERIFICATION_RESEND_BUTTON: "Resend code",
  SIGNUP_VERIFICATION_RESEND_BUTTON_IN: "Resend code in {seconds}s",
  SIGNUP_VERIFICATION_RESEND_IN: "resend code in {seconds}s",
  SIGNUP_VERIFICATION_VERIFY: "Verify",
  SIGNUP_VERIFICATION_NOT_RECEIVED: "Didn’t receive it? Check your SPAM folder.",
  SIGNUP_VERIFICATION_OTHERWISE: "Otherwise,",
  SIGNUP_VERIFICATION_INCORRECT_EMAIL: "Incorrect email address?",
  SIGNUP_VERIFICATION_CHANGE_EMAIL: "Change it.",
  SIGNUP_RESTART: "Restart signup",
  GUEST_PASS_SIGNUP_ACCOUNT_SUBTITLE: "Choose how you will log in to Hey Lady!",
  GUEST_PASS_SIGNUP_ACCOUNT_ACTION: "Continue",
  GUEST_PASS_SIGNUP_USE_YOUR_EMAIL: "or sign up with email",
  GOOGLE_SIGNUP_NAME_TITLE: "Please type your name in English",
  GOOGLE_SIGNUP_NAME_COPY:
    "Google sent us your name in non-English characters so we need your help!",
  SIGNUP_NAME_IN_ENGLISH_COPY:
    "Other members will see your name, so please write it with English letters.",
  GOOGLE_SIGNUP_NAME_FIRST_NAME: "First Name",
  GOOGLE_SIGNUP_NAME_LAST_NAME: "Last Name",
  GUEST_PASS_SIGNUP_ACCOUNT_ERROR:
    "We couldn’t create your account. Please try again later or contact Member Support at hello@heylady.io.",
  GUEST_PASS_SIGNUP_CONFIRMATION_TITLE: "You’re all set!",
  GUEST_PASS_SIGNUP_CONFIRMATION_SUBTITLE:
    "Review the details and start your Guest Pass. We are ready to welcome you!",
  GUEST_PASS_SIGNUP_CONFIRMATION_INCLUDES: "Your Guest Pass includes:",
  GUEST_PASS_SIGNUP_CONFIRMATION_LIVE_PRACTICE: "for live practice",
  GUEST_PASS_SIGNUP_CONFIRMATION_BOOKED: "Your first session is booked!",
  GUEST_PASS_SIGNUP_CONFIRMATION_BOOKED_AT: "Your first session is booked for {date}",
  GUEST_PASS_SIGNUP_CONFIRMATION_NOT_BOOKED: "You need to book your first session after you log in",
  GUEST_PASS_SIGNUP_CONFIRMATION_JOIN_COPY:
    "<b>Join live practice sessions</b> Friendly small-group sessions hosted by our team. You can attend up to 3.",
  GUEST_PASS_SIGNUP_CONFIRMATION_TABLES_COPY:
    "<b>Join live ‘Coffee Tables’</b> Casual video chats with other members online. No limit – join as many as you like.",
  GUEST_PASS_SIGNUP_CONFIRMATION_CHAT_COPY:
    "<b>Connect via chat</b> to keep talking to the people you meet",
  GUEST_PASS_SIGNUP_CONFIRMATION_MEMBER_COPY:
    "Choose a paid membership after your Guest Pass to unlock unlimited speaking and learning events.",
  GUEST_PASS_SIGNUP_CONFIRMATION_LIMIT: "Limit of one Guest Pass, one time per person.",
  GUEST_PASS_SIGNUP_SUCCESS_TITLE: "You’re in!",
  SIGN_UP_SUCCESS_PERSONAL_TITLE: "Please come in, {firstName}!",
  SIGN_UP_SUCCESS_LOGIN_COPY: "Confirmation of your login details has been emailed to you.",
  SIGN_UP_SUCCESS_PURCHASE_COPY:
    "A copy of your receipt and instructions to log in has been emailed to you.",
  GUEST_PASS_SIGNUP_SUCCESS_WELCOME: "We can’t wait to meet you.",
  GUEST_PASS_SIGNUP_SUCCESS_COPY:
    "We just sent you a link to {email} to enter the Hey Lady! platform.",
  GUEST_PASS_SIGNUP_SUCCESS_HELP: "If you need help at any time, our team is here for you:",
  GUEST_PASS_SIGNUP_SUCCESS_ACTION: "I will check my email now",
  COMMON_WATCH_VIDEO: "Watch video",
  COMMON_EMAIL_NOT_VALID_ERROR: "Please enter a valid email address.",
  COMMON_PASSWORD_MIN_CHAR_ERROR: "Password must be at least 8 characters long.",
  COMMON_NAME_IN_LATIN_LETTERS_ERROR: "Please use English letters.",
  COMMON_USE_YOUR_EMAIL: "or use your email",
  COMMON_YOU: "You",
  COMMON_MONTHLY: "Monthly",
  COMMON_YEARLY: "Yearly",
  COMMON_DELETE: "Delete",
  COMMON_WORDS: "{words} words",
  COMMON_SAVE_DRAFT: "Save as Draft",
  COMMON_CONFIRM_AND_PUBLISH: "Confirm & Publish",
  COMMON_REPORT_ABUSE: "Report abuse",
  COMMON_FEATURED: "Featured",
  COMMON_SEE_MORE: "See more",
  COMMON_SEE_RECOMMENDED_EVENTS: "See recommended events",
  COMMON_ADDITIONAL_MATERIALS: "Additional Materials",
  COMMON_ATTACHMENTS: "Attachments",
  COMMON_RELATED_INTERESTS_TAGS: "Related Interests Tags",
  COMMON_EMPTY_LIST: "There is no content yet.",
  COMMON_MEMBERZINE: "Memberzine",
  COMMON_ADD_REPLY: "Add reply",
  COMMON_CHOOSE_DATE: "Choose date",
  COMMON_ADD_YOUR_COMMENT: "Add your comment...",
  COMMON_AUTHOR: "By {author}",
  COMMON_BACK: "Back",
  COMMON_CANCEL: "Cancel",
  COMMON_SAVE: "Save",
  COMMON_CATEGORY: "Category",
  COMMON_CHAT: "Chat",
  COMMON_MESSAGES: "Messages",
  COMMON_THREADS: "Threads",
  COMMON_CITY: "City",
  COMMON_COMMENTS: "{comments} Comments",
  COMMON_COMING_SOON: "Coming Soon",
  COMMON_COMING_SOON_TITLE: "Coming Soon...",
  COMMON_COMING_SOON_DESCRIPTION:
    "Topic Library is available for members that have been with {title} for more than 12 months.",
  COMMON_CONTACT_US: "Contact us",
  COMMON_EVENTS_ATTENDED: "Events Attended",
  COMMON_PARTICIPATION_TIME: "Participation Time",
  COMMON_COPY_RIGHT: "Copyright © {year} {title} All rights reserved.",
  COMMON_COUNTRY: "Country",
  COMMON_CREATE_EVENT: "Create Event",
  COMMON_DATE: "Date",
  COMMON_DATE_OF_BIRTH: "Date of Birth",
  COMMON_FINISH: "Finish",
  COMMON_DONE: "Done",
  COMMON_DOWNLOAD: "Download",
  COMMON_DRAFT: "Draft",
  COMMON_DROP_PHOTO: "Drop photo",
  COMMON_DURATION: "Duration",
  COMMON_EDIT_EVENT: "Edit",
  COMMON_DETAILS: "Details",
  COMMON_DUPLICATE_EVENT: "Duplicate event",
  COMMON_EMAIL: "Email",
  COMMON_RECURRING: "Recurring",
  COMMON_RECURRENCE: "Recurrence",
  COMMON_ENGLISH_LEVEL: "English level",
  COMMON_ENTER_LINK: "Enter link",
  COMMON_EVENTS: "Events",
  COMMON_EVENTS_HOSTED: "Events hosted",
  COMMON_FAQ: "FAQ",
  COMMON_FIRST_NAME: "First name",
  COMMON_FOLLOW: "Follow",
  COMMON_UNFOLLOW: "Unfollow",
  COMMON_FROM: "From",
  COMMON_FOR: "For",
  COMMON_FULL_NAME: "Full name",
  COMMON_HELP: "Help",
  COMMON_HOME_PAGE: "Home",
  COMMON_LAST_NAME: "Last name",
  COMMON_LEVEL_ADVANCED: "Advanced",
  COMMON_LOCATION: "Location",
  COMMON_LOG_OUT: "Log Out",
  COMMON_MESSAGE: "Message",
  COMMON_MINUTES: "{minutes} min",
  COMMON_MORE_COMMENTS: "More comments",
  COMMON_NAME: "Name",
  COMMON_NATIVE_LANGUAGE: "Native language",
  COMMON_NEW_PASSWORD: "New password",
  COMMON_NEXT: "Next",
  COMMON_GOT_IT: "Got it!",
  COMMON_NEXT_STEP: "Next step",
  COMMON_NO: "No",
  COMMON_OK: "OK",
  COMMON_OR: "or",
  COMMON_NOTIFICATIONS: "Notifications",
  COMMON_NOT_VERIFIED: "Not verified",
  COMMON_OLD_PASSWORD: "Old password",
  COMMON_OTHER_LANGUAGES: "Other languages I speak",
  COMMON_PARTICIPANTS: "Participants",
  COMMON_PASSWORD: "Password",
  COMMON_MEMBERS: "Members",
  COMMON_MY_PROFILE: "My Profile",
  COMMON_PERSONAL_ACCOUNT: "My Account",
  COMMON_PLEASE_WAIT: "Please wait",
  COMMON_PREVIOUS: "Previous",
  COMMON_PRINT: "Print",
  COMMON_REMOVE: "Remove",
  COMMON_REMOVE_PHOTO: "Remove photo",
  COMMON_REPLIES: "{replies} Replies",
  COMMON_REPLY: "Reply",
  COMMON_SEARCH: "Search",
  COMMON_SETTINGS: "Settings",
  COMMON_SUBMIT: "Submit",
  COMMON_SHOW_LESS: "Show less",
  COMMON_SHOW_MORE: "Show more",
  COMMON_START_EVENT: "Start event",
  COMMON_START_DATE: "Start date",
  COMMON_END_DATE: "End date",
  COMMON_START_TIME: "Start time",
  COMMON_END_TIME: "End time",
  COMMON_TODAY: "Today",
  COMMON_SELECT_MONTH: "Select month",
  COMMON_JOIN_EVENT: "Join event",
  COMMON_JOIN: "Join",
  COMMON_KNOCK: "Knock",
  COMMON_STEP: "Step",
  COMMON_UNTIL: "Until",
  COMMON_TIME: "Time",
  COMMON_TIME_NOT_SET: "Time is not set",
  COMMON_TOPICS: "Topics",
  COMMON_UPLOAD_NEW_PHOTO: "Upload New Photo",
  COMMON_UPLOAD_NEW_IMAGE: "Upload New Image",
  COMMON_VERIFIED_MEMBER: "Verified Member",
  COMMON_VIEW_EVENT: "View Event",
  COMMON_VIEW: "View",
  COMMON_VIEW_PROFILE: "View Profile",
  COMMON_WATCH_INTRO_VIDEO: "Watch Intro Video",
  COMMON_YES: "Yes",
  COMMON_PAGE_ERROR_OCCURRED: "An error occurred",
  COMMON_THERE_WAS_A_PROBLEM_PROCESSING_PAYMENT:
    "We were unable to process your payment. If the error persists please <url>Contact Member Support</url>.",
  COMMON_RETRY: "Retry",
  COMMON_PURCHASE_MEMBERSHIP: "Purchase Membership",
  COMMON_DETAILS_PAGE_TOTAL: "Total:",
  COMMON_DETAILS_PAGE_SUBTOTAL: "Subtotal:",
  COMMON_PAGE_NAME: "First name and Last name",
  COMMON_YOUR_EMAIL: "Your Email",
  COMMON_CARDHOLDER_NAME: "Cardholder Name",
  COMMON_CHOOSE_FROM_LIST: "Choose from list",
  COMMON_CARD_NUMBER: "Card Number",
  COMMON_EXPIRATION_DATE: "Expiration Date",
  COMMON_CVV: "CVV",
  COMMON_ZIPCODE: "Zip Code",
  COMMON_ENTER_ZIPCODE: "Enter zip code",
  COMMON_TERMS_AND_CONDITIONS: "By registering I agree to all <url>Terms & Conditions</url>",
  COMMON_CONFIRM_AND_PAY: "Confirm & pay",
  COMMON_NEED_HELP: "Need help? <url>Contact Member Support</url>",
  COMMON_NO_RESULTS: "Sorry, we don't have anything to show you.",
  COMMON_CAN_NOT_SEE: "Sorry, you can't see these until you're verified.",
  COMMON_CLICK_HERE_TO_GET_VERIFIED: "Click <url>here</url> to get verified.",
  COMMON_SORRY: "Sorry!",
  COMMON_PLEASE_UPDATE_FILTERS: "Please make another selection.",
  COMMON_INTERMEDIATE: "Intermediate",
  COMMON_ADVANCED: "Advanced",
  COMMON_ANY_LEVEL: "Any level",
  COMMON_CLOSE: "Close",
  COMMON_NEW_MESSAGES: "You have new messages",
  COMMON_NEW_NOTIFICATIONS: "You have unread notifications",
  COMMON_INACTIVE_MEMBER: "Inactive member",
  COMMON_ARE_YOU_SURE: "Are you sure?",
  COMMON_NOT_REVERSIBLE_ACTION: "This action is not reversible and all data will be lost.",
  COMMON_ARTICLES_WE_THINK_YOU_LL_LOVE: "Articles we think you’ll love!",
  COMMON_FEATURED_ARTICLES: "Featured articles this month",
  COMMON_COMMENT_DELETED: "Comment was deleted successfully",
  COMMON_PROBLEM_DELETING_COMMENT: "There was a problem deleting the comment",
  COMMON_EVENT_DELETED: "Event deleted",
  COMMON_LINKS: "Links",
  COMMON_RELATED_INTERESTS: "Related interests",
  COMMON_LINK_COPIED: "Event link copied to clipboard",
  COMMON_MY_BACKGROUND: "My Background",
  COMMON_MY_NATIONALITY: "Nationality",
  COMMON_START_TYPING: "Please start typing in English",
  COMMON_ADD_EMOJI: "Add emoji",
  COMMON_SEND: "Send",
  COMMON_SPARK: "Spark",
  COMMON_SEND_FEEDBACK: "Send Feedback",
  COMMON_STEP_TOTAL: "Step {step}/{total}",
  COMMON_STEP_NUMBER: "Step {number}",
  COMMON_NEVER_AGAIN: "Never again!",
  COMMON_ABSOLUTELY_WILL: "Absolutely will!",
  COMMON_LETS_START: "Let's Start",
  COMMON_EXIT: "Exit",
  COMMON_CONTINUE_EDITING: "Continue Editing",
  COMMON_BACK_TO_HOME_PAGE: "Back to Home Page",
  COMMON_CONTINUE: "Continue",
  COMMON_FORM_ERRORS_REQUIRED: "This field is required",
  COMMON_FORM_ERRORS_INVALID_EMAIL: "Please provide valid email",
  COMMON_INVITE_A_FRIEND: "Invite a friend",
  COMMON_SUCCESS: "Success!",
  COMMON_CONFIRM: "Confirm",
  COMMON_FILTERS: "Filters",
  COMMON_CUSTOMISE_FILTERS: "Customise Filters",
  COMMON_FILTER_APPLIED: "Filter Applied",
  COMMON_FILTERS_APPLIED: "Filters Applied",
  COMMON_FILTERS_AVAILABILITY: "Availability",
  COMMON_FILTERS_MEMBERS: "Members",
  COMMON_FILTERS_OCCUPATION: "Occupation",
  COMMON_FILTERS_PERSONAL_INTERESTS: "Personal Interests",
  COMMON_FILTERS_ENGLISH_INTERESTS: "English Interests",
  COMMON_FILTERS_ENGLISH_LEVEL: "English Level",
  COMMON_CLEAR_FILTER: "Clear Filter",
  COMMON_CLEAR_ALL: "Clear All",
  COMMON_SHOW_RESULTS: "Show results",
  COMMON_CHOOSE_AN_EVENT: "Choose an event",
  COMMON_NO_RESULTS_FOUND: "No results found",
  COMMON_SHARE_EVENT: "Share Event",
  COMMON_SHARE: "Share",
  COMMON_MEMBER_EVENT: "Member Event",
  COMMON_LEARN_MORE: "Learn more",
  COMMON_GO_TO_MY_PROFILE: "Go to my Profile",
  COMMON_LIVE_TABLES: "Live Tables",
  COMMON_GET_VERIFIED: "Get verified",
  COMMON_MAYBE_LATER: "Maybe Later",
  COMMON_VIEW_EVENTS: "View Events",
  COMMON_UPGRADE_NOW: "Upgrade now",
  COMMON_EDIT: "Edit",
  COMMON_DESCRIPTION: "Description",
  COMMON_ACCEPT: "Accept",
  COMMON_DECLINE: "Decline",
  DEACTIVATE_PAGE_CANT_JUSTIFY: "I can't justify the time needed to participate",
  DEACTIVATE_PAGE_ENGLISH_LEVEL: "My English level isn't high enough",
  DEACTIVATE_PAGE_EXPENSIVE: "Expensive subscription",
  DEACTIVATE_PAGE_FINANCIAL: "My financial situation has changed",
  DEACTIVATE_PAGE_HOPE_TO_SEE_BACK:
    "We are very sorry to know that you decided to leave our community. Hope to see you back very soon. In case you have any question you can always contact our support team.",
  DEACTIVATE_PAGE_I_WANT_BECAUSE: "I want to delete my account because...",
  DEACTIVATE_PAGE_NOT_INTERESTED: "Not interested in learning English any more",
  DEACTIVATE_PAGE_NOT_USEFUL: "Content is not useful",
  DEACTIVATE_PAGE_OTHER_REASON: "Other reason",
  DEACTIVATE_PAGE_PRACTICE: "I couldn't find someone to practise with",
  DEACTIVATE_PAGE_HELP_US_IMPROVE: "Help us improve by offering feedback about your decision:",
  DEACTIVATE_PAGE_ARE_YOU_SURE_YOU_WANT_TO_LEAVE: "Are you sure you want to leave?",
  DEACTIVATE_PAGE_DELETING_YOUR_ACCOUNT:
    "Deleting your account means that you want to leave our community permanently. We will remove your account and all information.",
  DEACTIVATE_PAGE_YOU_HAVE_DECIDED_TO_LEAVE:
    "If you have decided to leave, we'll be sad to see you go!",
  DEACTIVATE_PAGE_YOUR_ACCOUNT: "Your account has been deleted",
  ENUM_A1: "Beginner (A1/A2)",
  ENUM_B1: "Intermediate (B1)",
  ENUM_B2: "Upper Intermediate (B2)",
  ENUM_C1: "Advanced (C1)",
  ENUM_C2: "Proficient (C2)",
  ENUM_SUNDAY: "Sun",
  ENUM_MONDAY: "Mon",
  ENUM_TUESDAY: "Tue",
  ENUM_WEDNESDAY: "Wed",
  ENUM_THURSDAY: "Thu",
  ENUM_FRIDAY: "Fri",
  ENUM_SATURDAY: "Sat",
  ENUM_DAILY: "Daily",
  ENUM_ON_DATE: "On date",
  ENUM_AFTER: "After",
  ENUM_NEVER: "Never",
  ENUM_DAYS: "Days",
  ENUM_WEEKS: "Weeks",
  ENUM_MONTHS: "Months",
  ENUM_SELF: "I will host the event",
  ENUM_COHOST: "I will co-host the event",
  ENUM_SOMEBODY_ELSE: "Somebody else will host the event",
  ENUM_WEEKLY_ON_THURSDAY: "Weekly on Thursday",
  ENUM_MONTHLY_ON_THE_FOURTH_THURSDAY: "Monthly on the fourth Thursday",
  ENUM_MONTHLY_ON_THE_LAST_THURSDAY: "Monthly on the last Thursday",
  ENUM_ANUALLY: "Annually on December 19",
  ENUM_EVERY_WEEKDAY: "Every weekday (Monday to Friday)",
  ENUM_GROUP_EVENT: "Group Event",
  ENUM_USER_BADGE_NONE: "None",
  ENUM_USER_BADGE_INACTIVE_MEMBER: "Inactive Member",
  ENUM_USER_BADGE_LITTLE_SISTER: "Little sister",
  ENUM_USER_BADGE_MEMBER: "Member",
  ENUM_USER_BADGE_BIG_SISTER: "Big sister",
  ENUM_USER_BADGE_ENGLISH_COACH: "English Coach",
  ENUM_USER_BADGE_COMMUNITY_SUCCESS: "Community Success",
  ENUM_USER_BADGE_FOUNDER: "Founder",
  ENUM_USER_BADGE_MEMBER_SUPPORT: "Member support",
  ENUM_USER_BADGE_TECHNICAL_SUPPORT: "Technical Support",
  ENUM_USER_BADGE_GUEST: "Guest",
  ENUM_GRAMMAR_SPOT: "Grammar Spot",
  ENUM_OFFICE_HOURS: "Office Hours",
  ENUM_CONVERSATIONS_OVER_COFFEE: "Conversations Over Coffee",
  ENUM_INTERVIEW: "Interview",
  ENUM_CUSTOM: "Custom",
  ENUM_COACH_CONVERSATIONS: "Coach Conversations",
  ENUM_COACH_WORKSHOP: "Coach Workshop",
  ENUM_FIFTEEN_MINUTES: "15 Minutes Daily Practice",
  ENUM_ONE_TO_ONE: "One to One",
  ENUM_IN_PERSON: "In Person",
  ENUM_NEW_MEMBER_WELCOME: "New Member Welcome",
  ENUM_SPEAKING_EVENT: "Speaking Event",
  ENUM_STUDY_EVENT: "Study Event",
  ENUM_CASUAL_CONVERSATION: "Casual Conversation",
  ENUM_STUDY_GROUP: "Study Group",
  STUDY_AND_LEARN: "Study & Learn",
  ENUM_DEEP_DIVE: "Deep Dive",
  ENUM_STUDY_AND_LEARN: "Study and Learn",
  ENUM_LISTEN_ONLY: "Listen Only",
  EVENT_TYPE_CONVERSATION_STARTER: "Conversation Starter",
  EVENT_TYPE_DEEP_DIVE_CONVERSATION: "Deep Dive Conversation",
  ENUM_OVERVIEW: "Overview",
  ENUM_VOCABULARY: "Vocabulary",
  ENUM_INTEREST_ANIMALS_AND_WILDLIFE: "Animals and wildlife",
  ENUM_INTEREST_ARTS_AND_CRAFTS: "Arts and crafts",
  ENUM_INTEREST_BEAUTY_AND_FASHION: "Beauty and fashion",
  ENUM_INTEREST_BUSINESS_AND_ENTREPRENEURSHIP: "Business and Entrepreneurship",
  ENUM_INTEREST_CAREERS_AND_PROFESSIONAL_DEVELOPMENT: "Careers and professional development",
  ENUM_INTEREST_DIFFERENT_CULTURES: "Different cultures",
  ENUM_INTEREST_DESIGN: "Design",
  ENUM_INTEREST_ECONOMICS: "Economics",
  ENUM_INTEREST_IELTS: "IELTS",
  ENUM_INTEREST_ENVIRONMENTAL_ISSUES: "Environmental issues",
  ENUM_INTEREST_EQUALITY: "Equality",
  ENUM_INTEREST_FAMILY_AND_MOTHERHOOD: "Family and motherhood",
  ENUM_INTEREST_FEMINISM_AND_EMPOWERMENT: "Feminism and empowerment",
  ENUM_INTEREST_FOOD_AND_COOKING: "Food and cooking",
  ENUM_INTEREST_GAMES: "Games",
  ENUM_INTEREST_GOALS_SETTING_AND_SUCCESS: "Goals setting and success",
  ENUM_INTEREST_HEALTH_AND_WELLNESS: "Health and wellness",
  ENUM_INTEREST_HIKING: "Hiking",
  ENUM_INTEREST_HISTORY: "History",
  ENUM_INTEREST_HOME_AND_GARDENING: "Home and gardening",
  ENUM_INTEREST_LANGUAGES: "Languages",
  ENUM_INTEREST_LEADERSHIP: "Leadership",
  ENUM_INTEREST_LIVING_ABROAD: "Living abroad",
  ENUM_INTEREST_LOVE_AND_RELATIONSHIPS: "Love and relationships",
  ENUM_INTEREST_MOVIES_AND_TV_SHOWS: "Movies and TV shows",
  ENUM_INTEREST_MUSIC_AND_DANCE: "Music and dance",
  ENUM_INTEREST_NATURE_AND_THE_ENVIRONMENT: "Nature and the environment",
  ENUM_INTEREST_PERSONAL_DEVELOPMENT: "Personal development",
  ENUM_INTEREST_PHOTOGRAPHY: "Photography",
  ENUM_INTEREST_POLITICS: "Politics",
  ENUM_INTEREST_PSYCHOLOGY: "Psychology",
  ENUM_INTEREST_READING: "Reading",
  ENUM_INTEREST_SCIENCE_AND_TECHNOLOGY: "Science and technology",
  ENUM_INTEREST_SPIRITUALITY: "Spirituality",
  ENUM_INTEREST_SPORTS: "Sports",
  ENUM_INTEREST_SUSTAINABLE_LIVING: "Sustainable living",
  ENUM_INTEREST_THEATRE_AND_PERFORMANCE: "Theatre and performance",
  ENUM_INTEREST_TRAVEL: "Travel",
  ENUM_INTEREST_VIDEO_GAMES: "Video games",
  ENUM_INTEREST_VOLUNTEERING_AND_CHARITY: "Volunteering and charity",
  ENUM_INTEREST_WRITING: "Writing",
  ENUM_ENGLISH_SKILL_GIVING_A_PRESENTATION: "Give a presentation or speak in public",
  ENUM_ENGLISH_SKILL_INTERVIEW_OR_BE_INTERVIEWED: "Interview or be interviewed",
  ENUM_ENGLISH_SKILL_INTRODUCE_MYSELF: "Introduce myself",
  ENUM_ENGLISH_SKILL_MEET_NEW_PEOPLE: "Meet new people using English",
  ENUM_ENGLISH_SKILL_NEGOTIATE_AND_DEBATE: "Negotiate & Debate",
  ENUM_ENGLISH_SKILL_PASS_AN_ENGLISH_EXAM: "Pass an English exam",
  ENUM_ENGLISH_SKILL_PERSONAL_NETWORKING: "Personal networking",
  ENUM_ENGLISH_SKILL_PRONUNCIATION: "Pronunciation",
  ENUM_ENGLISH_SKILL_SPEAK_CONFIDENTLY_AT_WORK: "Speak confidently at work",
  ENUM_ENGLISH_SKILL_THINK_IN_ENGLISH: "Think in English",
  ENUM_ENGLISH_SKILL_UNDERSTAND_MOVIES_AND_MUSIC: "Understand movies & music",
  ENUM_ENGLISH_SKILL_UNDERSTAND_NATIVE_SPEAKERS: "Understand native speakers",
  ENUM_ENGLISH_SKILL_WRITE_CREATIVELY: "Write creatively",
  ENUM_ENGLISH_SKILL_WRITE_PROFESSIONALLY: "Writing professionally",
  ENUM_NONE: "None",
  ENUM_MEMBER: "Member",
  ENUM_BIG_SISTER: "Big Sister",
  ENUM_COMMUNITY_SUCCESS: "Community Success",
  ENUM_CURIOUS_LADY: "Curious Lady",
  ENUM_CUSTOMER_SUPPORT: "Customer Support",
  ENUM_ENGLISH_COACH: "English Coach",
  ENUM_FOUNDER: "Founder",
  ENUM_PRIVATE_EVENT: "Private",
  ENUM_PUBLIC_EVENT: "Public",
  ENUM_TECHNICAL_SUPPORT: "Technical Support",
  ENUM_LITTLE_SISTERS: "Little Sisters",
  ENUM_LITTLE_SISTER: "Little Sister",
  ENUM_UNVERIFIED: "Unverified",
  ENUM_ZERO_TO_ONE: "Little sisters",
  ENUM_ONE_TO_THREE: "1-3 months",
  ENUM_THREE_TO_TWELVE: "3-12 months",
  ENUM_THREE_TO_SIX_MONTH: "3-6 month",
  ENUM_SIX_TO_TWELVE_MONTH: "6-12 month",
  ENUM_MORE_THAN_TWELVE_MONTHS: "12 months+",
  ENUM_EVENT_DURATION_FILTER_15: "15 minutes",
  ENUM_EVENT_DURATION_FILTER_30: "30 minutes",
  ENUM_EVENT_DURATION_FILTER_45: "45 minutes",
  ENUM_EVENT_DURATION_FILTER_60: "1 hour",
  ENUM_EVENT_DURATION_FILTER_90: "1,5 hours",
  ENUM_EVENT_DURATION_FILTER_120: "2 hours and more",
  ENUM_ART_AND_CULTURE: "Art and Culture",
  ENUM_CAREER_WOMEN: "Career Women",
  ENUM_COMMUNITY: "Community",
  ENUM_FAMILY_AND_FRIENDS: "Family and Friends",
  ENUM_FOOD_AND_TRADITIONS: "Food and Traditions",
  ENUM_HEALTH_AND_WELLNESS: "Health and Wellness",
  ENUM_PERSONAL_DEVELOPMENT: "Personal Development",
  ENUM_SCIENCE_AND_TECHNOLOGY: "Science and Technology",
  ENUM_THE_ENVIRONMENT: "The Environment",
  ENUM_TRAVEL: "Travel",
  ENUM_ACCOMMODATION_AND_HOSPITALITY: "Accommodation & Hospitality",
  ENUM_ADMINISTRATIVE_AND_SUPPORT_SERVICES: "Administrative and Support Services",
  ENUM_DESIGN_AND_CONSTRUCTION: "Design & Construction",
  ENUM_CONSUMER_SERVICES: "Consumer Services",
  ENUM_EDUCATION: "Education",
  ENUM_ARTS_AND_ENTERTAINMENT: "Arts & Entertainment",
  ENUM_ANIMALS_HORTICULTURE_FORESTRY: "Animals, Horticulture, Forestry",
  ENUM_FINANCIAL_SERVICES: "Financial Services",
  ENUM_GOVERNMENT_ADMINISTRATION: "Government Administration",
  ENUM_HOSPITAL_AND_MEDICAL: "Hospital & Medical",
  ENUM_HEALTH_AND_WELLBEING: "Health & Wellbeing",
  ENUM_MANUFACTURING: "Manufacturing",
  ENUM_OIL_GAS_AND_MINING: "Oil, Gas, and Mining",
  ENUM_PROFESSIONAL_SERVICES: "Professional Services",
  ENUM_REAL_ESTATE: "Real Estate",
  ENUM_RETAIL: "Retail",
  ENUM_SCIENCE_AND_RESEARCH: "Science & Research",
  ENUM_SPORTS_AND_RECREATION: "Sports & Recreation",
  ENUM_TECHNOLOGY_INFORMATION_AND_MEDIA: "Technology, Information and Media",
  ENUM_TRANSPORTATION: "Transportation",
  ENUM_HOME_CARE: "Home Care",
  ENUM_RETIRED: "Retired",
  ENUM_STUDENTS: "Students",
  ENUM_ASSISTANT_COOK: "Assistant Cook",
  ENUM_BAKER: "Baker",
  ENUM_BAR_MANAGER: "Bar Manager",
  ENUM_BAR_STAFF: "Bar Staff",
  ENUM_CAFE_OWNER: "Cafe Owner",
  ENUM_CAFE_STAFF: "Cafe Staff",
  ENUM_CATERER: "Caterer",
  ENUM_CHEF: "Chef",
  ENUM_COOK: "Cook",
  ENUM_GUEST_HOUSE_OWNER: "Guest House Owner",
  ENUM_HOSTESS: "Hostess",
  ENUM_HOTELIER: "Hotelier",
  ENUM_HOTEL_WORKER: "Hotel Worker",
  ENUM_KITCHEN_HAND: "Kitchen Hand",
  ENUM_LANDLORD: "Landlord",
  ENUM_PASTRY_CHEF: "Pastry Chef",
  ENUM_RESTAURANT_MANAGER: "Restaurant Manager",
  ENUM_RESTAURATEUR: "Restaurateur",
  ENUM_WAITRESS: "Waitress",
  ENUM_ACCOUNTS_MANAGER: "Accounts Manager",
  ENUM_ADMINISTRATION_ASSISTANT: "Administration Assistant",
  ENUM_ADMINISTRATOR: "Administrator",
  ENUM_ASSISTANT_MANAGER: "Assistant Manager",
  ENUM_CLAIMS_ASSESSOR: "Claims Assessor",
  ENUM_CLERK: "Clerk",
  ENUM_LEGAL_ASSISTANT: "Legal Assistant",
  ENUM_LEGAL_SECRETARY: "Legal Secretary",
  ENUM_OFFICE_MANAGER: "Office Manager",
  ENUM_PAYROLL_ASSISTANT: "Payroll Assistant",
  ENUM_PAYROLL_MANAGER: "Payroll Manager",
  ENUM_RECEPTIONIST: "Receptionist",
  ENUM_REGISTRAR: "Registrar",
  ENUM_SALES_ADMINISTRATOR: "Sales Administrator",
  ENUM_SECRETARY: "Secretary",
  ENUM_SUPERVISOR: "Supervisor",
  ENUM_TRAINING_ASSISTANT: "Training Assistant",
  ENUM_TRAINING_MANAGER: "Training Manager",
  ENUM_VIRTUAL_ASSISTANT: "Virtual Assistant",
  ENUM_ARBORIST: "Arborist",
  ENUM_BREEDER: "Breeder",
  ENUM_FARMER: "Farmer",
  ENUM_FOREST_RANGER: "Forest Ranger",
  ENUM_GARDEN_DESIGNER: "Garden Designer",
  ENUM_GARDENER: "Gardener",
  ENUM_HORSE_BREEDER: "Horse Breeder",
  ENUM_HORSE_TRAINER: "Horse Trainer",
  ENUM_HORTICULTURALIST: "Horticulturalist",
  ENUM_LANDSCAPER: "Landscaper",
  ENUM_NURSERY_WORKER: "Nursery Worker",
  ENUM_VETERINARIAN: "Veterinarian",
  ENUM_VETERINARY_SURGEON: "Veterinary Surgeon",
  ENUM_ZOO_KEEPER: "Zoo Keeper",
  ENUM_ACTOR: "Actor",
  ENUM_ACTRESS: "Actress",
  ENUM_ART_CRITIC: "Art Critic",
  ENUM_ART_HISTORIAN: "Art Historian",
  ENUM_ARTIST: "Artist",
  ENUM_BROADCASTER: "Broadcaster",
  ENUM_CAMERAWOMAN: "Camerawoman",
  ENUM_CARTOONIST: "Cartoonist",
  ENUM_CHOREOGRAPHER: "Choreographer",
  ENUM_COMEDIAN: "Comedian",
  ENUM_ENTERTAINER: "Entertainer",
  ENUM_FASHION_DESIGNER: "Fashion Designer",
  ENUM_ILLUSTRATOR: "Illustrator",
  ENUM_JEWELLERY_MAKER: "Jewellery Maker",
  ENUM_MAGICIAN: "Magician",
  ENUM_MUSICIAN: "Musician",
  ENUM_OPERA_SINGER: "Opera Singer",
  ENUM_PHOTOGRAPHER: "Photographer",
  ENUM_RADIO_PRESENTER: "Radio Presenter",
  ENUM_SCREEN_WRITER: "Screen Writer",
  ENUM_SCRIPT_WRITER: "Script Writer",
  ENUM_SCULPTOR: "Sculptor",
  ENUM_SINGER: "Singer",
  ENUM_STAGE_MANAGER: "Stage Manager",
  ENUM_TATTOOIST: "Tattooist",
  ENUM_THEATRE_MANAGER: "Theatre Manager",
  ENUM_TV_PRESENTER: "TV Presenter",
  ENUM_WRITER: "Writer",
  ENUM_AUTO_ELECTRICIAN: "Auto Electrician",
  ENUM_BAGGAGE_HANDLER: "Baggage Handler",
  ENUM_BARBER: "Barber",
  ENUM_BEAUTICIAN: "Beautician",
  ENUM_BEAUTY_THERAPIST: "Beauty Therapist",
  ENUM_BOOK_BINDER: "Book Binder",
  ENUM_BUTCHER: "Butcher",
  ENUM_CARPET_CLEANER: "Carpet Cleaner",
  ENUM_CASHIER: "Cashier",
  ENUM_CHAPLAIN: "Chaplain",
  ENUM_CHARITY_WORKER: "Charity Worker",
  ENUM_CHEMIST: "Chemist",
  ENUM_CLEANER: "Cleaner",
  ENUM_DOG_WALKER: "Dog Walker",
  ENUM_HAIRDRESSER: "Hairdresser",
  ENUM_HOUSEKEEPER: "Housekeeper",
  ENUM_LAUNDRY_STAFF: "Laundry Staff",
  ENUM_LIBRARIAN: "Librarian",
  ENUM_LIFEGUARD: "Lifeguard",
  ENUM_LIFT_ATTENDANT: "Lift Attendant",
  ENUM_MAKE_UP_ARTIST: "Make Up Artist",
  ENUM_MECHANIC: "Mechanic",
  ENUM_METER_READER: "Meter Reader",
  ENUM_NEWSAGENT: "Newsagent",
  ENUM_OUTREACH_WORKER: "Outreach Worker",
  ENUM_PET_MINDER: "Pet Minder",
  ENUM_PRIEST: "Priest",
  ENUM_PRINTER: "Printer",
  ENUM_SECURITY_GUARD: "Security Guard",
  ENUM_TELEMARKETER: "Telemarketer",
  ENUM_TEXTILE_CONSULTANT: "Textile Consultant",
  ENUM_TOUR_GUIDE: "Tour Guide",
  ENUM_ARCHITECT: "Architect",
  ENUM_BUILDER: "Builder",
  ENUM_BUILDING_ENGINEER: "Building Engineer",
  ENUM_BUILDING_SURVEYOR: "Building Surveyor",
  ENUM_CABINET_MAKER: "Cabinet Maker",
  ENUM_CARPENTER: "Carpenter",
  ENUM_CIVIL_ENGINEER: "Civil Engineer",
  ENUM_ENGINEER: "Engineer",
  ENUM_INTERIOR_DECORATOR: "Interior Decorator",
  ENUM_INTERIOR_DESIGNER: "Interior Designer",
  ENUM_LANDSCAPE_ARCHITECT: "Landscape Architect",
  ENUM_LIGHTING_DESIGNER: "Lighting Designer",
  ENUM_PAINTER: "Painter",
  ENUM_QUANTITY_SURVEYOR: "Quantity Surveyor",
  ENUM_TRADESPERSON: "Tradesperson",
  ENUM_TRADES_PERSON: "Trades Person",
  ENUM_ASSISTANT_TEACHER: "Assistant Teacher",
  ENUM_CHILDCARE_WORKER: "Childcare Worker",
  ENUM_ENGLISH_TEACHER: "English Teacher",
  ENUM_HIGH_SCHOOL_TEACHER: "High School Teacher",
  ENUM_INSTRUCTOR: "Instructor",
  ENUM_LECTURER: "Lecturer",
  ENUM_PRE_SCHOOL_TEACHER: "Pre-School Teacher",
  ENUM_PRIMARY_SCHOOL_TEACHER: "Primary School Teacher",
  ENUM_PRINCIPAL: "Principal",
  ENUM_TEACHER: "Teacher",
  ENUM_TEACHERS_ASSISTANT: "Teachers Assistant",
  ENUM_TUTOR: "Tutor",
  ENUM_VICE_PRINCIPAL: "Vice-Principal",
  ENUM_ACCOUNTANT: "Accountant",
  ENUM_BANK_MANAGER: "Bank Manager",
  ENUM_BOOKKEEPER: "Bookkeeper",
  ENUM_ENTREPRENEUR: "Entrepreneur",
  ENUM_INSTRUCTIONAL_DESIGNER: "Instructional Designer",
  ENUM_FINANCIAL_TRADER: "Financial Trader",
  ENUM_INVESTMENT_ADVISOR: "Investment Advisor",
  ENUM_INVESTMENT_MANAGER: "Investment Manager",
  ENUM_INVESTOR: "Investor",
  ENUM_LOANS_MANAGER: "Loans Manager",
  ENUM_MERCHANT_BANKER: "Merchant Banker",
  ENUM_TRADER: "Trader",
  ENUM_TREASURER: "Treasurer",
  ENUM_CAREERS_ADVISOR: "Careers Advisor",
  ENUM_COMMUNITY_WORKER: "Community Worker",
  ENUM_COUNCILLOR: "Councillor",
  ENUM_DIPLOMAT: "Diplomat",
  ENUM_FIREWOMAN: "Firewoman",
  ENUM_HEALTH_ADVISOR: "Health Advisor",
  ENUM_HOUSING_OFFICER: "Housing Officer",
  ENUM_IMMIGRATION_OFFICER: "Immigration Officer",
  ENUM_INVESTIGATOR: "Investigator",
  ENUM_JUDGE: "Judge",
  ENUM_LOCAL_GOVERNMENT: "Local Government",
  ENUM_MAGISTRATE: "Magistrate",
  ENUM_MILITARY_PERSONNEL: "Military Personnel",
  ENUM_PARKING_ENFORCEMENT: "Parking Enforcement",
  ENUM_POLICE_OFFICER: "Police Officer",
  ENUM_POLICY_MAKER: "Policy Maker",
  ENUM_POLITICIAN: "Politician",
  ENUM_POSTWOMAN: "Postwoman",
  ENUM_PUBLIC_RELATIONS_OFFICER: "Public Relations Officer",
  ENUM_SOCIAL_WORKER: "Social Worker",
  ENUM_STATUTORY_PLANNER: "Statutory Planner",
  ENUM_TAX_OFFICER: "Tax Officer",
  ENUM_TAX_ADVISOR: "Tax Advisor",
  ENUM_TOWN_CLERK: "Town Clerk",
  ENUM_TOWN_PLANNER: "Town Planner",
  ENUM_YOUTH_WORKER: "Youth Worker",
  ENUM_ACUPUNCTURIST: "Acupuncturist",
  ENUM_ALTERNATIVE_MEDICINE_CONSULTANT: "Alternative Medicine Consultant",
  ENUM_AROMATHERAPIST: "Aromatherapist",
  ENUM_CHIROPRACTOR: "Chiropractor",
  ENUM_HERBALIST: "Herbalist",
  ENUM_HOMEOPATH: "Homeopath",
  ENUM_HYPNOTHERAPIST: "Hypnotherapist",
  ENUM_MASSAGE_THERAPIST: "Massage Therapist",
  ENUM_MEDITATION_TEACHER: "Meditation Teacher",
  ENUM_MINDFULNESS_COACH: "Mindfulness Coach",
  ENUM_NATUROPATH: "Naturopath",
  ENUM_NUTRITIONIST: "Nutritionist",
  ENUM_REFLEXOLOGIST: "Reflexologist",
  ENUM_SPEECH_THERAPIST: "Speech Therapist",
  ENUM_YOGA_TEACHER: "Yoga Teacher",
  ENUM_AU_PAIR: "Au Pair",
  ENUM_FULL_TIME_MUM: "Full Time Mum",
  ENUM_HOUSEWIFE: "Housewife",
  ENUM_NANNY: "Nanny",
  ENUM_AMBULANCE_DRIVER: "Ambulance Driver",
  ENUM_ANAESTHETIST: "Anaesthetist",
  ENUM_ASSISTANT_NURSE: "Assistant Nurse",
  ENUM_AUDIOLOGIST: "Audiologist",
  ENUM_CARE_ASSISTANT: "Care Assistant",
  ENUM_CHIROPODIST: "Chiropodist",
  ENUM_DENTIST: "Dentist",
  ENUM_DIETITIAN: "Dietitian",
  ENUM_DOCTOR: "Doctor",
  ENUM_GENERAL_PRACTITIONER: "General Practitioner",
  ENUM_GYNAECOLOGIST: "Gynaecologist",
  ENUM_HEALTH_CARE_ASSISTANT: "Health Care Assistant",
  ENUM_HOSPITAL_MANAGER: "Hospital Manager",
  ENUM_HOSPITAL_WARDEN: "Hospital Warden",
  ENUM_HOSPITAL_WORKER: "Hospital Worker",
  ENUM_MIDWIFE: "Midwife",
  ENUM_NEUROLOGIST: "Neurologist",
  ENUM_NURSE: "Nurse",
  ENUM_NURSERY_ASSISTANT: "Nursery Assistant",
  ENUM_OPTICIAN: "Optician",
  ENUM_OPTOMETRIST: "Optometrist",
  ENUM_ORTHODONTIST: "Orthodontist",
  ENUM_OSTEOPATH: "Osteopath",
  ENUM_PAEDIATRICIAN: "Paediatrician",
  ENUM_PARAMEDIC: "Paramedic",
  ENUM_PATHOLOGIST: "Pathologist",
  ENUM_PHARMACIST: "Pharmacist",
  ENUM_PODIATRIST: "Podiatrist",
  ENUM_PSYCHIATRIST: "Psychiatrist",
  ENUM_PSYCHOLOGIST: "Psychologist",
  ENUM_RADIOLOGIST: "Radiologist",
  ENUM_FACTORY_WORKER: "Factory Worker",
  ENUM_MANUFACTURER: "Manufacturer",
  ENUM_MILLINER: "Milliner",
  ENUM_POTTER: "Potter",
  ENUM_QUALITY_ASSURANCE_MANAGER: "Quality Assurance Manager",
  ENUM_RUG_MAKER: "Rug Maker",
  ENUM_SCREEN_PRINTER: "Screen Printer",
  ENUM_SEAMSTRESS: "Seamstress",
  ENUM_SHOE_MAKER: "Shoe Maker",
  ENUM_WEAVER: "Weaver",
  ENUM_MINING_CONSULTANT: "Mining Consultant",
  ENUM_MINING_ENGINEER: "Mining Engineer",
  ENUM_ADVERTISING_MANAGER: "Advertising Manager",
  ENUM_ANALYST: "Analyst",
  ENUM_BARRISTER: "Barrister",
  ENUM_BUSINESS_CONSULTANT: "Business Consultant",
  ENUM_BUSINESS_OWNER: "Business Owner",
  ENUM_CHIEF_EXECUTIVE_OFFICER: "Chief Executive Officer",
  ENUM_CHIEF_OPERATIONS_OFFICER: "Chief Operations Officer",
  ENUM_CONSULTANT: "Consultant",
  ENUM_ECONOMIST: "Economist",
  ENUM_EXECUTIVE_DIRECTOR: "Executive Director",
  ENUM_EXECUTIVE_MANAGER: "Executive Manager",
  ENUM_GENERAL_MANAGER: "General Manager",
  ENUM_INSURANCE_CONSULTANT: "Insurance Consultant",
  ENUM_INTERPRETER: "Interpreter",
  ENUM_JOURNALIST: "Journalist",
  ENUM_LAW_CLERK: "Law Clerk",
  ENUM_LAWYER: "Lawyer",
  ENUM_LEGAL_ADVISOR: "Legal Advisor",
  ENUM_MARKETING_DIRECTOR: "Marketing Director",
  ENUM_OPERATIONS_MANAGER: "Operations Manager",
  ENUM_PLANNER: "Planner",
  ENUM_PROJECT_MANAGER: "Project Manager",
  ENUM_RECRUITMENT_CONSULTANT: "Recruitment Consultant",
  ENUM_SALES_MANAGER: "Sales Manager",
  ENUM_CARETAKER: "Caretaker",
  ENUM_MORTGAGE_BROKER: "Mortgage Broker",
  ENUM_PROPERTY_BUYER: "Property Buyer",
  ENUM_PROPERTY_DEVELOPER: "Property Developer",
  ENUM_PROPERTY_MANAGER: "Property Manager",
  ENUM_PROPERTY_VALUER: "Property Valuer",
  ENUM_REAL_ESTATE_AGENT: "Real Estate Agent",
  ENUM_ANTIQUE_DEALER: "Antique Dealer",
  ENUM_BOOK_SELLER: "Book Seller",
  ENUM_CAR_DEALER: "Car Dealer",
  ENUM_FLORIST: "Florist",
  ENUM_FURNITURE_DEALER: "Furniture Dealer",
  ENUM_GALLERY_OWNER: "Gallery Owner",
  ENUM_GROCER: "Grocer",
  ENUM_JEWELLER: "Jeweller",
  ENUM_PURCHASING_MANAGER: "Purchasing Manager",
  ENUM_RETAIL_ASSISTANT: "Retail Assistant",
  ENUM_SALES_ASSISTANT: "Sales Assistant",
  ENUM_SHOP_ASSISTANT: "Shop Assistant",
  ENUM_SHOP_KEEPER: "Shop Keeper",
  ENUM_SUPERMARKET_ASSISTANT: "Supermarket Assistant",
  ENUM_TICKET_AGENT: "Ticket Agent",
  ENUM_TRAVEL_AGENT: "Travel Agent",
  ENUM_ANTHROPOLOGIST: "Anthropologist",
  ENUM_ARCHAEOLOGIST: "Archaeologist",
  ENUM_ASTROLOGER: "Astrologer",
  ENUM_ASTRONOMER: "Astronomer",
  ENUM_BIOCHEMIST: "Biochemist",
  ENUM_BIOLOGIST: "Biologist",
  ENUM_BOTANIST: "Botanist",
  ENUM_CARTOGRAPHER: "Cartographer",
  ENUM_GENEALOGIST: "Genealogist",
  ENUM_GEOLOGIST: "Geologist",
  ENUM_GEOPHYSICIST: "Geophysicist",
  ENUM_HISTORIAN: "Historian",
  ENUM_INDUSTRIAL_CHEMIST: "Industrial Chemist",
  ENUM_INVENTOR: "Inventor",
  ENUM_LABORATORY_ANALYST: "Laboratory Analyst",
  ENUM_LINGUIST: "Linguist",
  ENUM_METALLURGIST: "Metallurgist",
  ENUM_METEOROLOGIST: "Meteorologist",
  ENUM_MICROBIOLOGIST: "Microbiologist",
  ENUM_NUCLEAR_SCIENTIST: "Nuclear Scientist",
  ENUM_PHYSICIST: "Physicist",
  ENUM_RESEARCHER: "Researcher",
  ENUM_SCIENTIST: "Scientist",
  ENUM_TAXIDERMIST: "Taxidermist",
  ENUM_ZOOLOGIST: "Zoologist",
  ENUM_FITNESS_COACH: "Fitness Coach",
  ENUM_GYM_INSTRUCTOR: "Gym Instructor",
  ENUM_OUTDOOR_EDUCATION_STAFF: "Outdoor Education Staff",
  ENUM_PERSONAL_TRAINER: "Personal Trainer",
  ENUM_PHYSICAL_EDUCATION_INSTRUCTOR: "Physical Education Instructor",
  ENUM_PILATES_INSTRUCTOR: "Pilates Instructor",
  ENUM_PROFESSIONAL_ATHLETE: "Professional Athlete",
  ENUM_SPORTS_COACH: "Sports Coach",
  ENUM_MASTERS_STUDENT: "Masters Student",
  ENUM_PHD_STUDENT: "PHD Student",
  ENUM_STUDENT: "Student",
  ENUM_CHIEF_MARKETING_OFFICER: "Chief Marketing Officer",
  ENUM_CHIEF_TECHNICAL_OFFICER: "Chief Technical Officer",
  ENUM_COMMUNICATIONS_MANAGER: "Communications Manager",
  ENUM_COMMUNITY_MANAGER: "Community Manager",
  ENUM_CONTENT_CREATOR: "Content Creator",
  ENUM_CYBER_SECURITY_CONSULTANT: "Cyber Security Consultant",
  ENUM_EDITOR: "Editor",
  ENUM_GRAPHIC_DESIGNER: "Graphic Designer",
  ENUM_IT_CONSULTANT: "IT Consultant",
  ENUM_MARKETING_ASSISTANT: "Marketing Assistant",
  ENUM_MARKETING_MANAGER: "Marketing Manager",
  ENUM_MARKET_RESEARCHER: "Market Researcher",
  ENUM_PRODUCER: "Producer",
  ENUM_PRODUCT_DESIGNER: "Product Designer",
  ENUM_PRODUCT_MANAGER: "Product Manager",
  ENUM_PUBLISHER: "Publisher",
  ENUM_SOCIAL_MEDIA_ASSISTANT: "Social Media Assistant",
  ENUM_SOFTWARE_DEVELOPER: "Software Developer",
  ENUM_SOFTWARE_ENGINEER: "Software Engineer",
  ENUM_SOFTWARE_TESTER: "Software Tester",
  ENUM_SOUND_ENGINEER: "Sound Engineer",
  ENUM_SYSTEMS_ENGINEER: "Systems Engineer",
  ENUM_UX_UI_DESIGNER: "UX/UI Designer",
  ENUM_VIDEO_EDITOR: "Video Editor",
  ENUM_WEB_DEVELOPER: "Web Developer",
  ENUM_AERONAUTICAL_ENGINEER: "Aeronautical Engineer",
  ENUM_AIRCRAFT_ENGINEER: "Aircraft Engineer",
  ENUM_AIRPORT_MANAGER: "Airport Manager",
  ENUM_AIR_TRAFFIC_CONTROLLER: "Air Traffic Controller",
  ENUM_BUS_DRIVER: "Bus Driver",
  ENUM_DELIVERY_DRIVER: "Delivery Driver",
  ENUM_DRIVER: "Driver",
  ENUM_FLYING_INSTRUCTOR: "Flying Instructor",
  ENUM_MARINE_ENGINEER: "Marine Engineer",
  ENUM_PASSENGER_DRIVER: "Passenger Driver",
  ENUM_PILOT: "Pilot",
  ENUM_TRANSPORT_OFFICER: "Transport Officer",
  ENUM_HOSPITAL_SALES_REPRESENTATIVE: "Hospital Sales Representative",
  ENUM_MEDICAL_SALES_REPRESENTATIVE: "Medical Sales Representative",
  ENUM_CASTING_DIRECTOR: "Casting Director",
  ENUM_DEPENDENT: "Dependent",
  ENUM_INTERMEDIATE_LOW: "Intermediate Low",
  ENUM_INTERMEDIATE_MID: "Intermediate Mid",
  ENUM_INTERMEDIATE_HIGH: "Intermediate High",
  ENUM_ADVANCED_LOW: "Advanced Low",
  ENUM_ADVANCED_MID: "Advanced Mid",
  ENUM_ADVANCED_HIGH: "Advanced High",
  ENUM_PROFICIENT: "Proficient",
  ENUM_PERSONAL_CHAT: "Personal Chat",
  ENUM_GROUP_CHAT: "Group Chat",
  ENUM_PUBLIC_CHANNEL: "Public Channel",
  EVENTS_PAGE_NOT_HOSTING_EVENTS: "You’re not hosting any upcoming events.",
  EVENTS_PAGE_NOT_HOSTING_EVENTS_SUBTITLE:
    "Once you create and host events, they will be displayed here...",
  EVENTS_PAGE_NOT_HOSTED_EVENTS: "You haven’t hosted any events yet.",
  EVENTS_PAGE_FIND_AN_EVENT: "Let’s find an Event for you",
  EVENTS_PAGE_BROWSE_EVENTS: "Browse All Events",
  EVENTS_PAGE_USE_FILTERS: "Use event filters",
  EVENTS_PAGE_EXIT_FILTERS: "Exit event filters",
  EVENTS_PAGE_TOP_PICKS: "Top Picks for you this week",
  EVENTS_PAGE_TOP_PICKS_SUBTITLE:
    "These are the events we think you’ll enjoy, based on your profile information",
  EVENTS_PAGE_CONVERSATION_PRACTICE: "Events for Conversation Practice",
  EVENTS_PAGE_CONVERSATION_SUBTITLE:
    "Let your fluency flow as you practise your conversation skills in these events. ",
  EVENTS_PAGE_STUDY_AND_LEARN: "Events to Study & Learn",
  EVENTS_PAGE_STUDY_SUBTITLE: "The perfect way sharpen your grammar, vocabulary or pronunciation! ",
  EVENTS_PAGE_DIVE_DEEPER: "Events to Dive Deeper",
  EVENTS_PAGE_DIVE_DEEPER_SUBTITLE:
    "Explore different formats and challenge yourself to try new ways to experience English.",
  EVENTS_PAGE_SEARCH_EVENTS: "Search all events with filters",
  EVENTS_PAGE_BANNER_CREATE_CANT_FIND: "Can’t find the right event?",
  EVENTS_PAGE_BANNER_USE_FILTERS: "You can try using filters to search all events.",
  EVENTS_PAGE_BANNER_SEARCH: "Search all events",
  EVENTS_PAGE_WHICH_EVENT: "Which event should I join first?",
  EVENTS_PAGE_WHICH_EVENT_DESCRIPTION:
    "Watch this short video where Emma shares the best way to get started.",
  EVENTS_PAGE_FILTERS_LOCATION: "Location",
  EVENTS_PAGE_FILTERS_TYPES: "Event Types",
  EVENTS_PAGE_FILTERS_EVENT_TIME: "Event Time",
  EVENTS_PAGE_FILTERS_TIME_MORNING: "Morning",
  EVENTS_PAGE_FILTERS_TIME_AFTERNOON: "Afternoon",
  EVENTS_PAGE_FILTERS_TIME_EVENING: "Evening",
  EVENTS_PAGE_FILTERS_TIME_NIGHT: "Night",
  EVENTS_PAGE_FILTERS_TIME_MORNING_HOURS: "6:00 AM – 12:00 PM",
  EVENTS_PAGE_FILTERS_TIME_AFTERNOON_HOURS: "12:00 PM – 6:00 PM",
  EVENTS_PAGE_FILTERS_TIME_EVENING_HOURS: "6:00 PM – 12:00 AM",
  EVENTS_PAGE_FILTERS_TIME_NIGHT_HOURS: "12:00 AM – 6:00 AM",
  EVENTS_PAGE_FILTERS_CUSTOM_TIME: "Custom Time",
  EVENTS_PAGE_FILTERS_SELECT_CUSTOM_TIME_RANGE: "Select custom time range",
  EVENTS_PAGE_FILTERS_AVAILABLE_WHEN_I_AM: "Available When I Am",
  EVENTS_PAGE_FILTERS_SIMILAR_TIMES: "Similar Times",
  EVENTS_PAGE_FILTERS_ANY_TIME: "Any Time",
  EVENTS_PAGE_FILTERS_HOSTED_BY: "Hosted By",
  EVENTS_PAGE_FILTERS_HOSTED_BY_ANYONE: "Hosted By Anyone",
  EVENTS_PAGE_FILTERS_PEOPLE_I_FOLLOW: "People I Follow",
  EVENTS_PAGE_FILTERS_HL_MEMBERS: "{HL} Members",
  EVENTS_PAGE_FILTERS_HL_COACHES: "{HL} Coach",
  EVENTS_PAGE_FILTERS_TEAM: "{HL} Team",
  EVENTS_PAGE_FILTERS_BIG_SISTERS: "Big Sisters",
  EVENTS_PAGE_FILTERS_HOSTED_BY_ME: "Hosted by me",
  EVENTS_PAGE_FILTERS_TOPIC_FILTER: "Topic Type",
  EVENTS_PAGE_FILTERS_ALL_TOPICS: "All Topics",
  EVENTS_PAGE_FILTERS_HL_TOPICS: "{HL} Topics",
  EVENTS_PAGE_FILTERS_OTHER_TOPICS: "Other Topics",
  EVENTS_PAGE_FILTERS_ALL_EVENT_TYPES: "All Event Types",
  EVENTS_PAGE_FILTERS_CONVERSATIONS: "Conversations",
  EVENTS_PAGE_FILTERS_STUDY_EVENTS: "Study & Learn",
  EVENTS_PAGE_FILTERS_DEEP_DIVE: "Deep Dive",
  EVENTS_PAGE_FILTERS_PROFESSIONAL_EVENTS: "Professional",
  EVENTS_PAGE_FILTERS_LISTEN_ONLY: "Listen Only",
  EVENTS_PAGE_FILTERS_IN_PERSON_EVENTS: "In Person",
  EVENTS_PAGE_FILTERS_NEW_MEMBER_EVENTS: "New Member Events",
  EVENTS_PAGE_FILTERS_ANY_LEVEL: "Any Level",
  EVENTS_PAGE_FILTERS_EVENT_LEVEL: "All Event Levels",
  EVENTS_PAGE_FILTERS_INTERMEDIATE: "Intermediate",
  EVENTS_PAGE_FILTERS_ADVANCED: "Advanced",
  EVENTS_PAGE_FILTERS_CHOOSE_AVAILABILITY: "Choose Availability",
  EVENTS_PAGE_FILTERS_ADVANCED_FILTERS: "Advanced filters",
  EVENTS_PAGE_NM_EVENTS: "New Member Events",
  EVENTS_PAGE_COACH_EVENTS: "Coach Events",
  EVENTS_PAGE_GROUP_STUDY: "Group Study",
  EVENTS_PAGE_MEMBER_HOSTED: "Member Hosted",
  EVENTS_PAGE_SPEAK_15_30: "Speak 15-30 min",
  EVENTS_PAGE_SPEAK_15_30_MIN: "Speak {br} 15-30 min",
  EVENTS_PAGE_LISTEN_ONLY: "Listen Only",
  EVENTS_PAGE_SPEAK_45: "Speak 45+ min",
  EVENTS_PAGE_SPEAK_45_MIN: "Speak {br} 45+ min",
  EVENTS_PAGE_IN_PERSON: "In Person",
  EVENTS_PAGE_SHOW_ALL: "Show All",
  EVENTS_PAGE_SHOWING_ALL_EVENTS: "Showing all events",
  EVENTS_PAGE_USE_THE_FILERS: "You can use the filters to find what you're looking for",
  EVENTS_PAGE_FILTERED_RESULTS: "Filtered Results",
  EVENTS_PAGE_ADJUST_FILTERS: "Sorted by relevance. Add or remove filters to adjust your search",
  EVENTS_PAGE_ALL_EVENTS: "All Events",
  EVENTS_PAGE_FEATURED_COMMUNITY: "Featured Community Events",
  EVENTS_PAGE_FEATURED: "Featured Events",
  EVENTS_PAGE_RECOMMENDED_EVENTS: "Recommended Events",
  EVENTS_PAGE_EVENTS_I_M_GOING_TO: "Events I’m Going To",
  EVENTS_PAGE_I_M_GOING_TO: "I’m Going To",
  EVENTS_PAGE_EVENTS_I_M_HOSTING: "Events I'm Hosting",
  EVENTS_PAGE_I_M_HOSTING: "I'm Hosting",
  EVENTS_PAGE_EVENTS_I_WENT_TO: "Events I Went To",
  EVENTS_PAGE_I_WENT_TO: "I Went To",
  EVENTS_PAGE_EVENTS_I_HOSTED: "Events I Hosted",
  EVENTS_PAGE_I_HOSTED: "I Hosted",
  EVENTS_PAGE_MY_EVENTS: "My Events",
  EVENTS_PAGE_MY_EVENTS_TOOLTIP: "What are Events? <url>Learn more</url>{br}about how they work.",
  EVENTS_PAGE_FEATURED_EVENTS_TOOLTIP: "Special events hosted by the team at Hey Lady!",
  EVENTS_PAGE_FULL_EVENT: "FULL",
  EVENTS_PAGE_FULL: "Full event!",
  EVENTS_PAGE_YOU_RE_GOING: "You're going!",
  EVENTS_PAGE_YOU_RE_INVITED: "You're invited!",
  EVENTS_PAGE_YOU_RE_HOSTING: "You're hosting!",
  EVENTS_PAGE_SHARED_WITH_YOU: "Shared with you!",
  EVENTS_PAGE_YOUR_TIMEZONE: "Your timezone",
  EVENTS_PAGE_IN_PROGRESS: "In progress",
  EVENTS_PAGE_GOING: "Going?",
  EVENTS_PAGE_LIVE: "Live",
  EVENTS_PAGE_FULL_EVENTS: "Full Events",
  EVENTS_PAGE_REMOVE_TOPIC: "Remove Topic",
  EVENTS_PAGE_HIDE_FULL_EVENTS: "Hide FULL Events",
  EVENTS_PAGE_EVENT_DATE: "Event Date",
  EVENTS_PAGE_ANY_EVENT_DATE: "Any Event Date",
  EVENTS_PAGE_CAPACITY: "Capacity",
  EVENTS_PAGE_UNVERIFIED_BANNER: "Which event should you choose?",
  EVENTS_PAGE_UNVERIFIED_BANNER_DESCRIPTION:
    "{name}, any of the events you see below are great for new members. They are shown in your time zone. Choose one that suits your schedule and we will meet you there!",
  EVENTS_PAGE_FILTER_LOCKED_TOOLTIP:
    "Join {required} Events to unlock more events. Events attended: {attended}/{required}",
  EVENTS_PAGE_FILTER_LOCKED_NOT_ALLOWED_TOOLTIP: "Upgrade to unlock",
  EVENTS_PAGE_UNLOCKED_NEW_EVENTS: "You’ve unlocked new Events!",
  EVENTS_PAGE_UNLOCKED_NEW_EVENTS_DESCRIPTION:
    "You’ve already attended 3 events! Now you have unlocked even more:" +
    " <b>Coach Events</b>, <b>Group Study</b>, and <b>Speak (45+ min)</b>.",
  EVENTS_PAGE_UNLOCKED_NEW_EVENTS_BASIC_DESCRIPTION:
    "You’ve already attended 3 events! Now you have unlocked even more:" +
    " <b>Group Study</b> and <b>Speak (45+ min)</b>.",
  EVENTS_PAGE_LOCKED_EVENT_TITLE: "Unlock all {type} Events",
  EVENTS_PAGE_EXPLORE_EVENTS: "Explore Events",
  EVENTS_PAGE_LOCKED_EVENT_DESCRIPTION:
    "Join <b>3 community events</b> to unlock access to {type} Events and take your learning to the next level!",
  EVENTS_PAGE_LOCKED_EVENT_DESCRIPTION_COACH:
    "Join <b>3 community events</b> to unlock conversation practice and training events with our Coaches.",
  EVENTS_PAGE_LOCKED_EVENT_NOT_ALLOWED_DESCRIPTION: "Upgrade to attend Coach Events",
  EVENTS_PAGE_COACH: "Coach",
  EVENTS_PAGE_LOCKED_EVENT_BUTTON: "OK!",
  EVENTS_PAGE_NEW_FILTERS_TOOLTIP_TITLE: "Filters unlocked!",
  EVENTS_PAGE_NEW_FILTERS_TOOLTIP: "You can now use Filters to quickly find what you need.",
  EVENTS_PAGE_LOCKED_EVENT: "Unlocked after you join 3 Events",
  EVENTS_PAGE_LOCKED_EVENT_NOT_ALLOWED: "Upgrade to attend",
  EVENTS_PAGE_LOCKED_EVENT_PAUSED: "Unpause to attend",
  EVENTS_INVITATIONS: "Invitations",
  EVENTS_INVITATIONS_DESCRIPTION:
    "Events that ladies have invited you to join or want to share with you. Let them know if you're attending!",
  EVENTS_INVITATIONS_EMPTY_TITLE: "You’re all caught up!",
  EVENTS_INVITATIONS_EMPTY_SUBTITLE: "You’ve responded to all your invitations. Well done!",
  EVENTS_FEATURED_COMMUNITY_EVENTS: "Featured Community Events",
  EVENTS_FEATURED_COMMUNITY_EVENTS_DESCRIPTION:
    "Events hosted by our team for the whole community—don’t miss out!",
  EVENTS_FEATURED_COMMUNITY_SEE_MORE: "Want to see more featured events?",
  EVENTS_FEATURED_COMMUNITY_SEE_MORE_DESCRIPTION:
    "Discover more events hosted by the Hey Lady! team.",
  EVENTS_FEATURED_COMMUNITY_SEE_ALL: "See All Featured Events",
  EVENTS_PAGE_FIRST_EVENT: "First Event? Here’s What to Expect",
  EVENTS_PAGE_FIRST_EVENT_DESCRIPTION:
    "Events are at the heart of Hey Lady! here you’ll connect, practise speaking, and start building real relationships. Watch the video to learn more:",
  EVENT_PAGE_IDEAS_WE_WILL_EXPLORE: "Ideas we will explore",
  EVENT_PAGE_BACK_TO_EVENTS: "Back to Events",
  EVENT_PAGE_BACK_TO_EVENT_PAGE: "Back to Event Page",
  EVENT_PAGE_CANCEL_ATTENDANCE: "Cancel attendance",
  EVENT_PAGE_DESCRIPTION: "Description",
  EVENT_PAGE_LOCATION: "Event Location",
  EVENT_PAGE_DISCUSSION: "Event Discussion",
  EVENT_PAGE_GO_TO_TOPIC: "Go to Topic",
  EVENT_PAGE_A_MESSAGE_FROM_YOUR_COACHES: "A message from your coaches",
  EVENT_PAGE_INVITE_OTHER_MEMBERS: "Invite other members to the event",
  EVENT_PAGE_I_CANT_PARTICIPATE: "I can’t participate",
  EVENT_PAGE_I_WILL_ATTEND: "I will attend",
  EVENT_PAGE_I_WILL_CO_HOST: "I will Co-Host",
  EVENT_PAGE_I_WILL_GO: "Actually, I will go",
  EVENT_PAGE_START_EVENT: "Start Event",
  EVENT_PAGE_YOU_ARE_GOING: "You’re going!",
  EVENT_PAGE_ACCEPT: "Accept",
  EVENT_PAGE_DECLINE: "Decline",
  EVENT_PAGE_LOCKED_EVENT: "Locked Event",
  EVENT_PAGE_ACCEPT_INVITATION: "Accept Invitation",
  EVENT_PAGE_DECLINE_INVITATION: "Decline Invitation",
  EVENT_PAGE_STARTS_IN: "Starts in {time}",
  EVENT_PAGE_NEED_TO_CANCEL: "Need to cancel?",
  EVENT_PAGE_FULL_EVENT: "The event is now full",
  EVENT_PAGE_REPEATS: "Repeats",
  EVENT_PAGE_RECURRING_DESCRIPTION: "This event repeats every {frequency} at {time}",
  EVENT_PAGE_VIEW_FULL_SCHEDULE: "View full schedule",
  EVENT_SCHEDULE_MODAL_TITLE: "Recurring Event Schedule",
  EVENT_SCHEDULE_MODAL_SELECT_ALL: "Select which events you'll attend:",
  EVENT_SCHEDULE_MODAL_SELECT_ALL_BTN: "Select All",
  EVENT_SCHEDULE_MODAL_SUCCESS: "Your attendance has been updated!",
  CONFIRM_RECURRING_ATTENDANCE_TITLE: "Confirm your place!",
  CONFIRM_RECURRING_ATTENDANCE_DESCRIPTION:
    "This is a recurring event. It repeats <bold>{recurrencePattern}</bold>.",
  CONFIRM_RECURRING_ATTENDANCE_HOW_ATTEND: "How would you like attend this event:",
  CONFIRM_RECURRING_ATTENDANCE_THIS_ONLY: "This event only ({date})",
  CONFIRM_RECURRING_ATTENDANCE_ALL_EVENTS: "All recurring events",
  CONFIRM_RECURRING_ATTENDANCE_ALL_EVENTS_NOTE:
    "You'll be added to all upcoming events with available spots.",
  CONFIRM_RECURRING_ATTENDANCE_CHOOSE_SPECIFIC: "Choose specific dates",
  DECLINE_ALL_RECURRING_CONFIRM_TITLE: "Are you sure?",
  DECLINE_ALL_RECURRING_CONFIRM_BODY: "You will decline all events in this series.",
  DECLINE_RECURRING_EVENT_THIS_ONLY: "This event only ({date})",
  DECLINE_RECURRING_EVENT_TITLE: "Decline Event",
  DECLINE_RECURRING_EVENT_DESCRIPTION:
    "This is a recurring event. It repeats <bold>{recurrencePattern}</bold>. Choose how many events would you like to decline?",
  DECLINE_RECURRING_EVENT_ALL_EVENTS: "All recurring events",
  DECLINE_RECURRING_EVENT_CHOOSE_SPECIFIC: "Choose specific dates",
  DECLINE_RECURRING_EVENT_SELECT_TEXT: "Select which events you'll attend or decline:",
  DECLINE_RECURRING_EVENT_SUCCESS: "Your responses have been updated!",
  COMMON_RESPOND: "Respond",
  EVENT_PAGE_CONFIRM_WHO_ATTENDED: "Confirm who attended",
  EVENT_PAGE_UPDATE_IN_PERSON_ATTENDANCE: "Update attendance",
  EVENT_PAGE_CONFIRM_IN_PERSON_EVENT_HAPPENED: "Did you successfully host this in-person event?",
  EVENT_PAGE_CONFIRM_IN_PERSON_EVENT_HAPPENED_YES: "Yes, I did",
  EVENT_PAGE_CONFIRM_IN_PERSON_EVENT_HAPPENED_NO: "No, I didn't",
  EVENT_PAGE_CONFIRM_IN_PERSON_PARTICIPANTS: "Please confirm which ladies attended",
  EVENT_PAGE_CONFIRM_IN_PERSON_NO_ONE_ATTENDED: "It looks like no-one attended this event!",
  EVENT_PAGE_CONFIRM_IN_PERSON_NO_ONE_ATTENDED_CONFIRM:
    "We are assuming that no one attended your event, is that right?",
  EVENT_PAGE_CONFIRM_IN_PERSON_CANCELLED: "Yes, it was cancelled",
  EVENT_PAGE_CONFIRM_IN_PERSON_SUCCESS_MESSAGE: "The event attendance has been confirmed.",
  EVENT_PAGE_UPGRADE_HEADING: "Upgrade to attend",
  EVENT_PAGE_UPGRADE_DESC:
    "Upgrade your plan and get instant access to coach events, webinars and learning resources.",
  EVENT_PAGE_UPGRADE_SEE_PLANS: "See plans",
  EVENT_PAGE_UPGRADE_TO_ATTEND: "Upgrade to attend",
  EVENT_PAGE_ACTIVATE_HEADING: "Want to join this {eventKind}?",
  EVENT_PAGE_UPGRADE_TO_ATTEND_HEADING: "Upgrade to attend this event",
  EVENT_PAGE_UPGRADE_TO_ATTEND_MEMBERS_EVENTS:
    "Events hosted by members are not included during your free trial.{br}<bold>To attend this event, you need to upgrade to a paid subscription.</bold>{br} That means your free trial will end today and you will be charged for your membership. Then, you can attend all events in the platform.",
  EVENT_PAGE_UPGRADE_TO_ATTEND_CONVERSATION_STARTER:
    "‘Conversation Starters’ are group events hosted by our Coaches but they are not included during your free trial.{br}<bold>To attend this event, you need to upgrade to a paid subscription.</bold>{br}That means your free trial will end today and you will be charged for your membership. Then, you can attend all events in the platform.",
  EVENT_PAGE_PRIVATE_EVENT: "This is a private event",
  EVENT_PAGE_CLOSED_DOOR:
    "This event started {minsAgo} minutes ago and the host has closed the door. You can knock to request access but must wait to see if the host allows you to enter",
  EVENT_PAGE_ARE_YOU_SURE: "Are you sure?",
  EVENT_PAGE_ADD_THIS_TO_YOUR_CALENDAR: "Add this to your calendar?",
  EVENT_PAGE_REMIND_YOURSELF: "Remind yourself to attend by adding this event to your calendar.",
  EVENT_PAGE_GOOGLE: "Google",
  EVENT_PAGE_APPLE: "Apple",
  EVENT_PAGE_CALENDAR_INVITE_SENT:
    "We’ve emailed you the event. Open it to add it to your calendar, and we’ll keep it up to date.",
  EVENT_PAGE_CALENDAR_INVITES_SENT:
    "We’ve emailed you each event. Open them to add them to your calendar, and we’ll keep them up to date.",
  EVENT_PAGE_OUTLOOK: "Outlook",
  EVENT_PAGE_I_CAL: "iCal",
  EVENT_PAGE_NO_THANKS: "No thanks",
  EVENT_PAGE_EVENT_ADDED_SUCCESSFULLY: "Event added successfully",
  EVENT_PAGE_IS_IN_YOUR_CALENDAR: "It’s in your calendar!",
  EVENT_PAGE_WELL_DONE: "Well done!",
  EVENT_PAGE_PUBLISHED_SUCCESSFULLY:
    "Your event has been successfully published! You can edit your event by going" +
    ' to the "My events" tab on events page.',
  EVENT_PAGE_GOOD_LUCK: "Good luck!",
  EVENT_PAGE_PUBLISHED_SUCCESSFULLY_IN_PERSON: "Your event has been published!",
  EVENT_PAGE_PUBLISHED_IN_PERSON_INFO:
    "<bold>But there is one more thing...</bold>" +
    "{br}Because this event is happening offline, we need your help." +
    "{br}<span>After your in-person event has ended,</span> please come back to confirm that the event happened, and who attended." +
    "{br}This will help us to update everyone's profiles!",
  EVENT_PAGE_PUBLISHED_IN_PERSON_TIP:
    "Tip: You will find the event on your Profile Page > Events I've Hosted",
  EVENT_PAGE_PUBLISHED_IN_PERSON_SURE: "Sure! I can do that!",
  EVENT_PAGE_SOMETHING_WENT_WRONG: "Oops! Something went wrong.",
  EVENT_PAGE_TRY_AGAIN:
    "We were not able to publish your event. Please close this window and try to ‘Confirm &" +
    " Publish’ your event again.",
  EVENT_PAGE_WE_HAVE_SENT_THIS_EVENT:
    "We have sent this event to your calendar. Make sure you update your calendar setting to receive reminders so you don’t miss it!",
  EVENT_PAGE_NOT_SUITABLE_EVENT:
    "This is an {eventLevel} event but your current level is {userSpeakingLevel}.",
  EVENT_PAGE_NOT_SUITABLE_EVENT_CONTACT_HOST:
    "You will need to update your level or contact the host to include your level in the event details.",
  EVENT_PAGE_NOT_SURE: "I’m not sure",
  EVENT_PAGE_I_LL_BE_THERE: "I will be there!",
  EVENT_PAGE_NOBODY_LIKES: "Nobody likes being <italic>stood up</italic>.",
  EVENT_PAGE_HOST_WILL_BE_EXPECTING:
    "If you say you’re going, {host} will be expecting you to be there!",
  EVENT_PAGE_IF_YOU_CHANGE_YOUR_MIND:
    "If you change your mind or you can’t make it, that’s OK, but please let her know & ‘cancel’ so your seat can be offered to someone else.",
  EVENT_PAGE_WHO_IS_COMING: "Who's coming?",
  EVENT_PAGE_VERIFIED: "Verified?",
  EVENT_PAGE_ARE_YOU_SURE_YOU_WANT_TO_VERIFY: "Are you sure you want to verify this person?",
  EVENT_PAGE_ARE_YOU_SURE_YOU_WANT_TO_UNVERIFY: "Are you sure you want to un-verify this person?",
  EVENT_PAGE_VERIFY: "Verify",
  EVENT_PAGE_UNVERIFY: "Un-verify",
  EVENT_PAGE_WHO_IS_COMING_UPDATED_USER: "User was updated successfully",
  EVENT_PAGE_CANT_MAKE_IT: "Can't make it any more?",
  EVENT_PAGE_THAT_IS_OK:
    "That's OK! Sometimes life gets busy. We'll see you at a different event soon!",
  CANCEL_RECURRING_TITLE: "Can't make it any more?",
  CANCEL_RECURRING_DESCRIPTION:
    "That's OK! Sometimes life gets busy. We'll see you at a different event soon! This is a recurring event, how would you like to cancel?",
  CANCEL_RECURRING_THIS_ONLY: "This event only",
  CANCEL_RECURRING_ALL_EVENTS: "All recurring events",
  CANCEL_RECURRING_CHOOSE_SPECIFIC: "Choose specific dates",
  CANCEL_RECURRING_SELECT_TEXT: "Select which events you want to cancel:",
  CANCEL_RECURRING_CONFIRM: "Confirm Cancelation",
  CANCEL_RECURRING_SUCCESS: "Your attendance has been cancelled.",
  RECURRING_INVITE_SCOPE_TITLE: "How should these ladies be invited to your recurring event?",
  RECURRING_INVITE_SCOPE_ALL: "I’m inviting them to attend all events with available places",
  RECURRING_INVITE_SCOPE_THIS_ONLY: "I'm just inviting them to join one event first ({date})",
  EVENT_PAGE_EVENT_TIME: "Your event is scheduled to start at {time}",
  EVENT_PAGE_YOU_CAN_START_THE_EVENT:
    "You can start the event now and get ready before your guests arrive.",
  EVENT_PAGE_YOUR_GUESTS: "Your guests will be able to join at the scheduled start time.",
  EVENT_PAGE_PLEASE_CANCEL: "Please cancel",
  EVENT_PAGE_FINISHED_EVENT: "Finished Event",
  EVENT_PAGE_UNLIMITED_PLACES_REMAINING: "Unlimited",
  EVENT_PAGE_JOIN_CALL: "Join call",
  EVENT_PAGE_PLACES_REMAINING: "{places} places remaining",
  EVENT_PAGE_SHOW_ALL_PARTICIPANTS: "Show all",
  EVENT_PAGE_REPORT_ABUSE: "Report this Event",
  EVENT_PAGE_SEND_INVITATION: "Send invitation",
  EVENT_PAGE_SHARE_EVENT_TO_PEOPLE: "Share event to people",
  EVENT_PAGE_SUGGESTED_EVENTS: "Suggested Events",
  EVENT_PAGE_ACCESS_DENIED:
    "Unfortunately the host of this event is not allowing more people to join at this time",
  EVENT_PAGE_DEEP_DIVE_ROUNDTABLE:
    "This Deep Dive is a ‘Roundtable’ discussion.  Roundtable is a discussion where each lady shares her opinion about a specific topic. It’s a great way to practise agreeing, disagreeing, and listening. To prepare for this event, complete the Deep Dive lesson, and do the Workbook. It will help you to organise your thoughts.  Ask your host if you have any questions about the topic! We know you’ll love it!",
  EVENT_PAGE_DEEP_DIVE_SHARE_AND_COMPARE:
    "This Deep Dive is a ‘Share and Compare’ discussion. In this event, each lady will practise giving a short talk in front of your group by sharing something special. Depending on the topic, you might share a song, a photo, a story, or even some advice! To prepare for your discussion, go through the Deep Dive lesson. Watch the video of us coaches having our own discussion, and complete the Workbook to prepare for the event. Be sure to ask your host if you have any questions about this topic! We know you’re going to love it!",
  EVENT_PAGE_DEEP_DIVE_ROLE_PLAY:
    "This Deep Dive is a ‘Role Play’. For this event each lady gets to play a special role by pretending to be someone else, or by performing a specific task. It’s a great way to think outside the box, and expand your vocabulary! To prepare for this event, complete the Deep Dive lesson and then read about the different roles that you could be. Be sure to message your host and ask her what she wants you to do before the event. This kind of event is so much fun, we know you’re going to love it!",
  EVENT_PAGE_DEEP_DIVE_SOLVE_A_PROBLEM:
    "This Deep Dive is a ‘Solve a Problem’ discussion. In this event, your host will choose a topic for you to discuss. Then you will work together to identify both problems and solutions related to the topic. This is a great way to practise asking questions, sharing ideas, and listening to each other. To prepare for the discussion, go through the Deep Dive lesson on the platform. Complete the Workbook to start brainstorming, and be sure to message your host if you have any questions about this topic!",
  EVENT_PAGE_SPECIFIC_MEMBER_GROUP: "Sorry, this event is scheduled for a specific member group.",
  EVENT_PAGE_TAG_PARTICIPANTS: "(Tag Event Participants)",
  EVENT_PAGE_SHARE_THIS_EVENT: "Who would you like to share this event with?",
  EVENT_PAGE_SHARE_EVENT_NOTE:
    "Note: Only members who are able to attend this kind of event will appear in your search.",
  EVENT_PAGE_SHARED: "Event shared successfully",
  EVENT_PAGE_WEBINAR: "Webinar Event",
  LIVE_COFFEE_TABLES: "Live Coffee Tables",
  LIVE_COFFEE_TABLES_DESCRIPTION:
    "Casual conversation practice with other ladies who are online right now. <url>Learn more</url>",
  LIVE_TABLES_TOOLTIP:
    "Join a casual, no-pressure chat with others online now— the perfect way to get extra" +
    " speaking practice! 😉",
  LIVE_TABLES_JOIN_A_TABLE: "Join a casual, no-pressure chat with others online now!",
  LIVE_TABLES_FULL: "Table is Full",
  LIVE_TABLES_UNPAUSE: "Unpause to join",
  LIVE_TABLES_JOIN_THIS_TABLE: "Join this table",
  LIVE_TABLES_JOINED: "Joined",
  LIVE_TABLES_WHAT_YOU_WILL_TALK_ABOUT: "What you will talk about?",
  LIVE_TABLES_TABLE_SETTINGS: "Table settings",
  LIVE_TABLES_START_TABLE: "Start Table",
  LIVE_TABLES_ADD_TOPIC: "Add from Topics Library",
  LIVE_TABLES_FROM_CURRENT_TOPIC: "Choose an idea from Current Topic",
  LIVE_TABLES_START_TABLE_TITLE: "Got a topic in mind?",
  LIVE_TABLES_START_TABLE_DESCRIPTION:
    "Create your own table for ladies to join your conversation!",
  LIVE_TABLES_TOPIC_LABEL: "Table Topic:",
  LIVE_TABLES_TOPIC_PLACEHOLDER: "Enter your own idea here",
  LIVE_TABLES_MAX_PARTICIPANTS_LABEL: "Max Seats (including you)",
  LIVE_TABLES_TIME_LIMIT: "Time limit",
  LIVE_TABLES_TIME_NO_LIMIT: "No limit",
  LIVE_TABLES_TIME_10_MINUTES: "10 minutes",
  LIVE_TABLES_TIME_20_MINUTES: "20 minutes",
  LIVE_TABLES_TIME_30_MINUTES: "30 minutes",
  LIVE_TABLES_UPDATE_TITLE: "Change Table Settings",
  LIVE_TABLES_ENDS_IN: "Ends in {min} min",
  LIVE_TABLES_SEATS_LEFT: "{count} Seats left",
  LIVE_TABLES_MIN: "{min} min",
  LIVE_TABLES_UPDATE_DESCRIPTION:
    "Change table settings to update this information on ‘Live Tables’ page",
  LIVE_TABLES_STARTED_MODAL_TITLE: "Your Coffee Table has started",
  LIVE_TABLES_STARTED_MODAL_DESCRIPTION:
    "Please, show some patience and give ladies a little time to join. We will end this call automatically in {min} minutes if nobody joins your table.",
  LIVE_TABLES_STARTED_TIMER: "See the timer at the bottom of the screen?",
  LIVE_TABLES_STARTED_CLICK_START: "Click ‘Start’ when you are ready to start your {min} minutes.",
  LIVE_TABLES_END_MODAL_TITLE: "Your Coffee Table is about to end",
  LIVE_TABLES_END_MODAL_DESCRIPTION:
    "Looks like there are no ladies who are ready to join your table right now. But no worries, we are waiting for you next time!",
  LIVE_TABLES_END_MODAL_LEAVE_TABLE: "Leave Table",
  LIVE_TABLES_GRAB_SEAT_MODAL_TITLE: "Uh oh, that's not going to work!",
  LIVE_TABLES_GRAB_SEAT_MODAL_DESCRIPTION:
    "You are only able to grab one seat. You will need to leave your other seat before taking this one.",
  LIVE_TABLES_LEFT_ALONE_TITLE: "Looks like you're the only one left",
  LIVE_TABLES_LEFT_ALONE_DESCRIPTION:
    "We will end this call automatically in {min} minutes if nobody joins your table. Remember you can update the" +
    " table topic via the settings.",
  LIVE_TABLES_FEEDBACK_RATE_EXPERIENCE_TITLE: "Please rate your experience of Coffee Tables",
  LIVE_TABLES_FEEDBACK_RATE_EXPERIENCE_DESCRIPTION:
    "This is a new feature and there are many ways we can improve it. Please rate what you think about this feature as it is today.",
  LIVE_TABLES_FEEDBACK_COMMENT_EXPERIENCE_TITLE: "Why did you give that score?",
  LIVE_TABLES_FEEDBACK_COMMENT_EXPERIENCE_DESCRIPTION:
    "Your honest feedback is appreciated. You can say anything you like including suggestions for how we can make this feature better.",
  LIVE_TABLES_FEEDBACK_COMMENT_EXPERIENCE_PLACEHOLDER: "Type your feedback..",
  LIVE_TABLES_FEEDBACK_WILL_USE_AGAIN_TITLE: "How likely are you to use it again?",
  LIVE_TABLES_FEEDBACK_SUCCESS: "Success!  Your feedback has been sent!",
  LIVE_TABLES_STARTED_MESSAGE_TITLE: "{name} just started a live coffee table",
  LIVE_TABLES_STARTED_MESSAGE_MUTE: "Mute for 60 mins",
  LIVE_TABLES_STARTED_MESSAGE_GO_TO_TABLES: "Go to Tables",
  LIVE_TABLES_GET_VERIFIED: "Get verified to access Live Tables",
  LIVE_TABLES_GET_VERIFIED_DESCRIPTION:
    "Community safety is important. All new members need to record a short video to introduce themselves to our team.",
  LIVE_COFFEE_TABLES_START: "Start",
  LIVE_TABLES_WILL_END: "⏰ Live Table will end in 1 minute",
  LIVE_TABLES_WILL_END_DESCRIPTION:
    "Time to wrap up your conversation or start a new table to keep chatting!",
  LIVE_TABLES_FIND_A_TOPIC: "Find a Conversation Topic {br} from Hey Lady’s Library",
  LIVE_TABLES_SELECT_TOPIC: "Select {title} Topic",
  LIVE_TABLES_SELECT_QUESTION: "Select question",
  LIVE_TABLES_SELECTED: "Selected",
  LIVE_TABLES_VIEW_QUESTIONS: "View Questions",
  LIVE_TABLES_SEARCH: "Search by topic name, category",
  FOOTER_MAKING_AN_IMPACT: "You are making an impact!",
  FOOTER_SPARKS_CREATED: "Sparks created since we launched!",
  FOOTER_OUR_MISSION:
    "Our mission is to spark one billion meaningful conversations between women of different" +
    " cultures.",
  FOOTER_INVITE_A_FRIEND: "Invite a friend to join and get a FREE month of membership!",
  FOOTER_BRING_A_FRIEND: "Bring a friend",
  FOOTER_CAMPAIGN_LABEL: "CAMPAIGN · ENDS 30 JUNE",
  FOOTER_CAMPAIGN_TITLE: "Hey Lady! needs your help.",
  FOOTER_CAMPAIGN_MEMBERS: "We have 1,750 members. Our goal is 2,500 by 30 June.",
  FOOTER_CAMPAIGN_REWARD: "Earn $50 USD",
  FOOTER_CAMPAIGN_REWARD_DESCRIPTION: "credit for every friend who joins by 30th June.",
  FOOTER_CAMPAIGN_BRING_A_FRIEND: "Bring a Friend",
  HELP_CONTACT_PAGE_FEEL_FREE:
    "Feel free to contact us! Our support team will reply to you as soon as possible.",
  HELP_CONTACT_PAGE_HOW_CAN_WE_HELP: "How can we help you?",
  HELP_CONTACT_PAGE_SEND: "Send message",
  HELP_CONTACT_MESSAGE_SENT: "Message successfully sent",
  HELP_CONTACT_PAGE_TYPE_YOUR_MESSAGE: "Type your message here...",
  HELP_FAQ_PAGE_CHOOSE_CATEGORY: "Common questions from our members",
  HELP_FAQ_PAGE_EVENTS: "Events",
  HELP_FAQ_PAGE_SUBSCRIPTIONS: "Subscriptions",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_AFTER_3_MONTHS: "after 3 months",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_AFTER_6_MONTHS: "after 6 months",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_AFTER_12_MONTHS: "after 12 months",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_STANDARD_THEME: "Standard Themes",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_SKILLS_WORKSHOPS: "English skills workshops",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_SKILLS_WORKSHOPS_DESCRIPTION:
    "Language workshops hosted by our teachers to help you sharpen your conversation skills. Specific, practical training designed to take your English to the next level.",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_TOPIC_LIBRARY: "Topic Library",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_CONVERSATION_STARTERS: "Conversation Starters",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_CONVERSATION_STARTERS_DESCRIPTION:
    "Develop your conversation skills in group events guided by our teachers. Get the support, advice and feedback you need to develop your English speaking skills.",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_GRAMMAR_SPOTS: "Grammar Spots",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_OFFICE_HOURS: "Office Hours",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_CREATE_HOSTS_EVENTS: "Create & Host Events",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_CREATE_HOSTS_EVENTS_DESCRIPTION:
    "Schedule online events and invite other ladies from the community to join. This is a fantastic way to meet other ladies talk about the things that interest you at a time that suits you best!",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_COMMUNITY_MEET_AND_GREETS: "Community Meet & Greets",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_COMMUNITY_MEET_AND_GREETS_DESCRIPTION:
    "Live events hosted by our Community Success team, these informal, fun events are here to help you meet and get to know other ladies in the community and find new speaking partners!",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_GRAMMAR_SPOTS_AND_OFFICE_HOURS: "Grammar Spots & Office Hours",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_GRAMMAR_SPOTS_AND_OFFICE_HOURS_DESCRIPTION:
    "Live events hosted by our teachers where you can continue learning vocabulary and grammar relating to our conversation topics. Bring your questions and have them answered.",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_WORKSHOPS: "Functional Language Workshops",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_GENERAL_EVENTS: "Community General Events",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_SPEED_MEETING: "Speed Meeting/Dating",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_OVER_COFFEE: "Conversations Over Coffee",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_OVER_COFFEE_DESCRIPTION:
    "Live events hosted by our team where you can grab a coffee and come along to listen in to their conversation with members from the community. A great way to learn more about other members as they discuss interesting topics!",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_MEMBER_INTERVIEWS: "Member Interviews",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_CONVERSATIONS: "Casual Conversations",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_STUDY_GROUPS: "Study Groups",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_DEEP_DIVES: "Deep Dives",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_CUSTOM_TOPIC_EVENTS: "Custom Topic Events",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_ONE_TO_ONE: "1:1 Conversations",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_CONVERSATIONS_GROUP: "Casual Conversations (Group)",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_PROFILES: "Explore member profiles",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_MESSAGES: "Send direct messages",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_CHAT: "Create Group Chat",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_CONVERSATION_PACKS: "Conversation Packs",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_CONVERSATION_PACKS_DESCRIPTION:
    "Structured video lessons, workbooks and activities to help you study, prepare and participate confidently in conversations inside community.",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_TEACHER_HOSTED_EVENTS: "Teacher Hosted Events",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_COMMUNITY_TEAM_EVENTS: "Community Team Events",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_MEMBER_EVENTS: "Join Member Events",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_HOST_YOUR_EVENTS: "Host your own events",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_FEATURE: "Feature",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_PROFILES_CHAT: "Profiles & Chat",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_FOUNDATIONS: "Foundations",
  HELP_FAQ_PAGE_SUBSCRIPTIONS_RISE: "Rise",
  HELP_FAQ_PAGE_PLATFORM_LAUNCH: "Platform launch",
  HELP_FAQ_PAGE_TOPICS_AND_LESSONS: "Topics & Lessons",
  HELP_FAQ_PAGE_PEOPLE: "Meeting people",
  HELP_FAQ_PAGE_MY_ACCOUNT: "My account",
  HELP_FAQ_PAGE_OUR_COMMUNITY: "Our community",
  HELP_FAQ_PAGE_PLEASE_CHOOSE_CATEGORY:
    "Please choose the category that best relates to your questions or concerns",
  HELP_FAQ_PAGE_STILL_HAVE_QUESTION: "Still have a question? <url>Contact us</url>",
  HOME_PAGE_HINT_HOME_TITLE: "Let's explore your home page!",
  HOME_PAGE_HINT_HOME_DESCRIPTION:
    "See the flashing icon? This quick tour will follow the icon to give you some tips on our main features.",
  HOME_PAGE_HINT_EVENTS_TITLE: "Events happening every day!",
  HOME_PAGE_HINT_EVENTS_DESCRIPTION:
    "All events are shown in your time zone. This link will take you to our Events page. You are welcome to join as many events as you like.",
  HOME_PAGE_HINT_USERS_TITLE: "People to practise with",
  HOME_PAGE_HINT_USERS_DESCRIPTION:
    "Follow this link to see and search for people in the community then connect via chat and start talking!",
  HOME_PAGE_HINT_TOPICS_TITLE: "Explore our topics",
  HOME_PAGE_HINT_TOPICS_DESCRIPTION:
    "This is where you will find all the tools you need to have great conversations!{br}We also offer Resources to study grammar and learn more about what's happening in the community.",
  HOME_PAGE_HINT_CHAT_TITLE: "Let's chat!",
  HOME_PAGE_HINT_CHAT_DESCRIPTION:
    "The perfect place to keep the conversation going. You can text 1:1, create a group and start an instant video call at the click of a button!",
  HOME_PAGE_HINT_MEMBERZINE_TITLE: "Read our Memberzine!",
  HOME_PAGE_HINT_MEMBERZINE_DESCRIPTION:
    "Have a read through the inspiring magazine articles written by our members and team! When you’re ready, you can contribute an article yourself!",
  HOME_PAGE_HINT_LEARN_BASICS_TITLE: "Watch to learn the basics",
  HOME_PAGE_HINT_LEARN_BASICS_DESCRIPTION:
    "These snack-sized videos created by our team will help you step-by-step to use the platform. Mark each one “Complete” to move through the series.",
  HOME_PAGE_HINT_PROFILE_TITLE: "My Account",
  HOME_PAGE_HINT_PROFILE_DESCRIPTION:
    "Click your profile pic to access and update your profile, change your availability settings and manage your membership subscription.",
  HOME_PAGE_TOUR_EXPLORE: "Start Exploring",
  EVENTS_PAGE_HINT_ALL_EVENTS_TITLE: "Your Events",
  EVENTS_PAGE_HINT_ALL_EVENTS_DESCRIPTION:
    "Click any link in this menu to see the events you are going to, have been to or are going to be hosting.",
  EVENTS_PAGE_HINT_FILTERS_TITLE: "Try the filters!",
  EVENTS_PAGE_HINT_FILTERS_DESCRIPTION:
    "We start by showing you the events that match your “Availability” settings from your profile. Try changing the filters to find the right events for you.",
  EVENTS_PAGE_HINT_EVENTS_IN_YOUR_TIMEZONE: "Events in your time zone",
  EVENTS_PAGE_HINT_EVENTS_IN_YOUR_TIMEZONE_DESCRIPTION:
    "All times are displayed in your time zone so you never need to worry about missing an event!",
  EVENTS_PAGE_HINT_JOIN_AS_MANY_AS_YOU_LIKE: "Join as many as you like!",
  EVENTS_PAGE_HINT_JOIN_AS_MANY_AS_YOU_LIKE_DESCRIPTION:
    "Join conversations hosted by community members and the Hey Lady! team. To join, simply click “View Event” then “I will attend” on the next page.",
  EVENTS_PAGE_HINT_JOIN_AS_MANY_AS_YOU_LIKE_DESCRIPTION_MOBILE:
    "Join conversations hosted by community members and the Hey Lady! team. To join, simply click event title or image then “I will attend” on the next page.",
  EVENT_PAGE_HINT_SHARE_EVENT_TITLE: "Share the love!",
  EVENT_PAGE_HINT_SHARE_EVENT_DESCRIPTION:
    "Attending an event is easy, just click “I will attend”. If you see an event that other members might enjoy, you can use “Share Event” button to let them know!",
  MEETING_PAGE_HINT_MEETING_TITLE: "✨ Feel a spark?",
  MEETING_PAGE_GIVE_A_SPARK: "Give a spark!",
  MEETING_PAGE_HINT_MEETING_DESCRIPTION:
    "Click this button to show your appreciation & gratitude toward others!" +
    " Every spark you give is counted and contributes to our mission! ",
  EVENT_PAGE_CONNECT_WITH_PEOPLE: "Connect with people who attended!",
  EVENT_PAGE_CONNECT_SEND_QUICK_MESSAGE: "Send them a quick message or type your own",
  EVENT_PAGE_CONNECT_LOVELY_MEETING_YOU: "So lovely meeting you!",
  EVENT_PAGE_CONNECT_CATCH_UP: "Shall we catch up?",
  EVENT_PAGE_CONNECT_LETS_KEEP_TALKING: "Let's keep talking!",
  EVENT_PAGE_CONNECT_SAY_HI: "👋 Say Hi!",
  EVENT_PAGE_CONNECT_GO_TO_CHAT: "Go to Chat",
  EVENT_PAGE_CONNECT_CLICK_TO_SEND_MESSAGE: "Click to send quick message",
  EVENT_PAGE_CONNECT_TYPE_YOUR_OWN: "Or type your own here...",
  PEOPLE_PAGE_SELECTED: "{number} out of {total} selected",
  PEOPLE_PAGE_CLEAR_SELECTION: "Clear selection",
  PEOPLE_PAGE_INVITE_TO_CHAT: "Invite to Group Chat",
  PEOPLE_PAGE_NO_EVENTS: "Create an event first then share it with people here",
  PEOPLE_PAGE_SEARCH_EVENT_BY_TITLE: "Search event by title",
  PEOPLE_PAGE_WHAT_EVENT_YOU_WANT_TO_SHARE: "What event would you like to share?",
  PEOPLE_PAGE_FILTERS_LOCATION: "Location",
  PEOPLE_PAGE_FILTERS_CHOOSE_TYPE: "Choose Type",
  PEOPLE_PAGE_FILTERS_CHOOSE_LOCATION: "Choose Location",
  PEOPLE_PAGE_FILTERS_CHOOSE_PERSONAL_INTERESTS: "Choose Personal Interests",
  PEOPLE_PAGE_FILTERS_CHOOSE_ENGLISH_INTERESTS: "Choose English Interests",
  PEOPLE_PAGE_FILTERS_CHOOSE_LEVEL: "Choose Level",
  PEOPLE_PAGE_FILTERS_CHOOSE_OCCUPATION: "Choose Occupation",
  PEOPLE_PAGE_FILTERS_MEMBER_TYPE_SELECTED: "{number} Member Type selected",
  PEOPLE_PAGE_FILTERS_LOCATION_SELECTED: "{number} Location selected",
  PEOPLE_PAGE_FILTERS_PERSONAL_INTEREST_SELECTED: "{number} Personal Interest selected",
  PEOPLE_PAGE_FILTERS_ENGLISH_INTEREST_SELECTED: "{number} English Interest selected",
  PEOPLE_PAGE_FILTERS_ENGLISH_LEVEL_SELECTED: "{number} English Level selected",
  PEOPLE_PAGE_FILTERS_MEMBER_TYPES_SELECTED: "{number} Member Types selected",
  PEOPLE_PAGE_FILTERS_OCCUPATION_SELECTED: "{number} Occupation selected",
  PEOPLE_PAGE_FILTERS_LOCATIONS_SELECTED: "{number} Locations selected",
  PEOPLE_PAGE_FILTERS_PERSONAL_INTERESTS_SELECTED: "{number} Personal Interests selected",
  PEOPLE_PAGE_FILTERS_ENGLISH_INTERESTS_SELECTED: "{number} English Interests selected",
  PEOPLE_PAGE_FILTERS_ENGLISH_LEVELS_SELECTED: "{number} English Levels selected",
  PEOPLE_PAGE_FILTERS_OCCUPATIONS_SELECTED: "{number} Occupations selected",
  PEOPLE_PAGE_MEMBERS_WHO_MATCH: "Members who match your profile",
  PEOPLE_PAGE_ONLINE_MEMBERS_WHO_MATCH: "Online members who match your profile",
  PEOPLE_PAGE_MEMBERS_SEE_HOW_YOU_MATCH:
    "Click the 'rotate' icon to see how you match. Use the filters to generate" +
    " your own results.",
  PEOPLE_PAGE_MEMBERS_CLICK_ROTATE: "Click the 'rotate' icon to see how you match.",
  PEOPLE_PAGE_HLT_MEMBERS: "Here are the members of our amazing team!",
  PEOPLE_PAGE_HLT_MEMBERS_DESCRIPTION:
    'We\'re all here to support you, feel free to reach out and say "Hey!"',
  PEOPLE_PAGE_MEMBERS_FILTERED_RESULTS: "Filtered results ({total} members)",
  PEOPLE_PAGE_MEMBERS_SORTED_BY:
    "Sorted by relevance. Click the 'rotate' icon to see your match score.",
  PEOPLE_PAGE_YOUR_MATCH_SCORE:
    "Your match score shows much you have in common with this member based on the" +
    " information in your profile.",
  PEOPLE_PAGE_MAKE_SURE:
    "Make sure <url>your profile</url> is complete and up to date to find the perfect match!",
  PEOPLE_PAGE_HINT_ALL_MEMBERS: "Meet the members of our community!",
  PEOPLE_PAGE_HINT_ALL_PEOPLE_DESCRIPTION:
    "Use these links to switch between search, members who are online now and a helpful list of Hey Lady! team members.",
  PEOPLE_PAGE_HINT_AVAILABILITY_TITLE: "Availability & Filters",
  PEOPLE_PAGE_HINT_AVAILABILITY_DESCRIPTION:
    "We show you the members we think are a good match and are available when you are. You can use any of these filters to customise your search at any time.",
  PEOPLE_PAGE_HINT_FILTERS_DESCRIPTION_MOBILE:
    "We show you the members we think are a good match and are available when you are. You can refine your search at any time by clicking the “Customize Filters” button and adjusting the filters to your preferences.",
  PEOPLE_PAGE_HINT_MATCH_SCORE: "Find out your match score!",
  PEOPLE_PAGE_HINT_MATCH_SCORE_DESCRIPTION:
    "Click this icon to flip the card and see how you match this member based on interests, availability and English level!",
  PEOPLE_SHARED_AVAILABILITY: "Shared Availability",
  PEOPLE_DIFFERENT_AVAILABILITY: "Different Availability",
  PEOPLE_ANY_AVAILABILITY: "Any Availability",
  PEOPLE_ALL_MEMBERS: "All Members",
  PEOPLE_PEOPLE_I_FOLLOW: "People I Follow",
  PEOPLE_I_MATCH: "People I Match",
  PEOPLE_ANY_LOCATION: "Any Location",
  PEOPLE_NEAR_ME: "Near Me",
  PEOPLE_LITTLE_SISTERS: "Little Sisters",
  PEOPLE_BIG_SISTERS: "Big Sisters",
  PEOPLE_SEARCH_BY_CITY: "Search by City or Country",
  PEOPLE_SEARCH_BY_OCCUPATION: "Search by occupation",
  PEOPLE_SEARCH_FOR_INTERESTS: "Search for Interests",
  PEOPLE_SEARCH_INTERMEDIATE: "Intermediate",
  PEOPLE_SEARCH_ADVANCED: "Advanced",
  PEOPLE_SEARCH_PROFICIENT: "Proficient",
  USER_PAGE_HINT_SPEAKING_PARTNER_TITLE: "Speaking Partners",
  USER_PAGE_HINT_SPEAKING_PARTNER_DESCRIPTION:
    "If you are open to meeting new speaking partners, make sure you let us know by selecting the right option on your profile. We will use this information when making recommendations for ladies we think you should meet!",
  USER_PAGE_HINT_FOLLOW_TITLE: "Follow",
  USER_PAGE_HINT_FOLLOW_DESCRIPTION:
    "You'll be able to follow your favourite members or reach out to them directly through our chat feature. ",
  USER_PAGE_HINT_EVENTS_HOSTED_TITLE: "Track your progress",
  USER_PAGE_HINT_EVENTS_HOSTED_DESCRIPTION:
    "We'll help you keep track of how many conversations you've had and hosted so you can set goals and keep improving.",
  TOPICS_PAGE_HINT_CURRENT_THEME_TITLE: "Current Topic",
  TOPICS_PAGE_HINT_CURRENT_THEME_DESCRIPTION:
    "The current topic is the one chosen by our Coaches for the whole community to study and practise talking about. A new conversation topic is released every two weeks.",
  TOPICS_PAGE_HINT_TOPIC_LIBRARY_TITLE: "Topic Library",
  TOPICS_PAGE_HINT_TOPIC_LIBRARY_DESCRIPTION:
    "Here you will find the full range of topics that we offer. This is a fantastic way to expand your vocabulary range and talk about the subjects you're interested in.",
  TOPICS_PAGE_HINT_GRAMMAR_LIBRARY_TITLE: "Grammar Library",
  TOPICS_PAGE_HINT_GRAMMAR_LIBRARY_DESCRIPTION:
    "Just as it sounds, this is where you will find the useful lessons our Coaches have created about the grammar we often use in our conversations.",
  TOPICS_PAGE_HINT_RESOURCES_TITLE: "Resources",
  TOPICS_PAGE_HINT_RESOURCES_DESCRIPTION:
    "This is the place to find super helpful resources about how to set goals, track your progress, study and host events the “Hey Lady! way”.",
  TOPICS_PAGE_UPGRADE_TO_ACCESS: "Upgrade to access",
  TOPICS_PAGE_UNPAUSE_TO_ACCESS: "Unpause to access",
  HOME_PAGE_JOIN_YOUR_FIRST_EVENT: "Join your first event!",
  HOME_PAGE_CHOOSE_TIME: "Choose a time",
  HOME_PAGE_COMPLETE_YOUR_PROFILE_GET_CHANCES:
    "By completing your profile it will be easier for us to help you find people to meet and practise with!",
  HOME_PAGE_VIEW_DETAILS: "View Details",
  HOME_PAGE_TO_UNLOCK:
    "To unlock all platform features you will need to attend an event where you will be kindly welcomed by our team.",
  HOME_PAGE_YOUR_VIDEO: "Your video will be reviewed soon!",
  HOME_PAGE_WAITING_FOR_VERIFICATION:
    "We have received your video. We review and verify all new members within 24" +
    " hours. This step will be marked as complete once you are verified.",
  HOME_PAGE_THANK_YOU_FOR_PATIENCE: "Thank you for your patience.",
  HOME_PAGE_LADIES_YOU_SHOULD_MEET: "Members we think you should meet!",
  HOME_PAGE_EVENTS: "Events for you",
  HOME_PAGE_WATCH_VIDEOS: "Watch videos to learn the basics!",
  HOME_PAGE_TRAINING_VIDEOS: "Helpful training videos from the team",
  HOME_PAGE_WATCH_AGAIN: "Watch again",
  HOME_PAGE_COMPLETED: "Completed",
  HOME_PAGE_FINISHED: "Have you finished watching the video?",
  HOME_PAGE_VIDEO_INFORMATION:
    "The information in this video will help you to unlock the quiz and answer all" +
    " questions successfully!",
  HOME_PAGE_WATCH_LATER: "Watch later",
  HOME_PAGE_MARK_COMPLETE: "Yes, mark as complete",
  HOME_PAGE_MORE_MEMBERS_YOU_MATCH: "More members you match",
  HOME_PAGE_THE_FIRST_THING_YOU_NEED:
    "The first thing you need to do is complete the steps below to verify your profile. Once complete, you'll be able to meet other members and join all our events!",
  HOME_PAGE_ADD_DETAILS: "The first thing you need to do is add a few details to your profile.",
  HOME_PAGE_THEN_COME_ALONG: "Then, come along to your first event to meet our team!",
  HOME_PAGE_YOUR_ACCOUNT_WILL_BE_VERIFIED:
    "For your safety all members are required to attend a New Member Meet-Up to say hello and verify their identity. Choose the best time for you!",
  HOME_PAGE_FIND_AN_EVENT:
    'Find an event that interests you and say "Hey" to our team. You\'ll meet other ladies and unlock access to all events and platform features!',
  HOME_PAGE_A_LITTLE_ABOUT_ME: "A little about me:",
  PEOPLE_PAGE_MATCH_SCORE: "Match score",
  PEOPLE_PAGE_MATCHING_SAME_CITY: "You live in the same city!",
  PEOPLE_PAGE_MATCHING_CONVERSATION_QUEEN: "Conversation Queen",
  PEOPLE_PAGE_MATCHING_OPEN_TO_NEW_SPEAKING_PARTNERS: "Open to new speaking partners",
  PEOPLE_PAGE_MATCHING_INTERESTS_YOU_SHARE: "Interests you share:",
  PEOPLE_PAGE_MATCHING_SKILLS_YOU_SHARE: "Both want to improve:",
  NOTIFICATIONS_NO_NOTIFICATIONS_YET: "No notifications yet!",
  NOTIFICATIONS_PAGE_ALL: "All ({number})",
  NOTIFICATIONS_PAGE_NOTIFICATIONS: "Notifications",
  NOTIFICATIONS_PAGE_PUBLISHED_EVENT: "{actor} has created a new event, {event}.",
  NOTIFICATIONS_PAGE_MENTION: "{actor} has just mentioned you in the discussion for {event}.",
  NOTIFICATIONS_PAGE_CHAT_MENTION: "{actor} has just mentioned you in a chat message!",
  NOTIFICATIONS_PAGE_CHAT_UNREAD_MESSAGE: "You have unread messages in a thread",
  NOTIFICATIONS_PAGE_CHAT_MENTION_VIEW_CHAT: "View Comment",
  NOTIFICATIONS_PAGE_CHAT_CHANNEL_INVITE: "{actor} has invited you to join {channelName} channel.",
  NOTIFICATIONS_PAGE_INVITATION_EVENT: "{actor} has invited you to join her for {event} on {time}.",
  NOTIFICATIONS_PAGE_INVITATION_DELETED_EVENT:
    "{actor} has invited you to join already deleted event {event} on {time}.",
  NOTIFICATIONS_PAGE_INVITATION_STATUS: `You've {status, select, 
    Accepted {accepted}
    Declined {declined}
    other {not decided}
  } the invitation.`,
  NOTIFICATIONS_PAGE_ACCOUNT_SETTINGS: "Notification Settings",
  NOTIFICATIONS_PAGE_ACCEPTED_INVITATION:
    "{actor} has accepted your invitation for {event} on {time}.",
  NOTIFICATIONS_PAGE_DECLINED_INVITATION:
    "{actor} has declined your invitation for {event} on {time}.",
  NOTIFICATIONS_PAGE_RECURRING_RESPONSE: "{actor} has responded to your invitation for {event}.",
  NOTIFICATIONS_PAGE_SEE_RESPONSE: "See response",
  RECURRING_RESPONSE_MODAL_TITLE: "Recurring Event Schedule",
  RECURRING_RESPONSE_MODAL_CLOSE: "Close",
  RECURRING_RESPONSE_ROW_ACCEPTED: "Accepted",
  RECURRING_RESPONSE_ROW_DECLINED: "Declined",
  NOTIFICATIONS_PAGE_NO_RESPONSE_INVITATION:
    "{actor} hasn't responded yet to your invitation for {event}.",
  NOTIFICATIONS_PAGE_INVITATION_EVENT_AS_COHOST:
    "{actor} has invited you to co-host {event} on {time}.",
  NOTIFICATIONS_PAGE_INVITATION_EVENT_AS_HOST:
    "{actor} has assigned you as the host of {event} on {time}.",
  NOTIFICATIONS_PAGE_SHARED_EVENT: "{actor} has shared {event} with you. Check it out!",
  NOTIFICATIONS_PAGE_SHARED_DELETED_EVENT:
    "{actor} has shared {event} with you. Unfortunately, the event has been deleted.",
  NOTIFICATIONS_PAGE_SYSTEM_MESSAGES: "System Messages",
  NOTIFICATIONS_PAGE_UPDATE: "The scheduled time of an event you're going to has been updated.",
  NOTIFICATIONS_PAGE_UPDATED_EVENT: "Event: {event}",
  NOTIFICATIONS_PAGE_NEW_TIME: "New time: {time}",
  NOTIFICATIONS_PAGE_IMPORTANT:
    'IMPORTANT: Please "refresh" your browser after reading this message. This will ensure the link to join the event is updated for you.',
  NOTIFICATIONS_PAGE_DELETED_EVENT:
    "{actor} has deleted an event you were going to {event}, on {time}",
  NOTIFICATIONS_PAGE_DELETED_EVENT_NOTE: "She left a note: {note}",
  NOTIFICATIONS_PAGE_REMOVED_PARTICIPANT:
    "{actor} has removed you as a participant for the event {event} on {time}. If you think this was an error, kindly contact {actor} to let her know.",
  NOTIFICATIONS_PAGE_REMOVED_COHOST:
    "{actor} has removed you as co-host for the event {event} on {time}. If this was an error, kindly contact {actor} to let her know.",
  NOTIFICATIONS_PAGE_NEW_EVENT: "{actor}, who you follow, is hosting {event} on {time}",
  NOTIFICATIONS_WE_WILL_LET_YOU_KNOW: "We'll let you know as soon as something arrives!",
  NOTIFICATIONS_CARD: "See all notifications",
  NOTIFICATIONS_EVENT_IS_STARTING: "Event starting soon!",
  NOTIFICATIONS_REMINDER:
    "A friendly reminder to let you know that {event} is starting in {time} minutes.",
  NOTIFICATION_MARK_ALL_AS_READ: "Mark all as read",
  NOTIFICATION_VIEW_EVENT: "View Changes",
  NOTIFICATION_GO_TO_COMMENT: "Go to comment",
  NOTIFICATION_GO_TO_THREADS: "Go to threads",
  NOTIFICATION_GO_TO_CHANNEL: "Go to channel",
  NOTIFICATION_VIEW_ARTICLE: "View article",
  NOTIFICATION_GOT_IT: "Got it",
  NOTIFICATION_CONTACT_HOST: "Contact Host",
  NOTIFICATION_INVITATION_SUCCESSFULLY_ACCEPTED: "Invitation successfully accepted",
  NOTIFICATION_INVITATION_SUCCESSFULLY_DECLINED: "Invitation successfully declined",
  NOTIFICATION_ADD_EVENT: "Add to calendar",
  NOTIFICATION_CONTACT: "Contact",
  NOTIFICATIONS_PAGE_RECEIVED: "Received {time}",
  NOTIFICATIONS_COMMENT: "{actor} has commented on {event}",
  NOTIFICATIONS_ARTICLE_PUBLISHED:
    "{actor} who you follow, has just published a new article: {title}",
  NOTIFICATIONS_CONFIRM_IN_PERSON:
    "You recently hosted ‘{event}’ but we are still waiting for you to confirm who attended so that we can update everyone’s profile.{br} If you or your co-host has already done this, you can ignore this message.{br} Otherwise, please, do it now.",
  NOT_FOUND_CONTACT_US: "Contact us about the problem",
  NOT_FOUND_GO_TO_HOME: "Go to Home Page",
  NOT_FOUND_THE_LINK:
    "The link you followed may be broken or this page does not exist any more. But don't worry, we have lots of other interesting things for you instead.",
  NOT_FOUND_WHOOPS: "Whoops, we can't find this page",
  ONBOARD_SETUP_PROFILE: "Set up your profile",
  ONBOARD_SETUP_INTRO_TITLE: "Get matched with the best people & events for your goals",
  ONBOARD_SETUP_INTRO_DESCRIPTION:
    "Complete the form to earn your ‘Perfect Profile’ badge! {br} <bold>NOTE</bold>: We will never share your personal information with anyone outside the Hey Lady! platform.",
  ONBOARD_ADD_PHOTO: "Add Photo",
  ONBOARD_DROP_PHOTO: "Drop photo",
  ONBOARD_ADD_PHOTO_TITLE: "Add Your Photo!",
  ONBOARD_ADD_PHOTO_DESCRIPTION:
    "Be sure to choose a photo that is friendly and welcoming so others can easily recognised you! {br} <bold>Note</bold>: We will never share your image outside our platform without your permission.",
  ONBOARD_ADD_STORY_TITLE: "Please, write your introduction",
  ONBOARD_ADD_STORY_DESCRIPTION:
    "What would you like someone to know about you when we introduce you? {br} <bold>TIP</bold>: Try to include something unique about you, that might spark conversation! (Minimum 30 words)",
  ONBOARD_INTRODUCE_YOU_TO_MEMBERS:
    "We want to introduce you to members who share your interests! Choose up to eight (8) interests and hobbies from the list below.",
  ONBOARD_AVAILABILITY: "When are you available to practise and improve your English?",
  ONBOARD_USE_YOUR_PHOTO:
    "We will use your photo when introducing you. Be sure to choose one that is friendly and welcoming..",
  ONBOARD_FRIDAY_SUNDAY: "Friday - Sunday",
  ONBOARD_MONDAY_THURSDAY: "Monday - Thursday",
  ONBOARD_B1: "B1",
  ONBOARD_INTERMEDIATE: "Intermediate",
  ONBOARD_B2: "B2",
  ONBOARD_UPPER: "Upper",
  ONBOARD_UPPER_INTERMEDIATE: "Intermediate",
  ONBOARD_C1: "C1",
  ONBOARD_ADVANCED: "Advanced",
  ONBOARD_C2: "C2",
  ONBOARD_PROFICIENT: "Proficient",
  ONBOARD_START_TYPING_HERE: "Start typing here..",
  ONBOARD_CHOSEN_SKILLS: "You have chosen {number} out of {total} skills",
  ONBOARD_CHOSEN_INTERESTS: "You have chosen {number} out of {total} interests",
  ONBOARD_USE_YOUR_ANSWERS:
    "We will use your answers  to recommend people and events that match your availability.",
  ONBOARD_UPDATE_LATER: "You can easily update this later if you need to.",
  ONBOARD_ENGLISH_GOALS:
    "We want to help you achieve your English goals! Choose up to five (5) skills from the list below.",
  ONBOARD_SMILE: "Show us your beautiful smile!",
  ONBOARD_WELCOME: "Welcome {name}!",
  ONBOARD_READY_TO_MEET: "Ready to meet friends to practise English with?",
  ONBOARD_START: "We’ll start by asking some simple questions to create your profile.",
  ONBOARD_USE_ANSWERS:
    "We will use your answers to introduce you to other members we think you should meet.",
  ONBOARD_WHAT_CITY_DO_YOU_LIVE: "What city do you live in?",
  ONBOARD_ENGLISH_SKILLS: "What English skills do you want to practise & improve?",
  ONBOARD_CONFIRM_YOUR_NAME: "Please confirm your name",
  ONBOARD_WHAT_ARE_YOUR_INTERESTS: "What are your interests & hobbies?",
  ONBOARD_SHARE_YOUR_STORY: "Let’s share your story!",
  ONBOARD_FANTASTIC: "Fantastic!",
  ONBOARD_STEP_INSIDE: "Let’s step inside {logo} so you can take a look around.",
  ONBOARD_EMAIL:
    "We will email you in the coming days with tips from our team to help you meet speaking partners and learn how to use the platform.",
  ONBOARD_ENTER: "Enter",
  ONBOARD_CLOSE_EDIT_PROFILE_TITLE: "Are you sure you want to leave before you finish?",
  ONBOARD_CLOSE_EDIT_PROFILE_DESCRIPTION: "Your information will not be saved.",
  ONBOARD_MISSING_FIELDS: "To complete this step, you need to add:",
  ONBOARD_SETUP_PROFILE_MISSING_PHOTO: "Photo",
  ONBOARD_SETUP_PROFILE_MISSING_FIRST_NAME: "First name",
  ONBOARD_SETUP_PROFILE_MISSING_LAST_NAME: "Last name",
  ONBOARD_SETUP_PROFILE_MISSING_STORY: "Personal introduction (min 30 words)",
  SEARCH_BAR_SEARCH_RESULTS: "Search results",
  SEARCH_BAR_START_TYPING: "Start typing",
  SEARCH_BAR_EVENTS: "Events:",
  SEARCH_BAR_LOADING: "Searching...",
  SEARCH_BAR_NO_EVENTS_FOUND: "No events found",
  SEARCH_BAR_OPTION_MEMBERS: "Members",
  SEARCH_BAR_OPTION_MEMBERZINE: "Memberzine",
  SEARCH_BAR_OPTION_RESOURCES: "Resources",
  SEARCH_BAR_ARTICLE_LABEL: "Article:",
  SEARCH_BAR_LESSON_LABEL: "Lesson:",
  SETTINGS_FIRST_PAYMENT_JOIN_COMMUNITY: "Join the Community",
  SETTINGS_FIRST_PAYMENT_YOUR_JOURNEY_BEGINS: "Your journey begins with our Foundations Program",
  SETTINGS_FIRST_PAYMENT_CLICK_HERE: "<url>Click here</url> for full details",
  SETTINGS_FIRST_PAYMENT_FOUNDATIONS_PROGRAM: "Foundations Program",
  SETTINGS_FIRST_PAYMENT_A_LIFE_CHANGING_EXPERIENCE: "A life-changing English experience!",
  SETTINGS_FIRST_PAYMENT_COACHING_FROM_EXPERTS: "Coaching from expert English teachers",
  SETTINGS_FIRST_PAYMENT_ACCESS_TO_MATERIALS:
    "Access to structured learning materials, workbooks and conversation training",
  SETTINGS_FIRST_PAYMENT_GET_INTRODUCED_TO_SPEAKING_PARTNERS: "Get introduced to speaking partners",
  SETTINGS_FIRST_PAYMENT_DAILY_EVENTS: "Daily events to learn and practise together!",
  SETTINGS_FIRST_PAYMENT_USD_PER_MONTH: "USD/month",
  SETTINGS_FIRST_PAYMENT_SPECIAL_OFFER: "Special Offer",
  SETTINGS_FIRST_PAYMENT_OFFER_FOR_NEW_MEMBERS: "Introductory offer for new members",
  SETTINGS_FIRST_PAYMENT_CANCEL_ANY_TIME: "You can cancel any time.",
  SETTINGS_FIRST_PAYMENT_FOUNDATIONS: "Foundations",
  SETTINGS_FIRST_PAYMENT_3_MONTH_PACKAGE: "{months} Month Package",
  SETTINGS_FIRST_PAYMENT_SET_YOURSELF_UP_FOR_SUCCESS: "Set yourself up for success!",
  SETTINGS_FIRST_PAYMENT_IMMERSE_YOURSELF:
    "Immerse yourself in our English-speaking community for three months and get results you can actually ",
  SETTINGS_FIRST_PAYMENT_FEEL: "feel!",
  SETTINGS_FIRST_PAYMENT_SIGN_UP: "Sign up for 3 months and save!",
  SETTINGS_FIRST_PAYMENT_MONEY_BACK: "14 day money-back guarantee",
  SETTINGS_FIRST_PAYMENT_PURCHASE_PACKAGE: "Purchase Package",
  SETTINGS_FIRST_PAYMENT_USD_MONTH: "USD/{months} mths",
  SETTINGS_FIRST_PAYMENT_EQUIVALENT_PER_WEEK: "Equivalent {amount} USD / week",
  SETTINGS_PAGE_ACTIVITY_AN_EMAIL_WILL_BE_SENT:
    "An email will be sent to you every time there is new activity",
  SETTINGS_PAGE_ACTIVITY_HAPPENS: "Activity happens",
  SETTINGS_PAGE_CHANGE_PASSWORD: "Change Password",
  SETTINGS_PAGE_CHANGE_OLD_PASSWORD_HINT: "The password is required",
  SETTINGS_PAGE_DAILY_DIGEST: "Daily Digest",
  SETTINGS_PAGE_DAILY_DIGEST_EMAIL_WILL_BE_SENT:
    "A daily digest email will be sent to you each day to summarise your notification. Note that time-sensitive notifications may still send as activity happens, including account updates and event reminders",
  SETTINGS_PAGE_EMAIL_AND_PASSWORD: "Email & Password",
  SETTINGS_PAGE_EMAIL_ME_WHEN: "Email me when",
  SETTINGS_PAGE_ACCOUNT_SETTINGS: "Account Settings",
  SETTINGS_PAGE_CANCEL_GUEST_PASS: "Cancel Guest Pass",
  SETTINGS_PAGE_NOTIFICATIONS_SETTINGS: "Notification Settings",
  SETTINGS_SECURITY_SESSIONS_TITLE: "Where you're signed in",
  SETTINGS_SECURITY_SESSIONS_DESCRIPTION:
    "Devices with an active session on your account. Sign out any device you don't recognise.",
  SETTINGS_SECURITY_SESSIONS_CURRENT_DEVICE: "this device",
  SETTINGS_SECURITY_SESSIONS_SIGN_OUT: "Sign out",
  SETTINGS_SECURITY_SESSIONS_SIGN_OUT_OTHERS: "Sign out all other devices",
  SETTINGS_SECURITY_SESSIONS_LAST_ACTIVE: "Last active",
  SETTINGS_SECURITY_SESSIONS_EMPTY: "No active sessions found.",
  SETTINGS_PAGE_NEVER_MISS_A_THING:
    "Never miss a thing! Tick the boxes below to manage how you would like to receive notifications.",
  SETTINGS_PAGE_PLATFORM: "Platform",
  SETTINGS_PAGE_EMAIL: "Email",
  SETTINGS_PAGE_WEB_NOTIFICATIONS: "Push",
  SETTINGS_PAGE_EVENT_UPDATES_AND_INVITATIONS: "Event updates and invitations",
  SETTINGS_PAGE_EVENT_UPDATES_AND_INVITATIONS_DESCRIPTION:
    "Get notified when a host invites you to their event  or when changes are made to the date or time.",
  SETTINGS_PAGE_EVENT_REMINDERS: "Event Reminders",
  SETTINGS_PAGE_EVENT_REMINDERS_DESCRIPTION:
    "Get reminders when an event you’re going to is about to start.",
  SETTINGS_PAGE_EVENT_RSVPS: "Event RSVP’s",
  SETTINGS_PAGE_EVENT_RSVPS_DESCRIPTION:
    "Get notified when someone you invite to an event accepts or declines",
  SETTINGS_PAGE_ACTIVITY_FROM_MEMBERS: "Activity From Members You Follow",
  SETTINGS_PAGE_ACTIVITY_FROM_MEMBERS_DESCRIPTION:
    "Get notified about new activity from the members that matter to you.",
  SETTINGS_PAGE_MENTIONS_AND_COMMENTS: "Mentions and comments",
  SETTINGS_PAGE_MENTIONS_AND_COMMENTS_DESCRIPTION:
    "Get notified when someone mentions you in a comment",
  SETTINGS_PAGE_CHAT_MENTIONS: "Mentions in chat",
  SETTINGS_PAGE_CHAT_MENTIONS_DESCRIPTION:
    "Get notified when someone mentions you in a chat group message",
  SETTINGS_PAGE_CHAT_UNREAD_MESSAGES_IN_THREAD: "Unread messages in thread",
  SETTINGS_PAGE_CHAT_UNREAD_MESSAGES_IN_THREAD_DESCRIPTION:
    "Get notified when you have an unread message in a chat thread",
  SETTINGS_PAGE_CHANNEL_INVITE: "Chat Group or Channel invitations",
  SETTINGS_PAGE_CHANNEL_INVITE_DESCRIPTION:
    "Get notified when someone invites you to join their private chat group or public channel",
  SETTINGS_PAGE_LIVE_TABLE_STARTED: "Live Table has started",
  SETTINGS_PAGE_LIVE_TABLE_STARTED_DESCRIPTION:
    "Get notified when someone has started a new live table",
  SETTINGS_PAGE_PERSONAL_MESSAGES: "Personal messages",
  SETTINGS_PAGE_PERSONAL_MESSAGES_DESCRIPTION:
    "Get notified when someone sends you a direct personal message",
  SETTINGS_PAGE_GROUP_MESSAGES: "Group messages",
  SETTINGS_PAGE_GROUP_MESSAGES_DESCRIPTION:
    "Get notified when someone sends a message to your group",
  SETTINGS_PAGE_PUBLIC_CHANNELS_MESSAGES: "Public channels messages",
  SETTINGS_PAGE_PUBLIC_CHANNELS_MESSAGES_DESCRIPTION:
    "Get notified when someone sends you a message to a public channel you are in",
  SETTINGS_PAGE_PLATFORM_STATUS: "Platform status",
  SETTINGS_PAGE_PLATFORM_STATUS_DESCRIPTION:
    "Get notified when there are changes affecting the platform",
  SETTINGS_PAGE_MEMBERSHIP_SUBSCRIPTION_CHANGES: "Membership subscription changes",
  SETTINGS_PAGE_MEMBERSHIP_SUBSCRIPTION_CHANGES_DESCRIPTION:
    "Get confirmation of changes to your subscription",
  SETTINGS_PAGE_MONTHLY_PLAN: "Monthly Plan",
  SETTINGS_PAGE_QUARTERLY_PLAN: "Quarterly Plan",
  SETTINGS_PAGE_ANNUAL_PLAN: "Yearly Plan",
  SETTINGS_PAGE_MEMBERSHIP_SETTINGS: "Membership Settings",
  SETTINGS_PAGE_NOTIFY_ME_BY_EMAIL: "Yes, notify me by email",
  SETTINGS_PAGE_ACTIVATE_MEMBERSHIP: "Yes, unpause",
  SETTINGS_PAGE_READY_TO_COME_BACK_EARLY: "Ready to come back early?",
  SETTINGS_PAGE_YOURE_READY_TO_ACTIVATE:
    "We will un-pause your billing and restore access to all the events and features in the platform",
  SETTINGS_PAGE_DELETED_ACCOUNT_HEADER: "Your account is going to be deleted",
  SETTINGS_PAGE_DELETED_ACCOUNT_DESCRIPTION:
    "This account {email} is going to be deleted. You can still recover this account until it is deleted completely.",
  SETTINGS_PAGE_DELETED_ACCOUNT_RECOVER: "Recover account",
  SETTINGS_PAGE_DELETED_ACCOUNT_ERROR_RECOVER:
    "Failed to recover an account. Please try again later or contact support!",
  SETTINGS_MEMBERSHIP_FREE_MEMBERSHIP: "You have 1 Month of Free Membership!",
  SETTINGS_MEMBERSHIP_FREE_THANKS:
    "Thanks for your contribution to building The Hey Lady Community!",
  SETTINGS_MEMBERSHIP_FREE_USE: "Use",
  SETTINGS_PAGE_FREE: "Free",
  SETTINGS_SWITCH_MEMBERSHIP_PLAN: "Switch Membership Plan?",
  SETTINGS_SWITCH_MEMBERSHIP_WHEN_YOU_SWITCH:
    "When you switch plans, the change will happen at the end of your current billing cycle.{br}{br}{has_current_term_end, select, yes {Your new plan will start on {current_term_end} when your current plan ends.} other {We’ll confirm the start date when your plan change is scheduled.}}",
  SETTINGS_SWITCH_MEMBERSHIP_KEEP_CURRENT: "Keep current",
  SETTINGS_MEMBERSHIP_YEARLY_SWITCH_PLAN: "Switch Plan",
  SETTINGS_SWITCH_MEMBERSHIP_LEGACY_SUBTITLE: "Please read this first.",
  SETTINGS_UPGRADE_TO_SOCIAL: "Upgrade to Basic?",
  SETTINGS_UPGRADE_TO_SOCIAL_COACHING: "Upgrade to Premium?",
  SETTINGS_UPGRADE_MEMBERSHIP_WHEN_YOU_SWITCH:
    "When you switch plans, the changes will apply immediately.{br}{br}We will adjust your first payment with any credit remaining on your existing plan. You can also edit your payment method details if you need to.",
  SETTINGS_SWITCH_MEMBERSHIP_LEGACY: "Before you switch",
  SETTINGS_SWITCH_MEMBERSHIP_LEGACY_DESCRIPTION:
    "You are currently on a membership plan that we no longer offer to new members.{br}{br}If you switch plans, the following changes will apply at the end of your current billing cycle:{br}<ul><li>Your membership will change to the new plan</li><li>You won’t be able to return to this plan later.</li><li>The same applies if you cancel and rejoin.</li></ul>{br}{has_current_term_end, select, yes {Your new plan will start on {current_term_end}.} other {We’ll confirm the start date when your plan change is scheduled.}}",
  SETTINGS_SWITCH_MEMBERSHIP_LEGACY_CONTACT_SUPPORT:
    "We want to make sure you have all the information so you can choose what’s right for you. If you have any questions or issues, please contact support at <url>hello@heylady.io</url>",
  SETTINGS_MEMBERSHIP_YOU_ARE_STAYING: "YAY! You're staying!",
  SETTINGS_MEMBERSHIP_YOUR_REQUEST:
    "Your request to cancel has been removed and your membership will continue at the end of your current billing cycle.",
  SETTINGS_MEMBERSHIP_SUCCESS: "Success!",
  SETTINGS_MEMBERSHIP_REACTIVATED_SUBSCRIPTION:
    "Welcome back {name}! {br} See you inside an event soon!",
  SETTINGS_FOUNDATIONS: "Foundations",
  SETTINGS_FOUNDATIONS_PACKAGE: "Foundations Package",
  SETTINGS_FOUNDATIONS_DESCRIPTION:
    "Need a little extra support? This plan includes guided conversations hosted by our qualified English teachers.",
  SETTINGS_RISE_MONTHLY: "Rise Monthly",
  SETTINGS_RISE_MONTHLY_DESCRIPTION:
    "Focus on fluency and take your English journey into your own hands. Create and host your own events with English-speaking friends around the world!",
  SETTINGS_RISE_YEARLY: "Rise Yearly",
  SETTINGS_RISE_YEARLY_PER_YEAR: "USD/year",
  SETTINGS_RISE_YEARLY_DESCRIPTION:
    "Same as Rise Monthly but commit to your progress for a full year and save!",
  SETTINGS_ANNUAL_PLAN_DESCRIPTION:
    "<ul><li>Save $20 per month</li><li>Get 1 x FREE Speaking Assessment with every renewal</li><li>Book a private 1:1 with a coach</li></ul>",
  SETTINGS_QUARTERLY_PLAN_DESCRIPTION:
    "<ul><li>Save $10 per month</li><li>Get 1 x FREE Speaking Assessment with every renewal</li></ul>",
  SETTINGS_QUARTERLY_PLAN_DESCRIPTION_BOTTOM: "",
  SETTINGS_FREE_PLAN_DESCRIPTION:
    "Enjoy one month of free access to everything the community offers.{br} {br} You can switch to an ongoing paid membership plan at any time and help us in creating safe spaces for women worldwide to find their voice!",
  SETTINGS_SOCIAL_PLAN_DESCRIPTION:
    "Community access, friendships and unlimited practice. <strong>Excludes</strong> Coach Events, Grammar Library and Topic Library.",
  SETTINGS_MONTHLY_PLAN_DESCRIPTION:
    "The same full access to Coach Events, community and unlimited speaking practice, paid month by month.",
  SETTINGS_SOCIAL_PLAN_DESCRIPTION_BOTTOM: "",
  SETTINGS_3_MTH_DESCRIPTION:
    "This introductory plan gives you three months access to Hey Lady! to meet new friends and build your fluency in" +
    " real conversations!",
  SETTINGS_3_MTH_DESCRIPTION_2: "Switch plans to extend your membership at any time.",
  SETTINGS_SUPPORTER_PLAN_DESCRIPTION_TOP:
    "Feel good supporting Hey Lady! as a friend while you take a break.",
  SETTINGS_SUPPORTER_PLAN_DESCRIPTION_BOTTOM:
    "You will still have access to basic platform features and your profile history, badges and achievements will be waiting for you when you return!",
  SETTINGS_CARD_PAUSED_UNTIL: "Paused. Returning {date}",
  SETTINGS_LEGACY_CARD_DESCRIPTION:
    "<strong>About your plan</strong>{br}The price you currently pay is no longer offered to new members. As a valued member, you can keep your current pricing for as long as you remain on this plan.{br}{br}However, if you switch plans, this price will not be available again. The same applies if you cancel and rejoin.",
  SETTINGS_SCHEDULED_CHANGE_TITLE: "Scheduled change confirmed!",
  SETTINGS_CARD_PAUSED: "Membership paused",
  SETTINGS_SCHEDULED_CHANGE_DESCRIPTION:
    "You have successfully scheduled to switch plans.{br}{br}{has_current_term_end, select, yes {Your new {plan_type} plan will start on {current_term_end} when your current plan ends.} other {Your new {plan_type} plan will start at the end of your current billing cycle.}}",
  // biome-ignore lint/suspicious/noTemplateCurlyInString: it's a different kind of template
  SETTINGS_CARD_DAYS_REMAINING: "{days} days remaining (then ${amount}/mth)",
  SETTINGS_CARD_BILLING_DATE_UNAVAILABLE: "Billing date unavailable",
  SETTINGS_CARD_RENEWS_IN: "renews in {days} days",
  SETTINGS_CARD_DAYS_LEFT: "{days} days remaining",
  SETTINGS_FIXED_PLAN_TITLE:
    "Current Plan: <bold>Premium - {months, plural, one {1 month only} other {# months only}}</bold>",
  SETTINGS_FIXED_PLAN_END:
    "{has_date, select, yes {Ends on: <bold>{date}</bold>.} other {End date unavailable}}",
  SETTINGS_FIXED_PLAN_CONTINUE:
    "<bold>Want to continue?</bold> Extend your membership by choosing a plan below.",
  SETTINGS_FIXED_PLAN_SCHEDULED:
    "Your switch to {plan} {cadence} is scheduled for the end of this fixed plan.",
  SETTINGS_FIXED_PLAN_SWITCH_TITLE: "Switch to a recurring membership?",
  SETTINGS_FIXED_PLAN_SWITCH_DESCRIPTION:
    "{has_current_term_end, select, yes {Your {plan} {cadence} membership will start on {current_term_end}, when your fixed plan ends.} other {Your {plan} {cadence} membership will start when your fixed plan ends. Please contact support to confirm the start date.}}{br}{br}You’ll pay {amount} every {period}, with automatic renewal.",
  SETTINGS_FIXED_PLAN_LEGACY_WARNING:
    "If you switch, you won’t be able to return to your current plan or legacy price.",
  SETTINGS_CARD_SWITCHES_IN: "Switches in {days} days",
  // biome-ignore lint/suspicious/noTemplateCurlyInString: React Intl placeholder with a literal currency symbol
  SETTINGS_CARD_YOU_PAY: "You pay: ${amount}/{period}",
  // biome-ignore lint/suspicious/noTemplateCurlyInString: React Intl placeholder with a literal currency symbol
  SETTINGS_CARD_SAVINGS: "Save ${amount} over {months} months",
  SETTINGS_CARD_BENEFIT_COMMUNITY: "Community access, friendships",
  SETTINGS_CARD_BENEFIT_EVENTS: "Live Tables, Community & Member Events",
  SETTINGS_CARD_BENEFIT_TOPIC_LIBRARY: "Current Topic & Additional Topic Library",
  SETTINGS_CARD_BENEFIT_COACH_LIBRARY: "Coach Events & Grammar Library",
  SETTINGS_CARD_BENEFIT_CHALLENGES: "Monthly Challenges",
  SETTINGS_CARD_BENEFIT_CURRENT_TOPIC: "Current Topic",
  SETTINGS_CARD_BENEFIT_BASIC_EXCLUSIONS:
    "Excludes Coach Events, Grammar Library, Additional Topics, Monthly Challenges",
  SETTINGS_CARD_BENEFIT_EVENTS_COMPACT: "Live Tables & Member Events",
  SETTINGS_CARD_ASSESSMENT_BONUS: "Bonus! 1 x Speaking Assessment Credit",
  SETTINGS_CARD_USD_PER_MONTH: "USD/month",
  SETTINGS_CARD_USD_PER_THREE_MONTHS: "USD/3 months",
  SETTINGS_CARD_DIFFERENCE: "What’s the difference?",
  SETTINGS_CARD_CURRENT_PLAN: "Current plan",
  SETTINGS_CARD_ABOUT_YOUR_PLAN: "About your plan",
  SETTINGS_CARD_PAUSE_UPDATE: "Update account details",
  SETTINGS_CARD_UNPAUSE_NOW: "Unpause now",
  SETTINGS_CARD_CHOOSE_PLAN: "Choose this plan",
  SETTINGS_CARD_BUY_PLAN: "Buy this plan",
  SETTINGS_CARD_SWITCH: "Switch to this plan",
  SETTINGS_CARD_ACTIVATE: "Activate",
  SETTINGS_PLAN_DIFFERENT_PRICE_TOOLTIP:
    "The current price of this plan is now {planAmount}/{period}. As an existing subscriber you will continue to enjoy {userAmount}/{period} until you cancel. If you rejoin after cancelling the increased price will apply.",
  SETTINGS_ACTIVATE_MODAL_HEADING: "Ready to be a Member?",
  SETTINGS_ACTIVATE_MODAL_DESC: "Upgrade today to get instant access to all events and features.",
  SETTINGS_ACTIVATE_MODAL_DESC_CHARGE:
    "If you choose to upgrade, your free trial will end today and your account will be charged automatically for your membership.",
  SPARKS_MODAL_AFTER_CALL_TITLE: "{name}, did you feel a spark?",
  SPARKS_MODAL_AFTER_CALL_DESCRIPTION:
    "We hope so! If you felt a meaningful connection to one lady (or many ladies) during this conversation, let us know by clicking the button below!",
  SPARKS_MODAL_AFTER_CALL_YES_BUTTON: "Yes, I felt a spark!",
  SPARKS_MODAL_AFTER_CALL_NO_BUTTON: "Sorry, not this time",
  TRIAL_BANNER_HEADING: "Congratulations! You've got credit!",
  TRIAL_BANNER_DESCRIPTION:
    "The next time your Hey Lady! account is charged, any available credit will be used to reduce the total!",
  REFERRAL_BANNER_HEADING: "Invite a friend to join for FREE and you could earn rewards!",
  REFERRAL_BANNER_LINK: "<link>Find out more</link>",
  REFERRAL_BANNER_HEADING_BF: "Black Friday - $30 for you and your friends!",
  REFERRAL_BANNER_DESCRIPTION_BF:
    "Share your code with a friend. If they join by 30th November, you'll both get $30" +
    " towards any membership plan! <link>See details</link>",
  REFERRAL_BANNER_BALANCE: "Credit balance:",
  REFERRAL_BANNER_CODE: "Your unique code:",
  REFERRAL_CARD_INVITE_A_FRIEND: "Invite a Friend",
  REFERRAL_CARD_REWARDS: "My Rewards",
  REFERRAL_CARD_EMAIL_SENT: "Email is sent!",
  REFERRAL_CARD_INVITE_TITLE: "Invite a friend to try{br}{HL} for FREE",
  REFERRAL_CARD_INVITE_DESCRIPTION:
    "<bold>Your friend gets a free 7-day Guest Pass PLUS US$20 bonus credit!</bold>{br}You <earnRewards>earn rewards</earnRewards> if she becomes a member.",
  REFERRAL_CARD_CHOOSE_HOW_TO_INVITE: "Choose how you want to invite them:",
  REFERRAL_CARD_ENTER_FRIEND_EMAIL:
    "Enter your friend’s email and we will send her the  invitation on your behalf.",
  REFERRAL_CAMPAIGN_LIMITED_TIME_OFFER: "LIMITED TIME OFFER",
  REFERRAL_CAMPAIGN_OFFER_BODY:
    "<bold>Help <i>Hey Lady!</i> grow</bold> - Earn $50 USD credit for every friend who joins" +
    " as a paying member by 30th June.",
  REFERRAL_CAMPAIGN_LEARN_MORE: "Learn more here",
  REFERRAL_SEND_LINK_BY_EMAIL: "Send Link by Email",
  REFERRAL_COPY_LINK_TO_CLIPBOARD: "Copy Invitation Link to Clipboard",
  REFERRAL_LINK_COPIED: "Link copied to Clipboard!",
  REFERRAL_LEARN_MORE: "<link>Click here</link> to learn more about how invitations work.",
  REFERRAL_CARD_REWARDS_TITLE: "Get a free month for every friend you bring",
  REFERRAL_CARD_REWARDS_DESCRIPTION:
    "When a friend you invite continues after their free trial on any paid membership plan you’ll get a free month added to your membership PLUS these milestone rewards!<sup>*</sup>",
  REFERRAL_BADGE_BROUGHT_FRIEND_TITLE:
    "Earn the <span>“Brought a friend”</span>badge when your first friend joins",
  REFERRAL_BADGE_AMBASSADOR_TITLE: "<span>“Ambassador”</span>- 5 friends",
  REFERRAL_BADGE_PLATINUM_AMBASSADOR_TITLE: "<span>“Platinum Ambassador”</span>- 25 friends",
  REFERRAL_BADGE_DIAMOND_AMBASSADOR_TITLE: "<span>“Diamond Ambassador”</span>- 50 friends",
  REFERRAL_REWARD_COACH_SESSION: "<span>Private 1:1 session</span>with a Hey Lady! Coach",
  REFERRAL_REWARD_COACHING_PROGRAM: "A place in any Hey Lady! small-group coaching program",
  REFERRAL_REWARD_LIFETIME_MEMBERSHIP: "<span>Lifetime membership</span>",
  REFERRAL_REWARD_RETURN_FLIGHT: "<span>Return flights</span>to a Hey Lady! Meetup",
  REFERRAL_FRIENDS_JOINED: "Friends joined",
  MEMBERSHIP_REFERRAL_CARD_TITLE: "Get a free month for every friend you bring",
  MEMBERSHIP_REFERRAL_CARD_DESCRIPTION:
    "Help us grow and you can earn some awesome rewards, including return flights to a Hey Lady! meetup!",
  MEMBERSHIP_REFERRAL_CARD_BUTTON: "Bring a friend",
  REFERRAL_CREDIT_BALANCE: "Account credit",
  REFERRAL_TERMS_AND_CONDITIONS:
    "<sup>*</sup>You must be an active paid member to be eligible for rewards. Terms and conditions apply. <link>Find out more</link>.",
  REFERRAL_WELCOME_SIGN_UP: "I want to sign up",
  REFERRAL_WELCOME_GREETING: "Great to see you!",
  REFERRAL_WELCOME_RECEIVE_INVITE: "Receive an invite",
  REFERRAL_WELCOME_WATCH_VIDEO: "Watch the video",
  REFERRAL_WELCOME_WATCH_VIDEO_DURATION: "4 min",
  REFERRAL_WELCOME_SIGN_UP_IN: "Sign up in Hey Lady!",
  REFERRAL_WELCOME_SIGN_UP_DURATION: "3 min",
  REFERRAL_WATCH_VIDEO_TO_CONTINUE: "Watch video to continue",
  REFERRAL_WELCOME_FRIEND_TITLE: "You’re {name}’s friend, right?",
  REFERRAL_WELCOME_FRIEND_DESCRIPTION:
    "{name} has offered you a special “members-only” invitation to experience {HL} including:",
  REFERRAL_WELCOME_TRIAL: "7-day Guest Pass to {HL}",
  REFERRAL_WELCOME_CREDIT: "US$20 credit in your {HL} account",
  REFERRAL_WELCOME_NO_CHARGE: "No card required. Choose a paid membership if you stay.",
  REFERRAL_WELCOME_KNOW_WHEN_JOINED: "We will let {name} know when you have joined.",
  REFERRAL_WELCOME_KNOW_ONCE_JOINED: "We will let {name} know once you have joined.",
  REFERRAL_WELCOME_OFFER_TITLE: "Sign up by {date} and you’ll get:",
  REFERRAL_WELCOME_OFFER_CREDIT: "+$20 USD credit in your {HL} Account",
  REFERRAL_WELCOME_OFFER_ASSESSMENT: "+ Free Speaking Assessment & Report ($75 value)",
  REFERRAL_WELCOME_STEP_ONE: "Step 1: Watch Emma’s video to learn about {HL} (4mins)",
  REFERRAL_WELCOME_STEP_TWO: "Step 2: Click the button below to sign up",
  REFERRAL_WELCOME_INFO_TITLE: "Connecting women through English",
  REFERRAL_WELCOME_INFO_HEY_LADY:
    "Hey Lady! is the world’s leading English speaking community created especially for women.",
  REFERRAL_WELCOME_INFO_COMMUNITY:
    "By stepping inside our community, you are following the footsteps of more than 8000 women from over 120 countries on a rewarding journey to English fluency, friendship and freedom.",
  REFERRAL_WELCOME_INFO_JOIN:
    "So, if you enjoy your time, we’d love you to join and continue your journey with us!",
  REFERRAL_CODE_NOT_FOUND: "Invalid referral code",
  REFERRAL_CODE_NOT_FOUND_DESCRIPTION:
    "The referral code you entered is not valid. Please contact your friend for a" +
    " new code or sign up without a code.",
  REFERRAL_CONTINUE_WITHOUT_CODE: "Continue without code",
  REFERRAL_SEE_MY_REWARDS: "See My Rewards",
  TOPICS_PAGE_TOPIC_LIBRARY: "Topic Library",
  TOPICS_PAGE_GRAMMAR_LIBRARY: "Grammar Library",
  TOPICS_PAGE_RESOURCES: "Resources",
  TOPICS_PAGE_CURRENT_TOPIC: "Current Topic",
  TOPICS_PAGE_EXPLORE_TOPIC: "Explore Topic",
  TOPICS_PAGE_LEARN_MORE: "Read",
  TOPICS_PAGE_EXPLORE_TOPICS: "Explore Topics",
  TOPICS_PAGE_COMMUNITY_RESOURCES: "Community Resources",
  TOPICS_PAGE_RESOURCES_BANNER_DESCRIPTION:
    "This month, we'll explore our communities and how they enrich our lives!",
  TOPICS_PAGE_LETS_DIVE_DEEPER: "Ready for a deep dive?",
  TOPICS_PAGE_LETS_STUDY_VOCABULARY: "Let’s Study Vocabulary",
  TOPIC_PAGE_CREATE_CASUAL_CONVERSATION: "Host a Casual Conversation",
  TOPIC_PAGE_CREATE_DEEP_DIVE: "Take the plunge! Host a Deep Dive event for this topic!",
  TOPIC_PAGE_CREATE_STUDY_GROUP: "Why not create a Study Group to improve your vocab and grammar?",
  TOPIC_PAGE_DEEP_DIVE: "Deep Dive",
  TOPIC_PAGE_DEEP_DIVE_OVERVIEW: "Deep Dive Overview",
  TOPIC_PAGE_EVENT_DISCUSSION: "Topic Discussion",
  TOPIC_PAGE_DISCUSSION: "Discussion",
  TOPIC_PAGE_FIND_RELATED_EVENTS: "Find related events",
  TOPIC_PAGE_HIDE_ANSWERS: "Hide Answers",
  TOPIC_PAGE_WATCH_INTRO_VIDEO: "Watch intro video",
  TOPIC_PAGE_IDEAS_TO_DISCUSS: "Ideas to discuss",
  TOPIC_PAGE_LESSON_OVERVIEW: "Lesson Overview",
  TOPIC_PAGE_LETS_CREATE_DEEP_DIVE: "Host a Deep Dive",
  TOPIC_PAGE_LETS_CREATE_STUDY_GROUP: "Host a Study Event",
  TOPIC_PAGE_LETS_DIVE_DEEPER: "Let’s Dive Deeper",
  TOPIC_PAGE_LINKS_TO_OTHER_RESOURCES: "Links to other resources",
  TOPIC_PAGE_OVERVIEW: "Overview",
  TOPIC_PAGE_SHOW_ANSWERS: "Show Answers",
  TOPIC_PAGE_VOCABULARY_PRACTICE: "Vocabulary Practice",
  TOPIC_PAGE_DEEP_DIVE_PRACTICE: "Deep Dive Practice",
  TOPIC_PAGE_USEFUL_VOCABULARY: "Useful Vocabulary",
  TOPIC_PAGE_STUDY_VOCABULARY: "Study Vocabulary",
  TOPIC_PAGE_VOCABULARY: "Vocabulary",
  TOPIC_PAGE_WOULD_YOU_LIKE_TO_HOST_AN_EVENT: "Why not host an event to talk about this topic?",
  TOPIC_PAGE_UPGRADE_READY: "Ready to study with us again?",
  TOPIC_PAGE_UPGRADE_DESC:
    "Upgrade your plan and get instant access to our events, video calls and learning resources.",
  TOPIC_PAGE_UPGRADE_SEE_PLANS: "See plans",
  USERS_PAGE_MEMBER_SEARCH: "Member Search",
  USERS_PAGE_NO_RESULTS: "Sorry, {name}! We searched but couldn't find a match.",
  USERS_PAGE_UPDATE_FILTERS: "Try a different combination of filters.",
  USERS_PAGE_JOINED: "Joined {date}",
  USERS_PAGE_TAKING_BREAK: "📆 Taking a break until {month}",
  USERS_PAGE_SIMILAR_ENGLISH_LEVEL: "Similar English Level",
  USERS_PAGE_SAME_ENGLISH_LEVEL: "Same English Level",
  USERS_PAGE_HERS: "Hers",
  USERS_PAGE_MINE: "Mine",
  USERS_PAGE_IN_YOUR_TIMEZONE: "(Shown in your timezone)",
  USERS_PAGE_MON_SUN: "Mon-Sun:",
  USERS_PAGE_HEY_LADY_TEAM: "{title} Team",
  USERS_PAGE_LOVES_TALKING_ABOUT: "Loves talking about:",
  USERS_PAGE_LAST_ONLINE: "Last online {distance} ago",
  USERS_PAGE_PERSONAL_INTERESTS: "My personal interests:",
  USERS_PAGE_ENGLISH_LEVEL: "My English level:",
  USERS_PAGE_SKILLS_I_WANT_TO_IMPROVE: "The skills I want to improve:",
  USERS_PAGE_ONLINE_NOW: "Online Now",
  USERS_PAGE_MEMBERS: "Members",
  USERS_PAGE_TIMES: "Times you can meet",
  USER_PAGE_NO_ARTICLES:
    "{name} hasn't written any articles yet. Explore what other ladies are writing about.",
  USER_PAGE_NO_EVENTS: "{name} hasn't attended or hosted any events yet.",
  USER_PAGE_NO_ATTENDED_EVENTS: "{name} hasn't attended any events yet.",
  USER_PAGE_NO_HOSTED_EVENTS:
    "{name} hasn't hosted any events yet. Check out other events in the community.",
  USER_PAGE_RECENT_ARTICLES: "Most recent articles",
  USER_PAGE_ADD_MORE_DETAILS: "Please, add more details...",
  USER_PAGE_HOSTED_EVENTS: "{name}'s Events",
  USER_PAGE_ARTICLES: "{name}'s Articles",
  USER_PAGE_MEMBER_INFO: "Member Profile",
  USER_PAGE_MY_PHOTOS: "Photos ({photos})",
  USER_PAGE_PERSONAL_EVENTS_GOING_TO: "Events {name}'s Going To",
  USER_PAGE_PERSONAL_INFO: "Personal Info",
  USER_PAGE_YOU_ARE_FOLLOWING: "You’re following {firstName}",
  USER_PAGE_ABLE_TO_SEE_EVENTS:
    "You’ll be able to see the events {firstName} is hosting and find them more easily.",
  USER_PAGE_SEND_MESSAGE: "Send Message",
  USER_PAGE_REPORT: "Report",
  USER_PAGE_REPORT_ABUSE: "Report abuse",
  USER_PAGE_REPORT_ABUSE_OTHER_REASON: "Other Reason",
  USER_PAGE_REPORT_ABUSE_MALE_GENDER_OR_FALSE_IDENTITY_OR_PREVIOUSLY_BANNED:
    "I don't believe this person should be in the community because of their gender (male), false identity or because they have been previously banned.",
  USER_PAGE_REPORT_ABUSE_OFFENSIVE_OR_DISRESPECTFUL:
    "I consider something this person has said or written to be offensive/disrespectful to another persons religious or political beliefs, nationality, ethnicity or culture practices.",
  USER_PAGE_REPORT_ABUSE_UNACCEPTABLE_BEHAVIOUR:
    "I found this person's behaviour to be unacceptable and not aligned with the values of our community during an event I attended.",
  USER_PAGE_REPORT_USER_ABUSE: "Report Abuse",
  USER_PAGE_REPORT_USER_ABUSE_HAS_BEEN_SENT: "The report has been sent",
  USER_PAGE_REPORT_USER_ABUSE_PLEASE_TELL_US:
    "Please help us understand why you decided to report {name}",
  USER_PAGE_REPORT_USER_ABUSE_THANK_YOU:
    "Thank you for being proactive. We'll process {break} your report as soon as we possibly can.",
  USER_PAGE_REPORT_USER_ABUSE_WE_ARE_VERY_SORRY:
    "We are very sorry to know you experienced negative behaviour in {break} our community.",
  USER_PAGE_STORY: "Story",
  CREATE_EVENT_NMW: "New Member Events",
  CREATE_EVENT_NMW_DESCRIPTION:
    "Events our Big Sisters (that’s you!) host especially for our Little Sisters",
  CREATE_EVENT_SPEAKING_DESCRIPTION: "A group event focused on speaking and conversation practice.",
  CREATE_EVENT_STUDY_DESCRIPTION: "A session to learn or practise English skills together.",
  CREATE_EVENT_OTO_DESCRIPTION: "A private conversation between you and one other member.",
  CREATE_EVENT_IN_PERSON_DESCRIPTION:
    "An event happening offline to meet other members in real life!",
  CREATE_EVENT_PAGE_SELECT_EVENT_TYPE: "Select Event Type",
  CREATE_EVENT_PAGE_HOSTED_BY: "Hosted By",
  CREATE_EVENT_PAGE_UNLIMITED: "No limit",
  CREATE_EVENT_PAGE_UP_TO: "Up to",
  CREATE_EVENT_PAGE_PLACES_REMAINING: "{places} places remaining",
  CREATE_EVENT_PAGE_UNLIMITED_PLACES_REMAINING: "Unlimited",
  CREATE_EVENT_PAGE_WHO_WILL_HOST_THE_EVENT: "Who will host the event?",
  CREATE_EVENT_PAGE_HOSTS_AND_PARTICIPANTS: "Hosts and Participants",
  CREATE_EVENT_PAGE_QUESTIONS_WE_WILL_EXPLORE: "Questions we will explore",
  CREATE_EVENT_PAGE_FOUNDATION_USER: "Foundation User",
  CREATE_EVENT_PAGE_RISE_USER: "Rise User",
  CREATE_EVENT_PAGE_UNVERIFIED: "Unverified",
  CREATE_EVENT_PAGE_LITTLE_SISTERS: "Little Sisters",
  CREATE_EVENT_PAGE_1_3_MONTHS: "1-3 months",
  CREATE_EVENT_PAGE_3_12_MONTHS: "3-12 months",
  CREATE_EVENT_PAGE_3_6_MONTH: "3-6 month",
  CREATE_EVENT_PAGE_6_12_MONTH: "6-12 month",
  CREATE_EVENT_PAGE_12_MONTHS_PLUS: "12 months+",
  CREATE_EVENT_PAGE_INTERMEDIATE: "Intermediate",
  CREATE_EVENT_PAGE_ADVANCED: "Advanced",
  CREATE_EVENT_PAGE_WHAT_IS_THIS: "What is this?",
  CREATE_EVENT_PAGE_CHOOSE_INTERMEDIATE:
    " {separator} Choose this if your event is best for ladies with Intermediate English (B1), or may be feeling less confident about speaking.",
  CREATE_EVENT_PAGE_CHOOSE_ADVANCED:
    " {separator} Choose this if your event is best for ladies with Upper Intermediate or Advanced English (B2 or above) who want to practise speaking with other high-level speakers.",
  CREATE_EVENT_PAGE_CHOOSE_ALL:
    " {separator} Choose this if you are happy for all ladies to attend - whether intermediate or advanced!",
  CREATE_EVENT_PAGE_WHICH_TYPE_OF_MEMBER_WILL_ATTEND:
    "Which type of members will be able to attend the event?",
  CREATE_EVENT_PAGE_CHOOSE_EVENT_CATEGORY: "What type of event is this?",
  CREATE_EVENT_PAGE_IS_FEATURED: "Is this a featured event?",
  CREATE_EVENT_PAGE_FEATURED_DESCRIPTION:
    "Choose this to promote the event on the 'Featured Events' tab for the whole community.",
  CREATE_EVENT_PAGE_MARK_THIS_EVENT_AS:
    "[Optional] Mark this event for listing in specific categories:",
  CREATE_EVENT_PAGE_FEATURED_EVENT: "Featured event",
  CREATE_EVENT_PAGE_RELATED_TO_PROFESSIONAL_SKILLS: "Related to professional skills",
  CREATE_EVENT_PAGE_FORMAT_TITLE: "What is the format of the event?",
  ENUM_FORMAT_MEETING: "Meeting",
  ENUM_FORMAT_LISTEN_ONLY: "Listen Only(webinar)",
  CREATE_EVENT_PAGE_CONVERSATION_TYPE: "Conversation",
  CREATE_EVENT_PAGE_STUDY_AND_LEARN_TYPE: "Study & Learn",
  CREATE_EVENT_PAGE_PROFESSIONAL_TYPE: "Professional",
  CREATE_EVENT_PAGE_PROFESSIONAL_DESCRIPTION:
    "Choose this if your event is designed to help members practise or" +
    " learn skills that will help them at work.",
  CREATE_EVENT_PAGE_LARGE_CALL: "Large Call",
  CREATE_EVENT_PAGE_LARGE_CALL_DESCRIPTION:
    "Enable this option if you anticipate a large number of participants (more than 50) will attend this event.{br}" +
    "You can edit this setting later if needed.",
  CREATE_EVENT_PAGE_NEW_MEMBER_EVENT: "New member event",
  CREATE_EVENT_PAGE_NEW_MEMBER_DESCRIPTION:
    "Choose this if your event is designed specifically for new members.{br}" +
    'The event will only be shown under the "New Member Events" icon.{br}' +
    "To include new members as well as other members, do not choose this option. Make your selections in the" +
    ' "Participants" step.',
  CREATE_EVENT_PAGE_COACH_EVENT: "Coach event",
  CREATE_EVENT_PAGE_COACH_DESCRIPTION:
    "When enabled, this event will only be available to members with access to Coach events.{br}" +
    "Basic members and new members who have not yet attended 3 events can 'see but not join'.",
  CREATE_EVENT_PAGE_WHICH_LEVEL: "Which level is this event suitable for?",
  CREATE_EVENT_PAGE_CHOOSE_THE_BACKGROUND: "Choose the Background",
  CREATE_EVENT_PAGE_CHOOSE_THE_COVER_BACKGROUND:
    "Choose the cover background from our options or upload yours.",
  CREATE_EVENT_PAGE_BACKGROUND_EXTENSIONS:
    "Upload your background here. Make sure you upload file extensions: <b>.jpg, .png.</b> Your file must be <b>940×280px</b>.",
  CREATE_EVENT_PAGE_CHOOSE_THE_IMAGE: "Choose the Image",
  CREATE_EVENT_PAGE_CHOOSE_THE_IMAGE_FROM_OUR_OPTIONS:
    "Choose the event image from our options or upload yours.",
  CREATE_EVENT_PAGE_IMAGE_EXTENSIONS:
    "Upload your image here. Make sure you upload file extensions: <b>.jpg, .png.</b> Your file must be at least <b>420×280px</b>.",
  CREATE_EVENT_PAGE_CHOOSE_THE_COVER: "Choose the Cover",
  CREATE_EVENT_PAGE_CHOOSE_THE_COVER_FROM_OUR_OPTIONS: "Choose the event cover from our options.",
  CREATE_EVENT_PAGE_CHOOSE_FROM_OUR_SUGGESTIONS: "Choose from our suggestions",
  CREATE_EVENT_PAGE_MY_CUSTOM_COVER: "My custom cover",
  CREATE_EVENT_PAGE_YOU_CAN_ADD_LINKS_TO_MATERIALS:
    "Add the link to a website, video or blog post here so ladies can review it before your event.",
  CREATE_EVENT_PAGE_ADD_NEW_LINK: "Add New Link",
  CREATE_EVENT_PAGE_LINK: "Link",
  CREATE_EVENT_PAGE_ENTER_LINK_DESCRIPTION: "Enter link description",
  CREATE_EVENT_PAGE_PASTE_URL: "Paste URL",
  CREATE_EVENT_PAGE_LINK_DESCRIPTION: "Link description",
  CREATE_EVENT_PAGE_DO_YOU_WANT_TO_DELETE_THIS_ATTACHMENT: "Do you want to delete this Attachment?",
  CREATE_EVENT_PAGE_AFTER_DELETING_THIS_PHOTO:
    "After deleting this photo, it will no longer be available",
  CREATE_EVENT_PAGE_CHOOSE_EVENT_HOST: "Choose Event Host",
  CREATE_EVENT_PAGE_ADD_LADIES: "Add ladies to join this event",
  CREATE_EVENT_PAGE_HOW_MANY_LADIES: "How many ladies can join this event?",
  CREATE_EVENT_PAGE_IS_THIS_A_PRIVATE_EVENT: "Is it a private event?",
  CREATE_EVENT_PAGE_ENTER_EVENT_HOST_NAME: "Enter event host name here",
  CREATE_EVENT_PAGE_START_TYPING_A_FIRST_OR_LAST_NAME:
    "Start typing a first or last name to search.",
  CREATE_EVENT_PAGE_PARTICIPANTS_ERROR:
    "Uh oh! You have more participants than the maximum capacity you chose ({number}). Please remove participants or increase the maximum capacity.",
  CREATE_EVENT_PAGE_PARTICIPANTS_NOTE:
    "Note: Only members included in 'Which type of members will be able to attend' settings will appear in your search.",
  CREATE_EVENT_IS_THIS_A_PRIVATE_EVENT: "Is this a private event? (Only visible to invited guests)",
  CREATE_EVENT_PAGE_PRIVATE_EVENT: "Private Event",
  CREATE_EVENT_PAGE_LADIES_EXCLUDING_HOST: "(excluding host)",
  CREATE_EVENT_PAGE_INVITE_PEOPLE_TO_YOUR_EVENT: "Invite people to your event (if you wish)",
  CREATE_EVENT_PAGE_DO_YOU_WANT_TO_UPLOAD:
    "Optional: Do you want to upload something for ladies so they can prepare for your event?",
  CREATE_EVENT_PAGE_MAKE_SURE_YOU_UPLOAD:
    "Please upload supported file types only: .jpeg, .doc, .docx, .pdf, .png",
  CREATE_EVENT_PAGE_UPLOAD_FILE: "Upload File",
  CREATE_EVENT_PAGE_UPLOAD_IMAGE: "Upload Image",
  CREATE_EVENT_PAGE_COVER_EXTENSIONS:
    "Upload your cover here. Make sure you upload file extensions: <b>.jpg," +
    " .png.</b>" +
    " Your file must be <b>940×280px</b>, and the file name should not contain any spaces.",
  CREATE_EVENT_PAGE_USE_IMAGES: "Please use high quality images that represent your event theme",
  CREATE_EVENT_PAGE_UPLOAD_COVER: "Upload cover",
  CREATE_EVENT_PAGE_UPLOAD_ILLUSTRATION: "Upload illustration",
  CREATE_EVENT_PAGE_OCCURS_EVERY: "Occurs Every",
  CREATE_EVENT_PAGE_SPECIFY_TIME_DETAILS: "Specify time details",
  CREATE_EVENT_PAGE_END_DATE_AND_TIME: "End Date and Time",
  CREATE_EVENT_WARNING_IMPORTANT: "Important information for hosts",
  CREATE_EVENT_WARNING_HL_VIDEO:
    "All events in our platform are now using Hey Lady! Video (<u>not</u> Zoom) to allow all members to enjoy unlimited call time.",
  CREATE_EVENT_WARNING_PLEASE_NOTE:
    "Please note that this feature is currently in beta, which means it is still 'in progress' and being tested. There are some differences you should be aware of:",
  CREATE_EVENT_WARNING_SCREEN_SHARING:
    "- Screen sharing is not currently supported on mobile or tablet (desktop only).",
  CREATE_EVENT_WARNING_BREAKOUT_ROOMS1:
    "- Breakout rooms are available but they are still being tested. <url>Click here</url> to learn more about breakout rooms.",
  CREATE_EVENT_WARNING_GOOGLE_CHROME:
    "- For the best experience we recommend that you install Google Chrome browser on your device.",
  CREATE_EVENT_WARNING_CONTACT:
    "If you notice anything that does not work as you expect or need assistance, kindly contact Member Support at <url>hello@heylady.io</url>.",
  CREATE_EVENT_PAGE_END_DATE: "End Date",
  CREATE_EVENT_PAGE_REPEATS_ON: "Repeats on",
  CREATE_EVENT_PAGE_REPEAT_ENDS: "Repeat ends",
  CREATE_EVENT_PAGE_IS_THIS_RECURRING_EVENT: "Is this event happening more than once?",
  CREATE_EVENT_PAGE_NO_JUST_ONCE: "No, just once",
  CREATE_EVENT_PAGE_NO_JUST_ONCE_DESCRIPTION: "This event doesn't repeat",
  CREATE_EVENT_PAGE_RECURRING_SCHEDULE: "Recurring Schedule",
  CREATE_EVENT_PAGE_RECURRING_SCHEDULE_DESCRIPTION:
    "This event will repeat at the same time on the same day(s). ",
  CREATE_EVENT_PAGE_SHOW_EXAMPLE: "Show example",
  CREATE_EVENT_PAGE_RECURRING_EXAMPLE_TEXT: "A Study Pod that meets every Monday at 2pm.",
  CREATE_EVENT_PAGE_SET_UP_RECURRENCE: "Set up recurrence",
  CREATE_EVENT_PAGE_RECURRENCE_DESCRIPTION:
    "Choose how often this event repeats. Use recurrence when the same event happens again and again over a period of time. For example, a Study Pod that meets every Monday at 2pm.",
  CREATE_EVENT_PAGE_RECURRENCE_REPEAT_EVERY: "Repeat every",
  CREATE_EVENT_PAGE_RECURRENCE_CUSTOM: "Custom",
  CREATE_EVENT_PAGE_RECURRENCE_DAILY: "Daily",
  CREATE_EVENT_PAGE_RECURRENCE_WEEKLY: "Weekly",
  CREATE_EVENT_PAGE_RECURRENCE_FORTNIGHTLY: "Fortnightly",
  CREATE_EVENT_PAGE_RECURRENCE_MONTHLY: "Monthly",
  CREATE_EVENT_PAGE_RECURRENCE_DAY: "Day",
  CREATE_EVENT_PAGE_RECURRENCE_WEEK: "Week",
  CREATE_EVENT_PAGE_RECURRENCE_MONTH: "Month",
  CREATE_EVENT_PAGE_RECURRENCE_REPEAT_ON: "Repeat on",
  CREATE_EVENT_PAGE_RECURRENCE_ENDS: "Ends",
  CREATE_EVENT_PAGE_RECURRENCE_ON: "On",
  CREATE_EVENT_PAGE_RECURRENCE_AFTER: "After",
  CREATE_EVENT_PAGE_RECURRENCE_OCCURRENCES: "occurrences",
  CREATE_EVENT_PAGE_RECURRENCE_TIMES: "times",
  CREATE_EVENT_PAGE_RECURRENCE_MAX_LIMIT: "The maximum recurrence limit is {limit}.",
  CREATE_EVENT_PAGE_RECURRENCE_LIMIT_EXCEEDED:
    "The number of occurrences exceeds the maximum limit of {limit}. Please reduce the occurrences or choose an earlier end date.",
  CREATE_EVENT_PAGE_RECURRENCE_MONTHLY_SAME_DATE: "Monthly on day {date}",
  CREATE_EVENT_PAGE_RECURRENCE_MONTHLY_SAME_WEEKDAY: "Monthly on the {nth} {dayName}",
  CREATE_EVENT_PAGE_RECURRENCE_WEEKS: "Week(s)",
  EDIT_RECURRING_EVENT_TITLE: "Edit Recurrent Event",
  EDIT_RECURRING_EVENT_DESCRIPTION: "How would you like to apply the changes?",
  EDIT_RECURRING_EVENT_DATE_CHANGE_DESCRIPTION: "These changes will affect all recurring events.",
  EDIT_RECURRING_EVENT_RECURRENCE_CHANGE_DESCRIPTION:
    "These changes will affect all events from {date} onward.",
  EDIT_RECURRING_EVENT_THIS_ONLY: "This event only",
  EDIT_RECURRING_EVENT_THIS_ONLY_DESCRIPTION: "Changes will only apply to this single event.",
  EDIT_RECURRING_EVENT_THIS_AND_FOLLOWING: "This and following events",
  EDIT_RECURRING_EVENT_THIS_AND_FOLLOWING_DESCRIPTION:
    "Changes will apply to this event and all events after it in the series.",
  EDIT_RECURRING_EVENT_ALL_FUTURE: "All future events",
  EDIT_RECURRING_EVENT_ALL_FUTURE_DESCRIPTION:
    "Changes will apply to all upcoming events in the series.",
  EDIT_RECURRING_EVENT_ALL_RECURRING: "All recurring events",
  EDIT_RECURRING_EVENT_CHOOSE_SPECIFIC: "Choose specific dates",
  EDIT_RECURRING_TIME_WARNING_TITLE: "Are you sure?",
  EDIT_RECURRING_TIME_WARNING_BODY:
    "You are about to edit the time of a recurring event. Any changes you make will affect all recurring events. Do you want to continue?",
  EDIT_RECURRING_TIME_WARNING_CANCEL: "No",
  EDIT_RECURRING_TIME_WARNING_CONFIRM: "Yes, I want to update them all",
  DELETE_RECURRING_EVENT_TITLE: "Delete recurring event?",
  DELETE_RECURRING_EVENT_DESCRIPTION: "Select how many recurring events to delete:",
  DELETE_RECURRING_EVENT_THIS_ONLY: "This event only",
  DELETE_RECURRING_EVENT_ALL_RECURRING: "All recurring events",
  DELETE_RECURRING_EVENT_CHOOSE_SPECIFIC: "Choose specific dates",
  DELETE_RECURRING_EVENT_SELECT_EVENTS: "Select which events you want to delete:",
  DELETE_RECURRING_EVENT_NOTE_LABEL: "Note (optional)",
  DELETE_RECURRING_EVENT_NOTE_PLACEHOLDER: "Write a note for attendees...",
  DELETE_RECURRING_EVENT_CHARACTERS_AVAILABLE: "{count} characters available",
  DELETE_RECURRING_EVENT_DELETE_BUTTON: "Delete events ({count})",
  COMMON_SAVE_CHANGES: "Save changes",
  CREATE_EVENT_PAGE_CHOOSE_TIME_AND_DURATION: "Choose time and duration for your event.",
  CREATE_EVENT_PAGE_START_DATE_ERROR: "Start date must be in the future",
  CREATE_EVENT_PAGE_TIME_RANGE_ERROR: "End time must be later than Start time",
  CREATE_EVENT_PAGE_CHOOSE_EVENT_TYPE: "Choose Event Type",
  CREATE_EVENT_PAGE_EVENT_DETAILS: "Event Details",
  CREATE_EVENT_PAGE_IN_PERSON_EVENT_DETAILS: "In Person Event Details",
  CREATE_EVENT_PAGE_EVENT_TOPIC: "What's the topic?",
  CREATE_EVENT_PAGE_EVENT_DETAILS_DESCRIPTION:
    "Keep your title short but descriptive. It might be a question or the key idea you want to explore together.",
  CREATE_EVENT_PAGE_EVENT_TAGS: "[Optional] Choose up to 3 tags that relate to your event",
  CREATE_EVENT_PAGE_ENGLISH_SKILLS_TAGS: "English skills",
  CREATE_EVENT_PAGE_RELEVANT_SELECTIONS: "Select up to three (3) that are relevant to your event",
  CREATE_EVENT_PAGE_PERSONAL_INTERESTS_TAGS: "Personal interests",
  CREATE_EVENT_PAGE_WHY_EVENT_TAGS:
    "'Tags' are key words or phrases that make it easier for us to show your event to the right people.",
  CREATE_EVENT_PAGE_TIME_DETAILS: "Time Details",
  CREATE_EVENT_PAGE_PARTICIPANTS: "Participants",
  CREATE_EVENT_PAGE_EVENT_COVER: "Event Cover",
  CREATE_EVENT_PAGE_CONFIRM_EVENT_DETAILS: "Confirm Event Details",
  CREATE_EVENT_PAGE_KIND_OF_EVENT: "What kind of event is this?",
  CREATE_EVENT_PAGE_KIND_OF_CONVERSATION_STARTER: "What kind of Coach Conversation is this?",
  CREATE_EVENT_PAGE_PURPOSE: "What's the main purpose of this event?",
  CREATE_EVENT_PAGE_SELECT: "Select one option",
  CREATE_EVENT_PAGE_IS_THIS_CASUAL_OR_IN_DEPTH:
    "Is this a casual conversation or perhaps something more in depth?",
  CREATE_EVENT_PAGE_CHOOSE_A_HEY_LADY_TOPIC: "Choose a Hey Lady Topic",
  CREATE_EVENT_PAGE_SET_MY_OWN_TOPIC: "Set my own topic",
  CREATE_EVENT_PAGE_EASY_GOING_CHAT: "This will be an easy going and open chat about the topic.",
  CREATE_EVENT_PAGE_IMPROVE_ENGLISH: "We will be helping each other to improve our English skills.",
  CREATE_EVENT_PAGE_CONVERSATION_STARTER: "Conversation Starter",
  CREATE_EVENT_PAGE_SPEAKING_CASUAL: "Speaking - Casual",
  CREATE_EVENT_PAGE_SPEAKING_DEEP_DIVE: "Speaking - Deep Dive",
  CREATE_EVENT_LISTEN_ONLY_DESCRIPTION:
    "Listen only. Participants will not need their webcam or microphone",
  CREATE_EVENT_PAGE_CUSTOM_CONVERSATION: "Choose this for casual, social, informal event formats",
  CREATE_EVENT_PAGE_CUSTOM_STUDY: "Choose this for events that help members improve English skills",
  CREATE_EVENT_PAGE_CUSTOM_DEEP_DIVE: "Choose this for challenging, deeper or formal event formats",
  CREATE_EVENT_PAGE_WILL_BE_TAKING_TOPIC: "Will be taking this topic to a whole new level!",
  CREATE_EVENT_PAGE_PRESELECTED_EVENT_TOPIC: "Event Topic",
  CREATE_EVENT_PAGE_SELECT_EVENT_TOPIC: "Select an event topic",
  CREATE_EVENT_PAGE_SELECT_CURRENT_TOPIC: "{name} (Current Topic)",
  CREATE_EVENT_PAGE_SELECT_TOPIC_LIBRARY: "Topic Library",
  CREATE_EVENT_PAGE_THEMES_AVAILABLE_FOR_THIS_KIND:
    "The topics available for this kind of conversation are:",
  CREATE_EVENT_PAGE_SELECT_CONVERSATION_TOPIC: "Select a conversation topic",
  CREATE_EVENT_PAGE_AVAILABLE_FOR_TOPIC: "Available for this topic are:",
  CREATE_EVENT_PAGE_TOPIC_OVERVIEW: "Topic Overview",
  CREATE_EVENT_PAGE_GIVE_YOUR_EVENT_A_TITLE: "Give your event a title",
  CREATE_EVENT_PAGE_KEEP_YOUR_TITLE_SHORT_BUT_DESCRIPTIVE:
    "Keep your title short but descriptive. It might be a question or the key idea you want to explore together.",
  CREATE_EVENT_PAGE_ENTER_YOUR_TITLE: "Enter your title",
  CREATE_EVENT_PAGE_ENTER_YOUR_IDEA: "Enter your question/idea",
  CREATE_EVENT_PAGE_ENTER_YOUR_DESCRIPTION: "Enter your description",
  CREATE_EVENT_PAGE_ADD_THREE_IDEAS_TO_DISCUSS: "Add up to three (3) ideas to discuss",
  CREATE_EVENT_PAGE_ADD_THREE_IDEAS_TO_DISCUSS_OPTIONAL:
    "Add up to three (3) ideas to discuss (optional)",
  CREATE_EVENT_PAGE_HELP_OTHER_TO_SEE_WHAT_KINDS_TALKING:
    "Help others to see what kinds of things you might be talking about so they have a chance to prepare if they want to.",
  CREATE_EVENT_PAGE_CREATE_YOUR_OWN: "Create your own",
  CREATE_EVENT_PAGE_INTRO_VIDEO: "Intro Video",
  CREATE_EVENT_PAGE_INVITE_GUEST: "Invite Guest to your event",
  CREATE_EVENT_PAGE_ENTER_GUEST_NAME: "Enter your guest name",
  CREATE_EVENT_PAGE_MAKE_SURE_YOU_UPLOAD_SUPPORTING_FILES:
    "Please, make sure you upload supporting files extensions: .mp4, .mov, .mpeg-4",
  CREATE_EVENT_PAGE_UPLOAD_VIDEO: "Upload Video",
  CREATE_EVENT_PAGE_PLEASE_USE_HIGH_QUALITY_IMAGES:
    "Please use high quality left-oriented images because the left part of your cover will be displayed as your event preview.",
  CREATE_EVENT_PAGE_COVER_PHOTO: "Cover photo",
  CREATE_EVENT_PAGE_EVENT_TILE_AND_DESCRIPTION: "Event Title & Description",
  CREATE_EVENT_PAGE_IDEA_FOR_DISCUSSION: "Idea for Discussion",
  CREATE_EVENT_PAGE_EVENT_TITLE: "Event Title",
  CREATE_EVENT_PAGE_EVENT_DESCRIPTION: "Event Description",
  CREATE_EVENT_PAGE_PICK_A_TOPIC: "Pick a topic",
  CREATE_EVENT_PAGE_DUPLICATE_EVENT: "Duplicate Event - Please be sure you check all details",
  CARD_DETAILS_PAGE_FOUNDATIONS_PACKAGE: "Foundations Package",
  CARD_DETAILS_PAGE_FOUNDATIONS_MEMBER: "Foundations Member",
  CARD_DETAILS_PAGE_FIRST_MONTHS: "3 month introductory offer",
  CARD_DETAILS_PAGE_MONTHLY_SUBSCRIPTION: "Monthly subscription",
  CARD_DETAILS_PAGE_GET_INTRODUCED_TO_SPEAKING_PARTNERS: "Get introduced to speaking partners",
  CARD_DETAILS_PAGE_GUIDED_CONVERSATIONS_WITH_COACHES: "Guided conversations with coaches",
  CARD_DETAILS_PAGE_UNLIMITED_SPEAKING_PRACTICE: "Unlimited speaking practice time",
  CARD_DETAILS_PAGE_ACCESS_LEARNING: "Access to structured learning materials and workbooks.",
  CARD_DETAILS_PAGE_PLUS: "PLUS",
  CARD_DETAILS_PAGE_SPECIAL_LAUNCH_OFFER: "Special Launch offer!",
  CARD_DETAILS_PAGE_TICKET_TO_SPECIAL_EVENT: "1 x Ticket to Special Event with Emma",
  CARD_DETAILS_PAGE_ONE_MONTH_FREE_MEMBERSHIP: "1 month FREE membership*",
  CARD_DETAILS_PAGE_APPLIES_AFTER_COMPLETION: "*Applies after completion of Foundations Package.",
  CARD_DETAILS_PAGE_OFFER_MONEY_BACK:
    "We offer a 14 day money back guarantee. If you join and decide within 14 days that Hey Lady! is not for you we will refund 100% of your payment.",
  CARD_DETAILS_PAGE_CONDITIONS_OF_MEMBERSHIP: "Conditions of Membership",
  CARD_DETAILS_PAGE_TO_JOIN: "To join Hey Lady! you will need to meet the following conditions:",
  CARD_DETAILS_PAGE_INTERMEDIATE_LEVEL: "Intermediate level (B1) English or above",
  CARD_DETAILS_PAGE_OVER_18_YEARS_OLD: "You must be over 18 years old",
  CARD_DETAILS_PAGE_YOU_MUST_BE_A_WOMAN:
    "You must be a woman or identify as a woman to participate",
  CARD_DETAILS_PAGE_MONTH: "{number} month",
  CARD_DETAILS_PAGE_MONTHS: "{number} months",
  CARD_DETAILS_PAGE_USD_MONTH: "USD/ mth",
  CARD_DETAILS_PAGE_USD_MONTHS: "USD/ {number} months",
  CARD_DETAILS_PAGE_PERSONAL_PAYMENT_DETAILS: "Personal & payment details",
  CARD_DETAILS_PAGE_PROMOCODE: "Promocode:",
  CARD_DETAILS_PAGE_ENTER_PROMOCODE_HERE: "Enter promocode here",
  CARD_DETAILS_PAGE_AMOUNT_PER_MONTH: "{amount} USD/ {months} months",
  CARD_DETAILS_PAGE_YOUR_PASSWORD: "Your Password",
  CARD_DETAILS_PAGE_CONFIRMATION_EMAIL: "Please confirm your email",
  CARD_DETAILS_PAGE_CONFIRMATION_PASSWORD: "Please confirm your password",
  CARD_DETAILS_PAGE_CONDITIONS_AND_MEMBERSHIP: "I confirm that I meet the Conditions of Membership",
  CARD_DETAILS_THANK_YOU_MESSAGE: "Thank you for your purchase. We'll be in contact soon!",
  CARD_DETAILS_GO_TO_MAIN_SITE: "Go to main site",
  CHAT_ALL_CHATS: "All Chats",
  CHAT_CHANNELS: "Channels",
  CHAT_GROUPS: "Groups",
  CHAT_PERSONAL: "Personal",
  CHAT_ARCHIVED: "Archived",
  CHAT_SHOW_MORE_REPLIES: "Show {number} more replies",
  CHAT_NEW: "New",
  CHAT_SHOW_REPLIES: "Show replies",
  CHAT_HIDE_REPLIES: "Hide replies",
  CHAT_NEW_REPLIES: "{unread} new replies",
  CHAT_THREADS: "Threads",
  CHAT_THREAD: "Thread",
  CHAT_REPLIES: "{replies} replies",
  CHAT_NO_THREADS: "You don't have any chat threads yet.",
  CHAT_MEMBERS: "Group: {total} members, {online} online",
  CHAT_MEMBERS_WO_GROUP: "{total} members, {online} online",
  CHAT_PUBLIC_CHANNEL_MEMBERS: "Channel: {total} members, {online} online",
  CHAT_SEARCH_RESULTS: "Search results",
  CHAT_INVITED_PEOPLE: "Invited",
  CHAT_LOADING: "Searching...",
  CHAT_NOTHING_YET: "Nothing yet...",
  CHAT_CREATE_CHAT_MSG: "Invite someone else for a group chat or continue and 'chat'",
  CHAT_CREATE_CHAT: "Chat",
  CHAT_SEARCH_ALL_CHATS: "Search all chats",
  CHAT_SEARCH_CHANNELS: "Search channels",
  CHAT_SEARCH_GROUP_CHATS: "Search group chats",
  CHAT_SEARCH_PERSONAL_CHATS: "Search personal chats",
  CHAT_SEARCH_ARCHIVED_CHATS: "Search archived chats",
  CHAT_SEARCH_FALLBACK: "Search chats or channels",
  CHAT_FIND_PEOPLE: "Find people",
  CHAT_DELETE_CHAT: "Delete chat",
  CHAT_DELETE_GROUP_CHAT: "Delete group chat",
  CHAT_ADD_MEMBER: "Add member",
  CHAT_ADD_MEMBERS: "Add members",
  CHAT_ADD_MEMBERS_NUM: "Add members ({num})",
  CHAT_START_SEARCH_TO_ADD: "Start searching people to add them in the chat",
  CHAT_START_SEARCH_TO_INVITE: "Start searching people to invite them to the channel",
  CHAT_INVITE_TO_JOIN: "Invite to join",
  CHAT_INVITE_TO_JOIN_NUM: "Invite to join ({num})",
  CHAT_ADD_NEW_MEMBERS: "Add new members",
  CHAT_VIEW_OR_REMOVE_MEMBERS: "View/remove members",
  CHAT_REMOVE_MEMBERS: "Remove members",
  CHAT_REMOVE_MEMBER: "Remove",
  CHAT_REMOVE_MEMBER_HEADING:
    "Are you sure you want to remove <strong>{memberName}</strong> from <em>{channelName}</em>?",
  CHAT_DELETE_INVITE_HEADING:
    "Are you sure you want to delete invite for <strong>{memberName}</strong>?",
  CHAT_MEMBERS_IN_GROUP: "Members in the channel:",
  CHAT_SELECTED: "Selected",
  CHAT_SELECTED_FOR_DELETION: "Selected to be removed:",
  CHAT_ARCHIVE_CHANNEL: "Archive chat",
  CHAT_ARCHIVE_CHANNEL_HEADER: "Are you sure you want to archive <em>{channelName}</em>",
  CHAT_ARCHIVE_CHANNEL_SHORT: "Archive",
  CHAT_UNARCHIVE_CHANNEL_SHORT: "Unarchive",
  CHAT_ACTIVITY: "Chat activity",
  CHAT_CHANNEL_ACTIVITY: "Channel activity",
  CHAT_LEAVE_GROUP: "Leave group chat",
  CHAT_CHANGE_THE_NAME: "Change the name of this group",
  CHAT_RENAME_GROUP: "Rename group chat",
  CHAT_LEAVE_CHAT: "Leave chat",
  CHAT_PIN_CHAT: "Pin",
  CHAT_UNPIN_CHAT: "Unpin",
  CHAT_MARK_READ_CHAT: "Mark as read",
  CHAT_MARK_UNREAD_CHAT: "Mark as unread",
  CHAT_MUTE_CHAT: "Mute notifications",
  CHAT_UNMUTE_CHAT: "Unmute notifications",
  CHAT_LEAVE_CHANNEL_SHORT: "Leave",
  CHAT_LEAVE_CHANNEL_HEADER: "Are you sure you want to leave <em>{channelName}</em>?",
  CHAT_DELETE_CHANNEL_HEADER:
    "Are you sure you want to delete <em>{channelName}</em> for everyone?",
  CHAT_RENAME_CHANNEL: "Rename channel",
  CHAT_COMMUNITY_CHANNEL_DESC: "Share achievements and good news here!",
  CHAT_VIEW_MEMBERS: "View members",
  CHAT_INFO: "Chat info",
  CHAT_GROUP_INFO: "Group Info",
  CHAT_CHANNEL_INFO: "Channel info",
  CHAT_PERMISSION_OWNER: "Owner",
  CHAT_PERMISSION_MODERATOR: "Moderator",
  CHAT_PERMISSION_MEMBER: "Member",
  CHAT_PERMISSION_ASSIGN_AS: "Assign as",
  CHAT_MANAGEMENT_GROUP_MEMBERS: "Group members",
  CHAT_MANAGEMENT_GROUP_CHAT_NAME: "Group name",
  CHAT_MANAGEMENT_CHANNEL_NAME: "Channel name",
  CHAT_MANAGEMENT_NO_MODERATORS_WARNING_HEADING: "This chat has no active owner or admin",
  CHAT_MANAGEMENT_NO_MODERATORS_WARNING:
    "If you need assistance with chat permissions, please <a>contact our support team.</a>",
  CHAT_START_VIDEO_CALL: "Start a video call",
  CHAT_START_CALL_DISABLED_TIER: "The other member doesn't have permission to attend a video call",
  CHAT_START: "Start",
  CHAT_JOIN: "Join",
  CHAT_ONGOING_VIDEO_CALL: "Ongoing video call",
  CHAT_CREATE_VIDEO_CALL: "Start a video call?",
  CHAT_CREATE_VIDEO_CALL_DESCRIPTION: "This will start a video call for your chat channel.",
  CHAT_START_CALL: "Start Call",
  CHAT_START_CHAT: "Start Chat",
  CHAT_ENDED_VIDEO_CALL: "Sorry, this video call has already ended.",
  CHAT_CHANNEL_UNAVAILABLE: "Sorry, this chat is no longer available.",
  CHAT_TEMPLATE_WONDERFUL_TO_MEET_YOU: "Wonderful to meet you!",
  CHAT_TEMPLATE_SPEAKING_PARTNERS: "Would you like to be speaking partners?",
  CHAT_TEMPLATE_CATCH_UP: "Are you free to catch up soon?",
  CHAT_TEMPLATE_ENJOYED_CONVERSATION: "I enjoyed our conversation!",
  CHAT_TEMPLATE_HEY_EVERYONE: "Hey everyone!",
  CHAT_TEMPLATE_WONDERFUL_TO_HAVE_YOU_HERE: "Wonderful to have you all here!",
  CHAT_TEMPLATE_WELCOME_TO_OUR_CHAT: "Welcome to our chat 🎉",
  CHAT_TEMPLATE_WELCOME_TO_MY_CHANNEL: "Hey everyone! Welcome to my channel 🎉",
  CHAT_START_CONVERSATION: "Start your conversation",
  CHAT_START_CONVERSATION_DESCRIPTION:
    "You can either choose a pre-defined message to send or type your own",
  CHAT_EMPTY_ALL_CHATS: "No chats here yet",
  CHAT_EMPTY_ALL_CHATS_DESCRIPTION: "Start by creating your first chat",
  CHAT_CREATE_NEW_CHAT: "Create new chat",
  CHAT_NEW_CHAT: "New Chat",
  CHAT_NEW_GROUP_CHAT: "New Group Chat",
  CHAT_NEW_CHANNEL: "New Channel",
  CHAT_EMPTY_CHANNELS: "You haven’t joined any channels yet",
  CHAT_EMPTY_CHANNELS_DESCRIPTION: "Here are some channels you might like:",
  CHAT_EMPTY_GROUP_CHATS: "No group chats here yet",
  CHAT_EMPTY_GROUP_CHATS_DESCRIPTION: "Start by creating your first group chat",
  CHAT_EMPTY_GROUP_CHATS_BUTTON: "Create group chat",
  CHAT_EMPTY_PERSONAL_CHATS: "No personal chats here yet",
  CHAT_EMPTY_PERSONAL_CHATS_DESCRIPTION: "Start by finding a person you want to chat with",
  CHAT_EMPTY_ARCHIVIED_CHATS: "No archived messages",
  CHAT_EMPTY_ARCHIVIED_CHATS_DESCRIPTION: "You haven’t archived any messages yet",
  CHAT_WELCOME_TO_CHAT: "Welcome to Chat",
  CHAT_WELCOME_TO_GROUP_CHATS: "Welcome to Group Chats",
  CHAT_WELCOME_TO_CHANNELS: "Welcome to Channels",
  CHAT_WELCOME_TO_CHAT_DESCRIPTION: "Start by selecting a chat to view the messages or create new.",
  CHAT_WELCOME_TO_GROUP_CHATS_DESCRIPTION:
    "Start by selecting a group chat to view the messages or create new.",
  CHAT_WELCOME_TO_CHANNELS_DESCRIPTION:
    "Start by selecting a channel to view the messages or create new.",
  CHAT_SEARCH_NO_RESULTS: "No results for “{query}”",
  CHAT_SEARCH_NO_RESULTS_DESCRIPTION:
    "Check your spelling or try different keywords. {br}Make sure you've typed at least 3 letters.",
  CHAT_CREATE_NEW_CHANNEL_OR_CHAT: "Create a New Channel or Chat",
  CHAT_NEW_CHANNEL_SELECT_TYPE: "Select type",
  CHAT_NEW_PERSONAL_CHAT_DESCRIPTION: "Private 1:1 chat between you and one other member.",
  CHAT_NEW_GROUP_CHAT_DESCRIPTION:
    "Private group chat only visible to group members. Others can only find and join if they are invited by a group member. Best for friends, Study Groups or ‘invite only’ Interest Groups.",
  CHAT_NEW_PUBLIC_CHANNEL_DESCRIPTION:
    "Public, searchable and visible to all members. Anyone who finds your channel can join. Use the search to check if a similar channel already exists before creating a new one.",
  CHAT_START_NEW_PERSONAL_CHAT: "Start New Personal Chat",
  CHAT_NEW_PERSONAL_CHAT_SELECT_USER_HINT: "Select a user profile to start a personal chat.",
  CHAT_NEW_CHANNEL_START_TYPING:
    "Start typing at least 3 letters in the field above to see matching user profiles",
  CHAT_CREATE_NEW_GROUP_CHAT: "Create New Group Chat",
  CHAT_CREATE_NEW_CHANNEL: "Create New Channel",
  CHAT_ADD_DETAILS: "Add Details",
  CHAT_GROUP_NAME: "Group Name",
  CHAT_NEW_CHANNEL_NAME_REQUIRED: "Channel Name<sup>*</sup>",
  CHAT_NEW_CHANNEL_DESCRIPTION_REQUIRED: "Description<sup>*</sup>",
  CHAT_START_TYPING: "Start typing...",
  CHAT_NEXT_ADD_MEMBERS: "Next: Add Members",
  CHAT_NEXT_INVITE_TO_JOIN: "Next: Invite to Join",
  CHAT_CREATE_GROUP_CHAT: "Create Group Chat",
  CHAT_CREATE_CHANNEL: "Create Channel",
  CHAT_NEW_CHAT_ADD_MEMBERS: "Add Members",
  CHAT_NEW_CHAT_ADD_MEMBERS_GROUP_HINT: "Add at least 2 members to create group chat",
  CHAT_NEW_CHANNEL_ADD_DETAILS_HINT: "Add Channel Details to continue",
  CHAT_NEW_CHANNEL_EXISTING_CHANNELS: "Existing channels",
  CHAT_NEW_CHANNEL_NAME_HELPER_TEXT: "At least 3 characters",
  CHAT_NEW_CHANNEL_DESCRIPTION_HELPER_TEXT: "At least 10 words",
  CHAT_NEW_CHANNEL_INVITE_TO_JOIN: "Invite to Join (optional)",
  CHAT_VIEW_CHANNEL: "View Channel",
  CHAT_JOIN_CHANNEL: "Join Channel",
  CHAT_JOIN_CHANNEL_SHORT: "Join",
  CHAT_YOU_JOINED_CHANNEL: "You joined the channel",
  CHAT_LEAVE_CHANNEL: "Leave Channel",
  CHAT_DELETE_CHANNEL: "Delete Channel",
  CHAT_EDIT_DETAILS: "Edit Details",
  CHAT_NEW_PUBLIC_CHANNEL_EXISTING_NAME_ERROR: "Channel with this name already exists",
  CHAT_RECENTLY_ACTIVE_PUBLIC_CHANNELS: "Recently active channels",
  CHAT_RECENTLY_ACTIVE_PUBLIC_CHANNELS_MEMBERS_NUMBER: "{count} members",
  CHAT_NO_MESSAGES_YET: "No messages yet",
  CHAT_NO_MESSAGES_YET_DESCRIPTION: "There aren’t any messages posted in this channel yet.",
  CHAT_CHANNEL_OWNER: "Channel Owner",
  CHAT_CHANNEL_MODERATORS: "Moderators",
  CHAT_VIEW_MESSAGES: "View Messages",
  CHAT_PUBLIC_CHANNEL_NAME_MIN_LENGTH_ERROR: "Channel Name must have at least 3 characters",
  CHAT_DESCRIPTION_MIN_LENGTH_ERROR: "Channel Description must have at least 10 words",
  CHAT_JOINED_CHANNELS: "Joined Channels",
  CHAT_VIEW_ALL_CHANNELS: "View All Channels",
  CHAT_VIEW_ALL_CHANNELS_SHORT: "View All",
  CHAT_ALL_CHANNELS: "All Channels",
  CHAT_COMMUNITY_CHANNELS: "Community Channels",
  CHAT_HIDE_COMMUNITY_CHANNELS: "Hide",
  CHAT_SHOW_COMMUNITY_CHANNELS: "Show",
  CHAT_USER_INVITED_TO_JOIN: "{name} has invited you to join",
  CHAT_SEARCH_CHANNEL_MEMBERS: "Search channel members",
  CHAT_SEARCH_GROUP_MEMBERS: "Search group members",
  CHAT_COPY_CHANNEL_LINK: "Copy channel link",
  CHAT_LINK_COPIED: "Link copied",
  CHAT_MEMBERS_ADDED: "New members are added to the chat",
  CHAT_BROWSE_MEMBERS: "Not sure who to invite? Browse <link>Members</link>",
  CHAT_INVITATIONS_SENT: "Invitations sent!",
  CHAT_INVITATIONS_DESCRIPTION:
    "Members you invite will be able to post messages once they accept the invitation.",
  CHAT_ALREADY_INVITED: "Already invited",
  CHAT_INVITE: "Invite",
  CHAT_YOUR_INVITATIONS: "Your invitations",
  CHAT_SHOW_MORE_INVITATIONS: "Show more invitations",
  CHAT_LAST_DECLINED_ON: "Last declined on {date}",
  CHAT_PENDING_INVITATION: "Pending Invitation",
  CHAT_INVITATION_SENT_DATE: "Sent {distance} ago",
  PAYMENT_SUCCESSFUL_WELCOME_ON_BOARD: "Welcome on Board!",
  PAYMENT_SUCCESSFUL_WELCOME: "Welcome!",
  PAYMENT_SUCCESSFUL_HAPPY_THAR_YOU_ARE_HERE:
    "We're happy that you're here! After <url>completing your profile</url> and attending the <url2>New Member Meetup</url2>, you will unlock a lot of community features such as:",
  PAYMENT_SUCCESSFUL_COMPLETING_YOUR_PROFILE: "completing your profile",
  PAYMENT_SUCCESSFUL_NEW_MEMBER_MEETUP: '"New Member Meetup"',
  PAYMENT_SUCCESSFUL_TOPICS_BASED_GROUP_EVENTS: "Topic based group events",
  PAYMENT_SUCCESSFUL_CHATS_WITH_COMMUNITY: "Chats with community",
  PAYMENT_SUCCESSFUL_CONVERSATIONS_ONE_TO_ONE: "Conversations 1 to 1",
  PAYMENT_SUCCESSFUL_LEARNING_MATERIALS: "Learning materials",
  PAYMENT_SUCCESSFUL_CLASSES_WITH_TEACHERS: "Classes with teachers",
  PAYMENT_SUCCESSFUL_AFTER_THE_FIRST_THREE_MONTHS:
    "After the first 3 months your tariff plan will automatically changed to <url>$29/month</url>, and more features will be unlocked for you.",
  PAYMENT_SUCCESSFUL_USD_MONTH: "{usd}/month",
  PAYMENT_SUCCESSFUL_GO_TO_HOME_PAGE: "Go to Home Page",
  PAYMENT_SUCCESSFUL_REQUEST_REFUND:
    "If you don't feel like a part of our community within the first 30 days, you can request a refund.",
  PURCHASE_MEMBERSHIP_PRODUCT_DESCRIPTION: "Product Description",
  PURCHASE_MEMBERSHIP_DESCRIPTION_TITLE: "Hey Lady! Foundations",
  PURCHASE_MEMBERSHIP_DESCRIPTION:
    " Access to Hey Lady! platform plus invitations to join guided conversations hosted by our qualified English teachers. Your member fees will be charged to your card each month. You can update your plan at any time in your Account Settings.",
  PURCHASE_MEMBERSHIP_PRICE: "Price",
  PURCHASE_MEMBERSHIP_TERMS_AND_CONDITIONS: "I agree to all <url>Terms & Conditions</url>",
  PURCHASE_MEMBERSHIP_NOW_A_MEMBER: "You’re officially a member!",
  PURCHASE_MEMBERSHIP_SUCCESSFUL: "Payment successful!",
  PURCHASE_MEMBERSHIP_THANK_YOU: "Thank you for supporting Hey Lady!",
  PURCHASE_MEMBERSHIP_COPY: "A copy of your receipt has been sent to {email}",
  PURCHASE_MEMBERSHIP_YOU_CAN_UPDATE_YOUR_PAYMENT:
    "You can update your payment settings at any time.",
  PAYMENT_DETAILS_PAGE: "Payment details",
  PAYMENT_DETAILS_PAGE_BILLING_AND_PAYMENTS: "Billing and payments",
  PAYMENT_DETAILS_PAGE_YOU_CAN_UPDATE:
    "You can update your card details any time via our secure portal.",
  PAYMENT_DETAILS_PAGE_REMOVE_CARD: "Remove Card",
  PAYMENT_DETAILS_PAGE_ADD_CARD: "Add Card",
  PAYMENT_DETAILS_PAGE_ADD_NEW_CARD:
    "Don't forget to add a new card in order not to lose your membership benefits",
  PAYMENT_DETAILS_PAGE_YOUR_CREDIT_CARD_HAS_BEEN_EXPIRED:
    "Your credit card has been expired. Please try to add another card.",
  PAYMENT_DETAILS_PAGE_UPDATE: "Update",
  PAYMENT_DETAILS_PAGE_CURRENT_MEMBERSHIP_PLAN: "Current membership plan",
  PAYMENT_DETAILS_PAGE_YOU_CAN_SWITCH_YOUR_MEMBERSHIP:
    "You can switch your membership plan in <url>Membership Settings</url>",
  PAYMENT_DETAILS_PAGE_FOUNDATIONS_MONTHLY: "Foundations Monthly",
  PAYMENT_DETAILS_PAGE_FOUNDATIONS_PACKAGE: "Foundations Package",
  PAYMENT_DETAILS_PAGE_RISE_ANNUAL: "Rise Yearly",
  PAYMENT_DETAILS_PAGE_RISE_MONTHLY: "Rise Monthly",
  PAYMENT_DETAILS_PAGE_SOCIAL_PLUS_COACHING: "Premium",
  PAYMENT_DETAILS_PAGE_ANNUAL_PLAN: "Premium - Yearly",
  PAYMENT_DETAILS_PAGE_THREE_MONTHS_PLAN: "3 Month Plan",
  PAYMENT_DETAILS_PAGE_SUPPORTER_PLAN: "Friends Plan",
  PAYMENT_DETAILS_PAGE_THREE_MONTHS_ONLY:
    "Enjoy three(3) months access to everything we offer in the Hey Lady! platform and community.",
  PAYMENT_DETAILS_PAGE_QUARTERLY_PLAN: "Premium - Quarterly",
  PAYMENT_DETAILS_PAGE_MONTHLY_PLAN: "Premium - Monthly",
  PAYMENT_DETAILS_PAGE_FREE_PLAN: "Guest Pass",
  PAYMENT_DETAILS_PAGE_SOCIAL_PLAN: "Basic",
  PAYMENT_DETAILS_PAGE_SUPPORTER: "Friend of Hey Lady!",
  PAYMENT_DETAILS_PAGE_PRICE: "Price",
  PAYMENT_DETAILS_PAGE_NEXT_BILL: "Next bill:",
  PAYMENT_DETAILS_PAGE_DUE_ON: "Due on:",
  PAYMENT_DETAILS_PAGE_ENDS_ON: "Ends on:",
  PAYMENT_DETAILS_PAGE_CANCELS_ON: "Cancels on:",
  PAYMENT_DETAILS_PAGE_PAUSE: "Pause Billing",
  PAYMENT_DETAILS_PAGE_PAUSED: "Paused",
  PAYMENT_DETAILS_CHANGE_PLAN: "Change plan",
  PAYMENT_DETAILS_PAGE_RENEW_PLAN: "Reactivate membership",
  PAYMENT_DETAILS_NEED_TO_MAKE_CHANGES: "Need to make changes",
  PAYMENT_DETAILS_DELETE_MY_ACCOUNT: "Delete account",
  PAYMENT_DETAILS_DELETING_YOUR_ACCOUNT: "Deleting your account is final and cannot be undone.",
  PAYMENT_DETAILS_DELETE_ONCE_YOU_SUBMIT:
    "Once you submit this request to delete your account, you will be logged out and no longer able to access the platform. Your subscription will be cancelled and all personal details associated with your account will be removed, except those legally required for reporting purposes.",
  PAYMENT_DETAILS_PAGE_CANCEL_MEMBERSHIP: "Cancel membership",
  PAYMENT_DETAILS_DELETE_MODAL_TITLE: "Are you sure?",
  PAYMENT_DETAILS_DELETE_MODAL_WARNING: "⚠️ Deleting your account is permanent.",
  PAYMENT_DETAILS_DELETE_MODAL_MEMBERSHIP_ENDS: "Your membership ends immediately.",
  PAYMENT_DETAILS_DELETE_MODAL_LOGGED_OUT: "You will be logged out.",
  PAYMENT_DETAILS_DELETE_MODAL_INFORMATION_DELETED:
    "Your profile, messages, progress and personal information will be permanently deleted.",
  PAYMENT_DETAILS_DELETE_MODAL_CANNOT_BE_UNDONE: "This action cannot be undone.",
  PAYMENT_DETAILS_DELETE_MODAL_REASON: "What is your reason for deleting? (optional)",
  PAYMENT_DETAILS_DELETE_MODAL_REASON_PLACEHOLDER: "Type your answer here...",
  PAYMENT_DETAILS_DELETE_MODAL_KEEP_ACCOUNT: "Keep my account",
  PAYMENT_DETAILS_DELETE_MODAL_CONFIRM: "Delete my account",
  PAYMENT_DETAILS_PAGE_SCHEDULED_PLAN: "Scheduled change to your plan:",
  PAYMENT_DETAILS_PAGE_SCHEDULED_DATE: "Change date:",
  PAYMENT_DETAILS_REACTIVATE: "Reactivate",
  PAYMENT_DETAILS_PAUSE_DESCRIPTION:
    "You can pause your billing for up to 6 weeks. We will keep your history, participation statistics and profile. You can still log in but you will not be able to attend video calls or access lesson content. We will ‘freeze’ your billing until you return.",
  PAYMENT_DETAILS_CANCEL_SUBSCRIPTION_DESCRIPTION:
    "If you cancel, you will still have access until the end of your current billing cycle.",
  PAYMENT_DETAILS_DELETE_MY_ACCOUNT_DESCRIPTION:
    "This will cancel your membership immediately and delete your account including your profile and history. Deleting your account is instant and cannot be undone.",
  PAYMENT_DETAILS_CHANGE_PLAN_DESCRIPTION:
    "You can change plans at any time. Any days remaining on your current plan will be converted to credit and applied to the new plan.",
  PAYMENT_DETAILS_REACTIVATE_DESCRIPTION:
    "If you change your mind about cancelling your membership and decide you would like to continue, clicking the Reactivate Membership button will reverse your decision. Your membership will continue at the end of the current trial or billing period.",
  PAYMENT_DETAILS_PAGE_PAUSE_SCHEDULED_WARNING: "Are you sure?",
  PAYMENT_DETAILS_PAGE_PAUSE_SCHEDULED_WARNING_DESC:
    "Your membership is switching to a different plan on {endDate}.",
  PAYMENT_DETAILS_PAGE_PAUSE_SCHEDULED_WARNING_DESC2:
    "<strong>If you pause now, that change will be cancelled.</strong> {br} {br} Are you sure you want to proceed?",
  PAYMENT_DETAILS_PAGE_PAUSE_SCHEDULED_WARNING_PROCEED: "Yes, Proceed",
  PAYMENT_DETAILS_PAGE_PAUSE_SCHEDULED_WARNING_KEEP: "Don't pause",
  PAYMENT_DETAILS_PAGE_PAUSE_NEED_TO_TAKE_BREAK: "Need to take a break?",
  PAYMENT_DETAILS_PAGE_PAUSE_HOW_LONG_YOU_NEED: "Choose how long you’d like to pause your billing.",
  PAYMENT_DETAILS_PAGE_PAUSE_HOW_LONG_YOU_NEED_SUBTITLE: "Next, we’ll explain how this works.",
  PAYMENT_DETAILS_PAGE_PAUSE_SELECT_DURATION: "Select duration",
  PAYMENT_DETAILS_PAGE_PAUSE_DURATION_WEEKS: "{weeks} weeks",
  PAYMENT_DETAILS_PAGE_PAUSE_NEXT_AVAILABLE: "Next pause available: {date}",
  PAYMENT_DETAILS_PAGE_PAUSE_HOW_IT_WORKS: "How Pause Billing works",
  PAYMENT_DETAILS_PAGE_PAUSE_HOW_IT_WORKS_DESCRIPTION:
    "You can unpause any time. Until you return:<ul><li> ✅   You won’t lose any days you already paid for</li><li> ✅   We will keep your account, profile and history</li><li>  ✅   You can still log in, read messages & notifications</li><li> ❌   You can’t attend events, join calls and study lessons</li></ul>",
  PAYMENT_DETAILS_PAGE_PAUSE_HOW_IT_WORKS_INTRO:
    "You are pausing your billing for {weeks} weeks. It will start again on <bold>{resumeDate}</bold> unless you come back earlier.",
  PAYMENT_DETAILS_PAGE_PAUSE_HOW_IT_WORKS_NEXT_PAYMENT:
    "Your next payment will be on <bold>{date}</bold>.",
  PAYMENT_DETAILS_PAGE_PAUSE_HOW_IT_WORKS_BILLING_NOTE:
    "When you return, you will need to wait 35 days before pausing billing again.",
  PAYMENT_DETAILS_PAGE_PAUSE_START_NOW: "Start pause now",
  PAYMENT_DETAILS_PAGE_PAUSE_UNDERSTAND_CONSENT: "I understand how pausing works",
  PAYMENT_DETAILS_MEMBERSHIP_PAUSED: "You're all set!",
  PAYMENT_DETAILS_YOU_CAN_RETURN:
    "Your subscription will resume automatically on <bold>{date}</bold>. You can return to activate your subscription earlier if you need to.",
  PAYMENT_DETAILS_PAGE_REQUEST_REFUND: "Request Refund",
  PAYMENT_DETAILS_PAGE_IF_YOU_DONT_FEEL_PART_OF_COMMUNITY:
    "*If you don't feel Hey Lady! is right for you within the first 14 days, you can request a refund. {days} days left",
  PAYMENT_DETAILS_PAGE_WANT_TO_CANCEL: "Are you sure you want to cancel your membership?",
  PAYMENT_DETAILS_PAGE_AFTER_CANCELLING:
    "After cancelling your membership, you will still be able to access the platform until the end of your billing cycle.",
  PAYMENT_DETAILS_PAGE_KEEP_MEMBERSHIP: "Keep membership",
  PAYMENT_DETAILS_PAGE_ARE_YOU_SURE:
    "Are you sure you want to request a refund and cancel your membership?",
  PAYMENT_DETAILS_PAGE_LOSE_MEMBERSHIP:
    "Once your membership is cancelled and we issue a refund you will immediately lose access to our platform.",
  PAYMENT_DETAILS_PAGE_PURCHASE_HISTORY: "Purchase history",
  PAYMENT_DETAILS_PAGE_HERE_YOU_CAN_SEE: "Here you can see all your purchases",
  PAYMENT_DETAILS_PAGE_DATE: "Date",
  PAYMENT_DETAILS_PAGE_INVOICE_NO: "Invoice No.",
  PAYMENT_DETAILS_PAGE_CARD: "Card",
  PAYMENT_DETAILS_PAGE_DOWNLOAD: "Download",
  PAYMENT_DETAILS_PAGE_STATUS: "Status",
  PAYMENT_DETAILS_PAGE_NOTE:
    "Note: It will take a few minutes for the changes to be processed in our system. If you have any questions or issues, please contact support at <url>hello@heylady.io</url>.",
  PAYMENT_DETAILS_PAGE_PLAN: "Plan",
  PAYMENT_DETAILS_PAGE_PLAN_IS_DIFFERENT:
    "The price of this plan is now {planAmount} USD. We have decided that we don't want to charge existing users additional costs.",
  REDEEM_PAGE_REDEEM_GIFT: "Claim your Gift Card!",
  REDEEM_PAGE_COMPLETE_DETAILS: "Please complete the details below to claim your gift.",
  REDEEM_PAGE_GIFT_CODE: "Enter code",
  REDEEM_PAGE_EMAIL: "Email (you will use this to log in)",
  REDEEM_PAGE_CREATE_ACCOUNT: "Create my Hey Lady! account",
  REDEEM_PAGE_TERMS_AND_CONDITIONS: "By registering I agree to all <url>Terms & Conditions</url>",
  REDEEM_PAGE_CONFIRM_AGE_AND_GENDER: "I confirm that I am a woman aged 18 years and above",
  REDEEM_PAGE_WELCOME: "Welcome!",
  REDEEM_PAGE_WELCOME_BACK: "Welcome back!",
  REDEEM_PAGE_JOINING_OUR_COMMUNITY: "We're so excited that you're joining our community!",
  REDEEM_PAGE_CONTINUE_YOUR_JOURNEY:
    "We're so excited to see you continue your journey in our community!",
  REDEEM_PAGE_EMAIL_WAS_SENT: "An email has been sent to {email}.",
  REDEEM_PAGE_MEMBERSHIP_UPDATED: "Your membership has now been updated.",
  REDEEM_PAGE_LOG_IN_NOW: "Log in now",
  REDEEM_PAGE_MISSING_CODE: "Wrong gift code!",
  REDEEM_PAGE_ALREADY_REDEEMED: "This code has been already claimed!",
  REDEEM_PAGE_EXISTING_USER: "User already exists!",
  REDEEM_PAGE_BACKEND_FAIL: "Backend failed!",
  MEMBERZINE_WRITE_YOUR_OWN_STORY_TO_SHARE: "Write your own story to share",
  MEMBERZINE_WRITE_ARTICLE: "Write Article",
  MEMBERZINE_FROM_PEOPLE_YOU_FOLLOW: "From people you follow",
  MEMBERZINE_NEW_ARTICLES: "New articles",
  MEMBERZINE_BACK_TO_MAIN_PAGE: "Back to main page",
  MEMBERZINE_YOUR_PUBLISHED_ARTICLES: "Your published articles",
  MEMBERZINE_YOUR_DRAFT_ARTICLES: "Your draft articles",
  MEMBERZINE_ALL_ARTICLES: "All Articles",
  MEMBERZINE_MY_ARTICLES: "My articles",
  MEMBERZINE_MY_DRAFTS: "My drafts",
  MEMBERZINE_CATEGORY_ANY: "Any category",
  MEMBERZINE_CATEGORY_FEATURED: "Featured",
  MEMBERZINE_CATEGORY_POPULAR: "Most popular",
  MEMBERZINE_CATEGORY_RECOMMENDED: "Recommended",
  MEMBERZINE_CATEGORY_TOPICS: "Hey Lady! Topics",
  MEMBERZINE_CATEGORY_INTERESTS: "Interests",
  MEMBERZINE_CATEGORY_JOURNEY: "English Journeys",
  MEMBERZINE_CATEGORY_LIKED: "Liked by me",
  MEMBERZINE_AUTHOR_ANY: "Any author",
  MEMBERZINE_AUTHOR_MEMBERS: "By members",
  MEMBERZINE_AUTHOR_FOLLOW: "By people I follow",
  MEMBERZINE_AUTHOR_HEYLADY: "By Hey Lady! Team",
  MEMBERZINE_LIKE_IT: "Like it!",
  MEMBERZINE_EDIT_ARTICLE: "Edit Article",
  MEMBERZINE_EDIT_DRAFT: "Edit Draft",
  MEMBERZINE_LIKE_THE_ARTICLE: "Like the article? Cheer the author!",
  MEMBERZINE_ARTICLE_DELETED: "Article deleted",
  MEMBERZINE_REPORT_ARTICLE: "Report article",
  MEMBERZINE_CREATE_PAGE_WRITE_YOUR_ARTICLE: "Write Your Article",
  MEMBERZINE_CREATE_PAGE_CHOOSE_THE_COVER_IMAGE: "Choose the cover image",
  MEMBERZINE_CREATE_PAGE_UPLOAD_YOUR_COVER_HERE:
    "Upload your cover here. Please, make sure you upload supported files extensions: *.jpg, *.png",
  MEMBERZINE_CREATE_PAGE_GIVE_YOUR_ARTICLE_A_TITLE: "Give your article a title",
  MEMBERZINE_CREATE_PAGE_KEEP_YOUR_TITLE_SHORT:
    "Keep your title short but descriptive. It could be a question or the key idea you want to explore",
  MEMBERZINE_CREATE_PAGE_SHARE_YOUR_STORY: "Share your story",
  MEMBERZINE_CREATE_PAGE_KEEP_IN_MIND_WE_POST:
    "Please, keep in mind we post articles only with 300 words and above.",
  MEMBERZINE_CREATE_PAGE_SCHEDULE_ARTICLE: "Schedule Article",
  MEMBERZINE_CREATE_PAGE_TITLE_ARTICLE_TITLE: "Article Title",
  MEMBERZINE_CREATE_PAGE_TITLE_CHARACTERS_LEFT: "{chars} left",
  MEMBERZINE_CREATE_PAGE_USE_HIGH_QUALITY_IMAGES:
    "Please use high quality images that represent your article theme",
  MEMBERZINE_CREATE_PAGE_UPLOAD_IMAGE: "Upload Image",
  MEMBERZINE_CREATE_PAGE_ADD_ARTICLE_COVER: "Add Article Cover",
  MEMBERZINE_CREATE_PAGE_MOVE_AND_ZOOM:
    "Move and zoom (+/-) your image in the frame to create the perfect cover!",
  MEMBERZINE_CREATE_PAGE_SAVE_COVER: "Save Cover",
  MEMBERZINE_CREATE_PAGE_PLEASE_UPLOAD: "Please upload one file at a time.",
  MEMBERZINE_CREATE_PAGE_DRAG_AND_DROP: 'Drag and drop or click "Upload" to choose a file.',
  MEMBERZINE_CREATE_PAGE_ACCEPTED_FILES_TYPES: "Accepted file types are: .pdf, .jpg, .doc, .xls",
  MEMBERZINE_CREATE_PAGE_CHOOSE_A_CATEGORY:
    "Choose a category so we can help people to find your article more easily.",
  MEMBERZINE_CREATE_PAGE_WOULD_YOU_LIKE_TO_ATTACH_ANY_FILES_TO_YOUR_ARTICLE:
    "Would you like to attach any files to your article?",
  MEMBERZINE_CREATE_PAGE_PLEASE_SELECT_THREE_SUBJECTS:
    "Please select up to three (3) subjects relevant to your article",
  MEMBERZINE_CREATE_PAGE_PLEASE_SELECT_RELEVANT_THEME: "Please select the relevant theme",
  MEMBERZINE_YES_PLEASE: "Yes, please!",
  MEMBERZINE_NO_THANKS: "No, thanks!",
  MEMBERZINE_CREATE_PAGE_UPLOAD: "Upload",
  MEMBERZINE_CREATE_PAGE_DO_YOU_WANT_TO_SAVE: "Do you want to save your work?",
  MEMBERZINE_CREATE_PAGE_UNSAVED_CHANGES: "Unsaved Changes?",
  MEMBERZINE_CREATE_PAGE_SAVE_YOUR_ARTICLE:
    "Save your article as a draft if you plan to come back to finish it later.",
  MEMBERZINE_CREATE_PAGE_DISCARD_CHANGES:
    "Are you sure you want to discard the changes that you made to this article?",
  MEMBERZINE_CREATE_PAGE_EXIT_AND_DELETE: "Delete and exit",
  MEMBERZINE_CREATE_PAGE_DISCARD: "Discard",
  MEMBERZINE_CREATE_PAGE_SAVE_AS_DRAFT: "Save as draft",
  MEMBERZINE_CREATE_PAGE_WHAT_IS_YOUR_ARTICLE_ABOUT: "What is your article about?",
  MEMBERZINE_CREATE_PAGE_SELECT_UP_TO_5_TAGS:
    "Select up to 5 tags to make your article easier to find.",
  MEMBERZINE_CREATE_PAGE_HEY_LADY_TOPIC: "Hey Lady! Topic",
  MEMBERZINE_CREATE_PAGE_MY_PERSONAL_INTERESTS: "My personal interests",
  MEMBERZINE_CREATE_PAGE_MY_ENGLISH_JOURNEY: "My English journey",
  MEMBERZINE_CREATE_PAGE_SAVED_DRAFT: "Your draft has been saved!",
  MEMBERZINE_CREATE_PAGE_SAVED_ARTICLE: "Your article has been saved!",
  MEMBERZINE_CREATE_PAGE_SAFELY_SAVED:
    "Your hard work is safely saved. You can continue editing or come back later to keep working on it.",
  MEMBERZINE_CREATE_PAGE_EXIT_EDITOR: "Exit the editor",
  MEMBERZINE_CREATE_PAGE_CONTINUE_EDITING: "Continue editing",
  MEMBERZINE_CREATE_PAGE_PUBLISHED_ARTICLE: "Article published!",
  MEMBERZINE_CREATE_PAGE_WELL_DONE:
    "Well done! Your article has been published for the community to enjoy!",
  MEMBERZINE_CREATE_PAGE_MAKE_SURE:
    " Make sure you check back to respond to reader comments. You can also return and edit your article if you need to.",
  MEMBERZINE_SCHEDULE_PAGE_SCHEDULE_YOUR_ARTICLE: "Schedule your article",
  MEMBERZINE_SCHEDULE_PAGE_SPECIFY_TIME_DETAILS: "Specify time details",
  MEMBERZINE_SCHEDULE_PAGE_CHOOSE_TIME_WHEN_YOUR_ARTICLE_CAN_BE_PUBLISHED:
    "Choose time when your article can be published",
  MEMBERZINE_JANUARY: "January edition",
  MEMBERZINE_FEBRUARY: "February edition",
  MEMBERZINE_MARCH: "March edition",
  MEMBERZINE_APRIL: "April edition",
  MEMBERZINE_MAY: "May edition",
  MEMBERZINE_JUNE: "June edition",
  MEMBERZINE_JULY: "July edition",
  MEMBERZINE_AUGUST: "August edition",
  MEMBERZINE_SEPTEMBER: "September edition",
  MEMBERZINE_OCTOBER: "October edition",
  MEMBERZINE_NOVEMBER: "November edition",
  MEMBERZINE_DECEMBER: "December edition",
  MEMBERZINE_CREATE_ADD_HALF_WIDTH_IMAGE: "Add half width image",
  MEMBERZINE_CREATE_ADD_FULL_WIDTH_IMAGE: "Add full width image",
  MEMBERZINE_CREATE_ADD_VIDEO: "Add video",
  MEMBERZINE_CREATE_TEXT_SEPARATOR: "Text separator",
  MEMBERZINE_CREATE_PAGE_PASTE_LINK: "Paste or type a video link",
  HEAVY_LOAD_PAGE_OOPS: "Oh dear! We have heavy traffic and need your help!",
  HEAVY_LOAD_PAGE_WE_RE_WORKING_ON_IT: "Please wait 2 minutes before you try again.",
  HEAVY_LOAD_PAGE_TRY_AGAIN: "Try again",
  RESUBSCRIBE_BACK: "Welcome back, {name}!",
  RESUBSCRIBE_DESCRIPTION: "We saved your account in case you decided to return, including:",
  RESUBSCRIBE_BENEFIT_PROFILE: "Your profile",
  RESUBSCRIBE_BENEFIT_PROGRESS: "Your progress, streak and badges",
  RESUBSCRIBE_BENEFIT_CONNECTIONS: "Your connections",
  RESUBSCRIBE_BENEFIT_CHAT: "Your chat groups and messages",
  RESUBSCRIBE_BENEFIT_ASSESSMENT: "Your Speaking Assessment report",
  RESUBSCRIBE_KEEP_PREFIX: "We’ll keep your account for another",
  RESUBSCRIBE_KEEP_SUFFIX: "days.",
  RESUBSCRIBE_DELETE_NOTICE: "After that, it will be permanently deleted.",
  RESUBSCRIBE_SUBTITLE:
    "Choose a plan now to reactivate your account and pick up where you left off.",
  RESUBSCRIBE_CONFIRM: "Reactivate my account",
  DUNNING_BANNER_TITLE: "Your payment didn't go through",
  DUNNING_BANNER_DESCRIPTION:
    "We couldn't process your last membership payment. Please update your payment method to keep your access.",
  DUNNING_BANNER_CTA: "Update payment method",
  REQUEST_PERMISSION_TITLE: "Can we notify you?",
  REQUEST_PERMISSION_DESCRIPTION:
    "Can we notify you when you have an event to attend or you receive an important message from the team?",
  REQUEST_PERMISSION_HINT: "Click ‘allow’ so you don’t miss these updates",
  REQUEST_PERMISSION_ALLOW: "Allow",
  REQUEST_PERMISSION_GRANTED:
    "Thanks for allowing notifications! You can always manage your notification settings in your browser's preferences.",
  ERROR_HEADING: "Oops! Something went wrong",
  ERROR_DESCRIPTION:
    "We're sorry, but it looks like something unexpected happened. Please try reloading the page by clicking the button below, and if the issue persists, please <contact>contact our support team for assistance</contact>.",
  ERROR_RELOAD: "Reload page",
  ERROR_GO_HOME: "Home page",
  ERROR_PATIENCE: "Thank you for your patience and understanding.",
  ERROR_UPDATE_HEADING: "We're getting better every day!",
  ERROR_UPDATE_DESCRIPTION:
    "The Hey Lady! engineers have made more improvements to our platform. {br}" +
    "Refresh the page to use the latest version.",
  ERROR_UPDATE_REFRESH: "Refresh page",
  ERROR_PAGE_NEED_HELP: "Need help? Contact {mail}",
  ERROR_PAGE_HEADING: "Oh dear! Something is wrong",
  ERROR_PAGE_GO_HOME: "Back to Home Page",
  COMMON_LOGOUT_FAILED: "We couldn't log you out. Please try again.",
  ERROR_PAGE_SEE_PLANS: "See plans",
  NOTIFICATION_COMPLETED_PROFILE: "Your Profile is <o>{percentage}%</o> complete!",
  NOTIFICATION_COMPLETED_PROFILE_DESCRIPTION:
    "Complete your profile to reach 100% and earn yourself the “Perfect" + " Profile” badge today!",
  NOTIFICATION_UPDATE_PROFILE_NOW: "Update Profile Now",
  NOTIFICATION_NEED_TO_COMPLETE_PROFILE: "This is the information you’ll need to complete:",
  NOTIFICATION_IS_THIS_STILL_CORRECT: "{name}, is this still correct?",
  NOTIFICATION_THIS_WILL_HELP_US:
    "This will help us to find the best speaking partners for you who can practice" +
    " English at the same time.",
  NOTIFICATION_IS_THIS_YOUR_AVAILABILITY: "Is this your availability?",
  NOTIFICATION_ARE_YOU_OPEN: "Are you open to new speaking partners?",
  NOTIFICATION_SAVE_DETAILS: "Save Details",
  NOTIFICATION_ACCEPTED_INVITATION: "{name} accepted your invite!",
  NOTIFICATION_JUST_JOINED:
    "Just a quick note to let you know that your friend <b>{name}</b> just started her 7-day Guest Pass with us!",
  NOTIFICATION_MAKE_HER_FEEL_WELCOME: "Let’s make her feel welcome! 🤗",
  NOTIFICATION_SEND_MESSAGE: "Send message",
  NOTIFICATION_WE_HAVE_SENT:
    "We have sent an invitation email to your friend with a special link to join Hey Lady! and enjoy a free 7-day Guest Pass plus US$20 bonus credit!",
  NOTIFICATION_INVITE_ANOTHER_FRIEND: "Invite another friend",
  NOTIFICATION_SIGNED_UP: "{name} just became a member!",
  NOTIFICATION_GREAT_NEWS:
    "Great news! 💖 Your friend has decided to join {logo} as a paying member! That means you get a free month! Please allow 48 hours for our team to update your account.",
  NOTIFICATION_BAF_THANKS_TITLE: "From the bottom of our hearts 🙏🏻",
  NOTIFICATION_BAF_THANKS_BODY:
    "For bringing a friend to our community and helping us grow, we’re giving you $50 credit (to reduce your next membership or program fees).",
  NOTIFICATION_BAF_THANKS_SIGNOFF: "💞 Love, Emma, Shah & the Hey Lady! Team x",
  NOTIFICATION_BAF_THANKS_DELAY_NOTE:
    "Please allow up to 3 days for the credit to reach your Hey Lady! account.",
  NOTIFICATION_BAF_SEE_MY_ACHIEVEMENTS: "See My Achievements",
  NOTIFICATION_FRIEND_DID_NOT_JOIN_TITLE: "Your friend cancelled after her trial",
  NOTIFICATION_FRIEND_DID_NOT_JOIN_BODY:
    "Unfortunately {name} didn’t feel that Hey Lady! was right for her at this time. Her membership was cancelled.",
  VERIFICATION_PAGE_GET_VERIFIED: "Get verified to unlock access to all features",
  VERIFICATION_PAGE_KEEP_COMMUNITY_SAFE:
    "To keep our community safe, <orange>we do not allow anyone to create or" +
    " join video calls or chat with our members until they have been verified</orange> by our team.",
  VERIFICATION_PAGE_GETTING_VERIFIED:
    "Getting verified is easy. Just follow the steps on the next page to record a" +
    " short video. We will check your video and unlock all features within 24 hours.",
  VERIFICATION_PAGE_BACK_TO_HOME: "Back to Home",
  VERIFICATION_VIDEO_REVIEWED_SOON: "Your video will be reviewed soon!",
  VERIFICATION_VIDEO_REVIEWED_SOON_DESCRIPTION:
    "We have received your video. We review and verify all new members within 24 hours. While you’re waiting, would you like to see other events on Hey Lady?",
  RECORD_VIDEO_PAGE_RECORD_VIDEO: "Record a short video",
  RECORD_VIDEO_PAGE_WATCH_EMMA: "1. Watch Emma’s video",
  RECORD_VIDEO_PAGE_ANSWER_3_QUESTIONS: "2. Record your answer to 3 questions",
  RECORD_VIDEO_PAGE_NAME: "a. What is your name?",
  RECORD_VIDEO_PAGE_WHERE_LIVE: "b. Where do you live?",
  RECORD_VIDEO_PAGE_WHY_JOIN: "c. Why did you join {HL}?",
  RECORD_VIDEO_PAGE_SEND: "3. Click “Yes” to send your answers",
  RECORD_VIDEO_PAGE_VERIFICATION:
    "Your video is for verification purposes only. We will never share your" +
    " information, images or videos without your permission.",
  RECORD_VIDEO_PAGE_DONE: "I'm done",
  ONBOARDING_QUIZ_TAKE_THE_QUIZ: "Take the quiz!",
  ONBOARDING_QUIZ_INTRO_TITLE: "How well do you understand the {HL} Way?",
  ONBOARDING_QUIZ_INTRO_DESCRIPTION: "10 simple questions (2 mins)",
  ONBOARDING_QUIZ_HEY_LADY_QUIZ: "{HL} Quiz",
  ONBOARDING_QUIZ_QUESTION_NUM: "Question {current}/{total}",
  ONBOARDING_QUIZ_QUESTION_1: "Which of these best describes {HL} accurately?",
  ONBOARDING_QUIZ_QUESTION_1_OPTION_1: "A new type of language school for women",
  ONBOARDING_QUIZ_QUESTION_1_OPTION_2: "An English speaking community for women",
  ONBOARDING_QUIZ_QUESTION_1_OPTION_3: "A place to practice with native speakers",
  ONBOARDING_QUIZ_QUESTION_1_OPTION_4: "An English course created for women",
  ONBOARDING_QUIZ_QUESTION_1_HINT:
    "{HL} is not a language school or a course, but a safe, supportive space to meet and practise speaking English.",
  ONBOARDING_QUIZ_QUESTION_2: "What are the {HL} community values?",
  ONBOARDING_QUIZ_QUESTION_2_OPTION_1: "Courage, Confidence, Celebration & Happiness",
  ONBOARDING_QUIZ_QUESTION_2_OPTION_2: "Command, Coerce, Commit & Conquer",
  ONBOARDING_QUIZ_QUESTION_2_OPTION_3: "Connection, Collaboration, Contribution, Respect & Joy",
  ONBOARDING_QUIZ_QUESTION_2_OPTION_4: "Peace, Love, Creativity & Harmony",
  ONBOARDING_QUIZ_QUESTION_2_HINT:
    "We meet and work together respectfully to help each other succeed and have fun!",
  ONBOARDING_QUIZ_QUESTION_3: "What is the simple formula to build fluency and confidence?",
  ONBOARDING_QUIZ_QUESTION_3_OPTION_1: "Learn a new word from the English dictionary every day",
  ONBOARDING_QUIZ_QUESTION_3_OPTION_2: "Pay for as many courses about fluency as possible",
  ONBOARDING_QUIZ_QUESTION_3_OPTION_3:
    "Regular practice in real conversations with different people about different topics",
  ONBOARDING_QUIZ_QUESTION_3_OPTION_4: "Watch YouTube videos and speak out loud in every lesson",
  ONBOARDING_QUIZ_QUESTION_3_HINT:
    "Fluency and confidence develop naturally through consistent practice in a variety of situations.",
  ONBOARDING_QUIZ_QUESTION_4: "Why is {HL} only for women?",
  ONBOARDING_QUIZ_QUESTION_4_OPTION_1:
    "Because we can focus on the unique needs and interests of women",
  ONBOARDING_QUIZ_QUESTION_4_OPTION_2:
    "Because it creates a space that is inclusive of all cultures",
  ONBOARDING_QUIZ_QUESTION_4_OPTION_3: "Because the world needs more female voices to be heard",
  ONBOARDING_QUIZ_QUESTION_4_OPTION_4: "All of the above",
  ONBOARDING_QUIZ_QUESTION_4_HINT: "There are many great reasons {HL} is only for women.",
  ONBOARDING_QUIZ_QUESTION_5: "What is an “event” in {HL}?",
  ONBOARDING_QUIZ_QUESTION_5_OPTION_1: "Something that you pay for if you want to attend",
  ONBOARDING_QUIZ_QUESTION_5_OPTION_2: "A conversation or activity happening at a scheduled time",
  ONBOARDING_QUIZ_QUESTION_5_OPTION_3: "A class with a teacher where attendance is mandatory",
  ONBOARDING_QUIZ_QUESTION_5_OPTION_4: "A kind of contest where people compete against each other",
  ONBOARDING_QUIZ_QUESTION_5_HINT:
    "Our events are free and flexible and it’s always up to you if you would like to attend.",
  ONBOARDING_QUIZ_QUESTION_6: "What timezone are events displayed in the platform?",
  ONBOARDING_QUIZ_QUESTION_6_OPTION_1: "UTC (Coordinated Universal Time)",
  ONBOARDING_QUIZ_QUESTION_6_OPTION_2: "AEST (Australian Eastern Standard Time)",
  ONBOARDING_QUIZ_QUESTION_6_OPTION_3: "Your timezone",
  ONBOARDING_QUIZ_QUESTION_6_OPTION_4: "I don’t know, I never really paid attention to time zones",
  ONBOARDING_QUIZ_QUESTION_6_HINT:
    "We make it easy for you to know what time our events are happening.",
  ONBOARDING_QUIZ_QUESTION_7: "What’s the best way to find a great speaking partner?",
  ONBOARDING_QUIZ_QUESTION_7_OPTION_1:
    "Regularly attending different events and talking to different people",
  ONBOARDING_QUIZ_QUESTION_7_OPTION_2:
    "Writing a message to everyone in the chat and asking for one",
  ONBOARDING_QUIZ_QUESTION_7_OPTION_3: "Asking one of the teachers to find one for you",
  ONBOARDING_QUIZ_QUESTION_7_OPTION_4: "Waiting patiently until someone contacts you",
  ONBOARDING_QUIZ_QUESTION_7_HINT:
    "The more people you meet, the sooner you’ll find “your people”!",
  ONBOARDING_QUIZ_QUESTION_8: "Who is able to create an event in the {HL} platform?",
  ONBOARDING_QUIZ_QUESTION_8_OPTION_1: "Only the {HL} Coaches and Community managers",
  ONBOARDING_QUIZ_QUESTION_8_OPTION_2: "Anyone, but they must be verified to unlock this feature",
  ONBOARDING_QUIZ_QUESTION_8_OPTION_3: "Anyone but only if they have perfect English",
  ONBOARDING_QUIZ_QUESTION_8_OPTION_4: "Only people who have completed a college degree",
  ONBOARDING_QUIZ_QUESTION_8_HINT:
    "Any verified member has the same opportunities as everyone else.",
  ONBOARDING_QUIZ_QUESTION_9:
    "How long does it take before members can speak English more fluently and confidently?",
  ONBOARDING_QUIZ_QUESTION_9_OPTION_1: "Usually in just 2-3 hours with minimal effort",
  ONBOARDING_QUIZ_QUESTION_9_OPTION_2: "About 2-3 years, depending on the person",
  ONBOARDING_QUIZ_QUESTION_9_OPTION_3: "Within 2-3 months of regular weekly practice",
  ONBOARDING_QUIZ_QUESTION_9_OPTION_4: "Approximately 2 weeks, sometimes less",
  ONBOARDING_QUIZ_QUESTION_9_HINT:
    "Fluency and confidence don’t happen overnight, but it doesn’t take as long as you think to experience a change!",
  ONBOARDING_QUIZ_QUESTION_10: "What can you expect to become by following the {HL} Way?",
  ONBOARDING_QUIZ_QUESTION_10_OPTION_1: "Outgoing and confident when you talk to people",
  ONBOARDING_QUIZ_QUESTION_10_OPTION_2: "Open-minded, curious and compassionate",
  ONBOARDING_QUIZ_QUESTION_10_OPTION_3: "A competent and capable communicator",
  ONBOARDING_QUIZ_QUESTION_10_OPTION_4: "All of the above",
  ONBOARDING_QUIZ_QUESTION_10_HINT:
    "We produce women who are ready for the real world of English in every way!",
  ONBOARDING_QUIZ_CORRECT: "Correct!",
  ONBOARDING_QUIZ_TRY_AGAIN: "Oops... Try again!!",
  ONBOARDING_QUIZ_ERROR_MESSAGE: "Choose a correct answer to proceed",
  ONBOARDING_QUIZ_GET_HINT: "Not Sure? Get a Hint!",
  ONBOARDING_QUIZ_HINT_SUBTITLE: "Here is your hint!",
  SPEAKING_ASSESSMENT: "Speaking Assessment",
  ASSESSMENT_WATCH_VIDEO: "Watch this video",
  ASSESSMENT_PRETEST_DESCRIPTION:
    "Before you do anything, watch this short video from our Founder, Emma, so you know exactly what to expect in the Assessment,{br} and you can give it your best shot!",
  ASSESSMENT_START_ASSESSMENT: "Start Assessment",
  ASSESSMENT_PAGE_SORRY: "Sorry!",
  ASSESSMENT_PAGE_NO_CREDIT: "You don’t have any remaining credits for a Speaking Assessment.",
  ASSESSMENT_PAGE_CONTACT: "Please contact <link>hello@heylady.io</link>",
  ASSESSMENT_PAGE_COMPLETED: "Assessment Complete!",
  ASSESSMENT_PAGE_COMPLETED_DESC:
    "A copy of your report has been sent to your email address. {br} Didn't receive it?",
  ASSESSMENT_OVERVIEW_GOOD_JOB: "Good Job, {name}!",
  ASSESSMENT_OVERVIEW_YOUR_LEVEL: "Your {HL} Speaking Level is",
  ASSESSMENT_OVERVIEW_USERS_STATS: "More than <bold>{count}</bold> {HL} members share your level",
  ASSESSMENT_DETAILED_SKILLS: "Detailed skills overview",
  ASSESSMENT_SKILLS_DESCRIPTION: "Have a look at your score across the following categories:",
  ASSESSMENT_SKILL_FLUENCY: "Fluency",
  ASSESSMENT_SKILL_GRAMMAR: "Grammar",
  ASSESSMENT_SKILL_COHERENCE: "Coherence",
  ASSESSMENT_SKILL_VOCABULARY: "Vocabulary",
  ASSESSMENT_SKILL_PRONUNCIATION: "Pronunciation",
  ASSESSMENT_WHAT_TO_IMPROVE: "What you can do to improve",
  ASSESSMENT_NOT_FOUND: "Assessment result not found",
  ASSESSMENT_PREVIOUS_SCORE: "Your previous score was {score}",
  ASSESSMENT_MODAL_START_SPEAKING_ASSESSMENT: "Start Speaking Assessment",
  ASSESSMENT_MODAL_START_DESCRIPTION:
    "{name}, you have <bold>{credits} assessment credits</bold> available on your balance. To start the assessment, you need 1 assessment credit.",
  ASSESSMENT_MODAL_PURCHASE_CREDITS: "Purchase Credits",
  ASSESSMENT_MODAL_DO_LATER: "I’ll do it later",
  ASSESSMENT_YOU_ARE_ALL_SET: "You’re all set!",
  ASSESSMENT_CREDITS_PURCHASED:
    "You’ve successfully purchased an assessment credit to start the assessment.",
  ASSESSMENT_RESULTS_BACK_TO_MY_PROFILE: "Back to My profile",
  ASSESSMENT_SCORE_DESCRIPTION_0_DEPENDENT_STUDENT:
    "You may be able to handle simple interactions but it’s still difficult to speak spontaneously or effortlessly. You may use memorised phrases and pause often when speaking. {br} You still rely on teachers to direct your language learning, and that’s OK! Remember, practice makes progress—so keep exposing yourself to English and increasing your vocabulary range. You're not quite ready for {HL} yet - but keep studying and you'll get there! {br} Please note: If you think there has been an error in your score, please contact the {HL} Team",
  ASSESSMENT_SCORE_DESCRIPTION_4_INTERMEDIATE_LOW:
    "You’re starting to break out of the basics — great work! At this level, you can have simple conversations about familiar topics like your daily activities or hobbies. You might struggle with grammar and vocabulary gaps, but you can still get your message across with some effort. Keep studying and speaking with others, and don’t be afraid of making mistakes; they are part of learning!",
  ASSESSMENT_SCORE_DESCRIPTION_5_INTERMEDIATE_MID:
    "You're doing great! At this level, you’re becoming more confident in everyday conversations about familiar topics like your work, interests, or sharing your opinion.  You may still find yourself searching for words or relying on simpler structures, but your ability to express yourself is improving. Keep practising conversations regularly, and start experimenting with new vocabulary and sentence patterns to build your fluency step by step. Your progress is visible, and with continued effort, you'll feel even more at ease.",
  ASSESSMENT_SCORE_DESCRIPTION_5_5_INTERMEDIATE_MID:
    "Well done! You've made notable progress within the Intermediate Mid level. You can maintain longer conversations and share more detailed thoughts on a wider variety of topics. While you may still simplify language or pause to gather your thoughts, your speech is smoother and more engaging. To keep moving forward, try speaking about new and slightly challenging topics. Keep intentionally using new grammar structures in your speech. With each conversation, your confidence will grow, paving the way to the next level.",
  ASSESSMENT_SCORE_DESCRIPTION_6_INTERMEDIATE_HIGH:
    "Fantastic progress! You’re now able to discuss a variety of topics with more confidence and with a greater ability to listen and respond to arguments and ideas in conversation. {br} Occasionally, you might pause or face challenges when talking about less familiar subjects, but your speech generally flows well. Continue to expand your vocabulary range with our Hey Lady! topics, and practise with different speaking partners to strengthen your skills even further. You’re on the path to more fluent conversations—keep it up!",
  ASSESSMENT_SCORE_DESCRIPTION_6_5_INTERMEDIATE_HIGH:
    "Impressive! You're at the upper range of Intermediate High. Your conversations are becoming more fluid, and you can comfortably express your ideas, even if you occasionally pause to think of a word or to gather your thoughts. You’re able to adapt your language better when discussing different topics. To push yourself to the next level, practice speaking in more varied and dynamic situations such as debates, roundtable discussions, or other Deep Dive events. *Challenge yourself to use new vocabulary and expressions. You’re almost ready to step into Advanced territory!",
  ASSESSMENT_SCORE_DESCRIPTION_7_ADVANCED_LOW:
    "You’re becoming an accomplished communicator! At this stage, you can handle most day-to-day conversations and express your thoughts clearly. While you may still need to fine-tune some grammar points or search for the perfect word, you’re able to navigate conversations smoothly. Keep expanding your vocabulary and exploring more complex discussion topics. Read articles with a partner, or start a book club. Your dedication is paying off, and each step brings you closer to mastering your skills.",
  ASSESSMENT_SCORE_DESCRIPTION_7_5_ADVANCED_LOW:
    "You’re doing an amazing job at Advanced Low! Your ability to express opinions and share experiences is becoming more nuanced. Although minor challenges with word choice or more complex grammar may arise, you handle them well. Continue to practise speaking about a wider range of topics and explore discussions with different levels of formality. This will help you refine your abilities and prepare you for Advanced Mid",
  ASSESSMENT_SCORE_DESCRIPTION_8_ADVANCED_MID:
    "You’re truly excelling! At this level,  you’re comfortable conversing about a wider and more challenging variety of topics with accuracy and confidence. You may still find some areas challenging when it comes to highly specialised topics or intricate grammar, but you can maintain the flow of conversation. Keep seeking out opportunities to speak about diverse topics and push yourself with more complex language. Hosting engaging discussions with other advanced speakers is a great way to practise this! You’re showing great skill and promise — keep going!",
  ASSESSMENT_SCORE_DESCRIPTION_8_5_ADVANCED_MID:
    "Excellent work! You’re at the higher end of Advanced Mid, demonstrating strong communication skills. Your speech flows smoothly, and you can discuss different topics with a natural, conversational style. There may be moments when you pause or need to rephrase, but overall, you’re speaking with ease. Continue practising with new discussion themes and embrace more complex sentence structures to perfect your speech. Reading books and watching shows in English is a great way to expose yourself to new accents, phrases, and vocabulary. You’re very close to Advanced High!",
  ASSESSMENT_SCORE_DESCRIPTION_9_ADVANCED_HIGH:
    "You’re nearly at the top! Your ability to manage complex discussions and communicate fluently is impressive. You can share your ideas clearly and adjust your speech to different situations, even when discussing less familiar topics. Small adjustments to vocabulary precision or natural phrasing may still be needed, but your speaking skills are strong. To advance even further, challenge yourself to use more idiomatic and creative language, and practise speaking in more challenging contexts.",
  ASSESSMENT_SCORE_DESCRIPTION_9_5_ADVANCED_HIGH:
    "Outstanding! You’re approaching the pinnacle of Advanced High. You can handle conversations with depth and precision, even about complex or unfamiliar topics. While your fluency and adaptability are remarkable, striving for more natural pacing and mastering subtle cultural references will elevate your proficiency further. Keep engaging in discussions that push your boundaries. Expose yourself to idiomatic and colloquial English through reading a variety of books, articles and texts. Watch films from different English-speaking countries and subscribe to different podcasts to improve your listening! You’ll be ready to reach the Superior level in no time!",
  ASSESSMENT_SCORE_DESCRIPTION_10_PROFICIENT:
    "You’re an impressive speaker! At this level, you can speak with ease and precision, even when discussing abstract or technical topics. Your ability to argue, persuade, and explain complex ideas is strong. You communicate clearly and effectively. Of course, there’s always room for fine-tuning expressions and cultural nuances. Keep immersing yourself in diverse speaking situations to stay sharp and keep growing.",
  MONTH_JANUARY: "January",
  MONTH_FEBRUARY: "February",
  MONTH_MARCH: "March",
  MONTH_APRIL: "April",
  MONTH_MAY: "May",
  MONTH_JUNE: "June",
  MONTH_JULY: "July",
  MONTH_AUGUST: "August",
  MONTH_SEPTEMBER: "September",
  MONTH_OCTOBER: "October",
  MONTH_NOVEMBER: "November",
  MONTH_DECEMBER: "December",
  STREAKS_CURRENT_STREAKS_TITLE: "Your Current Streaks",
  STREAKS_ACTIVE_STREAK: "Active Streak",
  STREAKS_GOAL_STREAK: "Goal Streak",
  STREAKS_WEEKS: "weeks",
  STREAKS_WEEK: "week",
  STREAKS_CONNECTION_WEEK_COMPLETED_THIS_WEEK: "Connection Week Completed This Week",
  STREAKS_PROGRESS_TOAST: "Event Attended",
  STREAKS_PROGRESS_TOAST_EVENT_ATTENDED: "You showed up!",
  STREAKS_PROGRESS_TOAST_ONE_CALL_AWAY: "You're one video call away from your Goal Streak!",
  STREAKS_REMINDER_TOAST: "A new streak starts here!",
  STREAKS_REMINDER_TOAST_EVENTS_LINK: "View Events",
  // UI State Management messages
  STREAKS_ACTIVATE_STREAK_TITLE: "Activate your Streak",
  STREAKS_ACTIVATE_STREAK_MESSAGE: "Join one Video Call this week to start your Active Streak",
  STREAKS_KEEP_STREAK_ALIVE_TITLE: "Keep your Streak Alive",
  STREAKS_KEEP_STREAK_ALIVE_MESSAGE: "Join one Video Call this week to keep your Active Streak",
  STREAKS_SET_WEEKLY_GOAL_TITLE: "Set your Weekly Goal",
  STREAKS_SET_WEEKLY_GOAL_MESSAGE_PREFIX: "Did you know you're ",
  STREAKS_SET_WEEKLY_GOAL_MESSAGE_MULTIPLIER: "2x",
  STREAKS_SET_WEEKLY_GOAL_MESSAGE_SUFFIX:
    " more likely to advance in English if you set a weekly goal!",
  STREAKS_SET_WEEKLY_GOAL_BUTTON: "Set Weekly Goal",
  STREAKS_WEEKLY_GOAL_PROGRESS_TITLE: "Your current Weekly Goal:",
  STREAKS_WEEKLY_GOAL_ATTEND_MORE:
    "Attend <b>{count} more Video Call{plural}</b> to reach your Goal Streak!",
  STREAKS_EDIT_WEEKLY_GOAL_TITLE: "Edit your Weekly Goal",
  STREAKS_EDIT_WEEKLY_GOAL_MOTIVATIONAL_MESSAGE_PREFIX: "Did you know you're ",
  STREAKS_EDIT_WEEKLY_GOAL_MOTIVATIONAL_MESSAGE_MULTIPLIER: "2x",
  STREAKS_EDIT_WEEKLY_GOAL_MOTIVATIONAL_MESSAGE_SUFFIX:
    " more likely to advance in English if you set a weekly goal!",
  STREAKS_EDIT_WEEKLY_GOAL_HOW_MANY_CALLS_QUESTION:
    "How many Video Calls will you attend this week?",
  STREAKS_EDIT_WEEKLY_GOAL_CONFIRM_GOAL_BUTTON: "Confirm",
  STREAKS_EDIT_WEEKLY_GOAL_GOAL_RECOMMENDATION:
    "We recommend starting with 2, then increasing at your own pace.",
  STREAKS_EDIT_WEEKLY_GOAL_EFFECT_NEXT_WEEK:
    "The changes you make to your weekly goal will apply from Monday next week.",
  STREAKS_EDIT_WEEKLY_GOAL_EFFECT_THIS_WEEK: "Your weekly goal will apply from this week.",
  STREAKS_PENDING_WEEKLY_GOAL_CHANGE:
    "Your goal is set to change to {count} {count, plural, one {video call} other {video calls}} per week starting {startDate}.",
  STREAKS_PENDING_WEEKLY_GOAL_OPT_OUT: "You won't have a weekly goal starting {startDate}.",
  STREAKS_EDIT_WEEKLY_GOAL_OPT_OUT_GOAL_BUTTON: "I don't want a weekly goal",
  STREAKS_PENDING_WEEKLY_GOAL_CHANGE_CALLS: "{count, plural, one {video call} other {video calls}}",
  STREAKS_OPT_OUT_MODAL_TITLE: "Not interested in a weekly goal?",
  STREAKS_OPT_OUT_MODAL_MESSAGE_1:
    "Setting a manageable goal (just 1-2 per week) helps you create a healthy habit for steady progress.",
  STREAKS_OPT_OUT_MODAL_MESSAGE_2:
    "But if goal setting's not your thing, you can opt out of weekly streaks.",
  STREAKS_OPT_OUT_MODAL_MESSAGE_3: "You can set a goal again at any time.",
  STREAKS_OPT_OUT_MODAL_CONFIRM_BUTTON: "Yes, opt out",
  STREAKS_START_GOAL_CONFIRMATION_TITLE: "Ready to start your goal?",
  STREAKS_START_GOAL_CONFIRMATION_MESSAGE:
    "Your goal will start today, so you'll need to complete it by Monday. Make sure it feels realistic for the time you have left this week.",
  STREAKS_START_GOAL_CONFIRMATION_CANCEL_BUTTON: "I'll do it later",
  STREAKS_START_GOAL_CONFIRMATION_CONFIRM_BUTTON: "Start goal",
  STREAKS_STREAK_RECHARGE_LABEL: "Streak Re-charge",
  STREAKS_EARN_MORE_STREAKS_MESSAGE: "Stay active for {count} more weeks for full charge.",
  STREAKS_RECHARGE_TOOLTIP_MESSAGE:
    "With a Streak Re-charge, you can maintain your Active Streak even if you miss a week. <url>Learn more</url>",
  STREAKS_RECHARGE_MESSAGE:
    "You missed your {weeks}-Week Active Streak. But don't worry, you've got a Streak Charge! You earned this by showing up consistently!",
  STREAKS_RECHARGE_MESSAGE_GENERIC:
    "You missed your Active Streak. But don't worry, you've got a Streak Charge! You earned this by showing up consistently!",
  STREAKS_RECHARGE_LEARN_MORE: "Learn more about Streak Re-charge",
  STREAKS_RECHARGE_PROTECT_STREAK: "Use it now to keep your streak alive.",
  STREAKS_RECHARGE_USE_BUTTON: "Use Streak Charge",
  STREAKS_RECHARGE_START_OVER_BUTTON: "It's okay, I'll start over",
  STREAKS_RECHARGE_TITLE: "Recharge your Streak",
  STREAKS_RESTART_TITLE: "Restart your streak",
  STREAKS_RESTART_MESSAGE:
    "You missed your {weeks}-Week Streak. We know life gets busy and that's okay.",
  STREAKS_RESTART_MESSAGE_PART2:
    "You can start a new Active Streak by just joining one Video Call this week.",
  STREAKS_RESTART_LEARN_MORE: "Learn more about Streaks at Hey Lady!",
  STREAKS_RESTART_KEEP_GOING_BUTTON: "I'll keep going!",
  STREAKS_CELEBRATION_TITLE: "{weeks}-Week Active Streak",
  STREAKS_CELEBRATION_MESSAGE_1_WEEK: "A streak is born! Great job on being active this week.",
  STREAKS_CELEBRATION_MESSAGE_MULTIPLE_WEEKS:
    "You earned a streak! Great job on being active for {weeks} weeks in a row.",
  STREAKS_CELEBRATION_MESSAGE_KEEP_GOING_TITLE: "Can you make it to a {targetWeeks}-week streak?",
  STREAKS_CELEBRATION_MESSAGE_KEEP_GOING: "Come back next week to keep your streak alive!",
  STREAKS_CELEBRATION_GOAL_REMINDER_1: "Don’t forget about your Goal this week!",
  STREAKS_CELEBRATION_GOAL_REMINDER_2: "Earn a Goal Streak for accomplishing your goal this week.",
  STREAKS_CELEBRATION_GOAL_STREAK_TITLE: "Goal Streak Achieved!",
  STREAKS_CELEBRATION_GOAL_STREAK_MESSAGE:
    "Great job on achieving your goal this week. Practice makes progress!",
  STREAKS_CELEBRATION_GOAL_WEEKLY_GOAL_HEADING: "This week's goal",
  STREAKS_CELEBRATION_GOAL_VIDEO_CALLS: "{current}/{goal} Video Calls",
  STREAKS_CELEBRATION_GOAL_AGAIN_NEXT_WEEK: "Can you do it again next week?",
  STREAKS_CELEBRATION_DOUBLE_STREAK_TITLE: "Double Streak Achieved!",
  STREAKS_CELEBRATION_DOUBLE_STREAK_MESSAGE:
    "Congratulations! You achieved both Active and Goal Streaks by showing up and hitting your goal!",
  STREAKS_EDIT_GOAL_BUTTON: "Edit goal",
  STREAKS_COMMIT_BUTTON: "I'm committed!",
};
